<template>
  <div class="table mx-auto w-full p-5">
  <table class="w-full font-bold relative">
    <thead class="text-xs">
      <tr>
      <th class="w-10">№</th>
      <th class="team-name sm:hello">Название команды</th>
      <th class="city xsm:hidden sm:hidden md:table-cell xl:table-cell lg:table-cell">Город</th>
      <th class="xsm:hidden sm:hidden md:table-cell xl:table-cell lg:table-cell tour">0 тур</th>
      <th class="xsm:hidden sm:hidden md:table-cell xl:table-cell lg:table-cell tour">1 тур</th>
      <th class="xsm:hidden sm:hidden md:table-cell xl:table-cell lg:table-cell tour">2 тур</th>
      <th class="xsm:hidden sm:hidden md:table-cell xl:table-cell lg:table-cell tour">3 тур</th>
      <th class="xsm:hidden sm:hidden md:table-cell xl:table-cell lg:table-cell tour">4 тур</th>
      <th class="xsm:hidden sm:hidden md:table-cell xl:table-cell lg:table-cell tour">5 тур</th>
      <th class="xsm:hidden sm:hidden md:table-cell xl:table-cell lg:table-cell tour">6 тур</th>
      <th class="xsm:hidden sm:hidden md:table-cell xl:table-cell lg:table-cell tour">7 тур</th>
      <th class="w-24 xsm:hidden">Общий балл</th>
       </tr>
    </thead>
   
    <tbody>
      <MozgoTableItem v-for="(team, key) in teams" :key="key" :tabbleItem="team" :tabNumber="key" @showResultModal="initModal($event)"/>
    </tbody>
  </table>
  <ResultModal v-if="showResultModal" :modalData="selectedTeam" @close="toggleResultModal"/>

  </div>
</template>

<script>
import MozgoTableItem from "./MozgoTableItem";
import ResultModal from '../Helpers/ResultModal';

import axios from 'axios';
export default {
  name: "MozgoTable",
  components: {
    MozgoTableItem,
    ResultModal
  },
  data() {
    return {
      teams:[
	
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "7",
            "5": "8",
            "6": "14",
            "7": "12",
            "city": "Барнаул",
            "team_name": "НИИ БИ МОЗГИ",
            "total": "71"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "7",
            "5": "7",
            "6": "14",
            "7": "12",
            "city": "Могилев",
            "team_name": "1Gogh",
            "total": "70"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "7",
            "5": "8",
            "6": "13",
            "7": "12",
            "city": "Воронеж",
            "team_name": "Множественный сарказм",
            "total": "70"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "7",
            "5": "7",
            "6": "14",
            "7": "13",
            "city": "Киров",
            "team_name": "Чаки Норрисы",
            "total": "69"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "7",
            "5": "8",
            "6": "13",
            "7": "12",
            "city": "Могилев",
            "team_name": "Гульфик гугенота",
            "total": "69"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "10",
            "4": "7",
            "5": "7",
            "6": "14",
            "7": "11",
            "city": "Киров",
            "team_name": "Мюсли в голове",
            "total": "69"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "7",
            "5": "6",
            "6": "14",
            "7": "13",
            "city": "Гродно",
            "team_name": "Спасибо, Саша!",
            "total": "68"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "10",
            "4": "7",
            "5": "7",
            "6": "14",
            "7": "10",
            "city": "Барановичи",
            "team_name": "Люди с улицы",
            "total": "67"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "14",
            "7": "10",
            "city": "Гомель",
            "team_name": "Ва-БанкЪ",
            "total": "67"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "8",
            "6": "14",
            "7": "9",
            "city": "Брест",
            "team_name": "Третий гласс",
            "total": "67"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "14",
            "7": "13",
            "city": "Обнинск",
            "team_name": "Лебовски ",
            "total": "66"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "7",
            "6": "13",
            "7": "13",
            "city": "Челябинск",
            "team_name": "Вальсирующий лёд, пламя и гормоны",
            "total": "66"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "7",
            "5": "8",
            "6": "14",
            "7": "12",
            "city": "Севастополь",
            "team_name": "Мы - русские, с нами кот",
            "total": "66"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "7",
            "6": "13",
            "7": "12",
            "city": "Гродно",
            "team_name": "Царь Соломон",
            "total": "66"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "11",
            "city": "Омск",
            "team_name": "Псайдак",
            "total": "66"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "14",
            "7": "10",
            "city": "Екатеринбург",
            "team_name": "Roll Over!",
            "total": "66"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "13",
            "7": "10",
            "city": "Могилев",
            "team_name": "Возможно шулер",
            "total": "66"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "14",
            "7": "12",
            "city": "Ростов на Дону",
            "team_name": "Учёный совет",
            "total": "65"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "7",
            "6": "12",
            "7": "12",
            "city": "Таганрог",
            "team_name": "Что? Где? Почем?",
            "total": "65"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "8",
            "6": "12",
            "7": "11",
            "city": "Минск",
            "team_name": "Запад",
            "total": "65"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "7",
            "5": "6",
            "6": "14",
            "7": "10",
            "city": "Северодвинск",
            "team_name": "Феромоны IQ",
            "total": "65"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "7",
            "5": "7",
            "6": "13",
            "7": "10",
            "city": "Гомель",
            "team_name": "Намочи манту!",
            "total": "65"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "14",
            "7": "9",
            "city": "Киров",
            "team_name": "С2Н5ОН",
            "total": "65"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "7",
            "5": "7",
            "6": "14",
            "7": "8",
            "city": "Киров",
            "team_name": "Объекты ТОиРа",
            "total": "65"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "7",
            "5": "8",
            "6": "14",
            "7": "6",
            "city": "Гомель",
            "team_name": "Против Всех",
            "total": "65"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "7",
            "5": "3",
            "6": "14",
            "7": "13",
            "city": "Ярославль",
            "team_name": "Вомбат И",
            "total": "64"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "7",
            "6": "14",
            "7": "12",
            "city": "Зеленоград",
            "team_name": "Мексиканская автомойка",
            "total": "64"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "14",
            "7": "12",
            "city": "Норильск",
            "team_name": "Волосатый рейс",
            "total": "64"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "5",
            "6": "13",
            "7": "12",
            "city": "Королев",
            "team_name": "Валенки",
            "total": "64"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "10",
            "4": "5",
            "5": "7",
            "6": "12",
            "7": "12",
            "city": "Ковров",
            "team_name": "#askonadreamteam",
            "total": "64"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "14",
            "7": "11",
            "city": "Москва",
            "team_name": "Гадя Петрович",
            "total": "64"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "6",
            "4": "6",
            "5": "7",
            "6": "13",
            "7": "11",
            "city": "Обнинск",
            "team_name": "Дичь ",
            "total": "64"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "8",
            "6": "14",
            "7": "10",
            "city": "Ставрополь",
            "team_name": "Бывает и хуже",
            "total": "64"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "8",
            "6": "14",
            "7": "10",
            "city": "Хельсинки",
            "team_name": "Люблю понедельник ",
            "total": "64"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "7",
            "5": "7",
            "6": "14",
            "7": "10",
            "city": "Тюмень",
            "team_name": "Не все больны футболом",
            "total": "64"
        },
        {
            "0": "6",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "7",
            "6": "14",
            "7": "10",
            "city": "Могилев",
            "team_name": "Герда, икай!",
            "total": "64"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "7",
            "6": "13",
            "7": "10",
            "city": "Гродно",
            "team_name": "Ботсвана",
            "total": "64"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "7",
            "5": "5",
            "6": "13",
            "7": "10",
            "city": "Гомель",
            "team_name": "Наш дом - Содом",
            "total": "64"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "8",
            "6": "12",
            "7": "10",
            "city": "Молодечно",
            "team_name": "Zombie Team",
            "total": "64"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "7",
            "6": "12",
            "7": "10",
            "city": "Гомель",
            "team_name": "О.К.А.",
            "total": "64"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "7",
            "5": "7",
            "6": "10",
            "7": "10",
            "city": "Екатеринбург",
            "team_name": "Кот Довинчен",
            "total": "64"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "8",
            "6": "14",
            "7": "7",
            "city": "Рязань",
            "team_name": "Бейкер - Стрит",
            "total": "64"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "7",
            "5": "8",
            "6": "14",
            "7": "6",
            "city": "Екатеринбург",
            "team_name": "Вот такой пердимонокль",
            "total": "64"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "7",
            "5": "8",
            "6": "13",
            "7": "6",
            "city": "Гомель",
            "team_name": "Да, возможно",
            "total": "64"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "4",
            "6": "13",
            "7": "14",
            "city": "Кемерово",
            "team_name": "42 извилины",
            "total": "63"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "4",
            "6": "13",
            "7": "13",
            "city": "Гродно",
            "team_name": "Неопровержимые улитки",
            "total": "63"
        },
        {
            "0": "6",
            "1": "7",
            "2": "7",
            "3": "10",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "13",
            "city": "Кирово-Чепецк",
            "team_name": "Покроем всех!",
            "total": "63"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "12",
            "city": "Екатеринбург",
            "team_name": "Курт Котейн",
            "total": "63"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "13",
            "7": "12",
            "city": "Редмонд",
            "team_name": "Коктейль Молотова",
            "total": "63"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "7",
            "5": "6",
            "6": "12",
            "7": "12",
            "city": "Петропавловск",
            "team_name": "FriendSKO",
            "total": "63"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "9",
            "4": "3",
            "5": "7",
            "6": "14",
            "7": "11",
            "city": "Екатеринбург",
            "team_name": "Вася хотел пойти feat.#4",
            "total": "63"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "7",
            "6": "14",
            "7": "10",
            "city": "Хельсинки",
            "team_name": "Покажи Квас ",
            "total": "63"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "14",
            "7": "10",
            "city": "Челябинск",
            "team_name": "Автобиз",
            "total": "63"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "6",
            "6": "14",
            "7": "10",
            "city": "Могилев",
            "team_name": "Да будет так",
            "total": "63"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "6",
            "5": "4",
            "6": "14",
            "7": "10",
            "city": "Минск",
            "team_name": "ЖОЕ",
            "total": "63"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "7",
            "6": "13",
            "7": "10",
            "city": "Жуковский",
            "team_name": "БезУмцы",
            "total": "63"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "10",
            "city": "Таллин",
            "team_name": "Слабоумие и отвага",
            "total": "63"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "10",
            "city": "Кирово-Чепецк",
            "team_name": "Разведка боем",
            "total": "63"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "13",
            "7": "10",
            "city": "Слободской",
            "team_name": "Без мигалок",
            "total": "63"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "7",
            "6": "14",
            "7": "9",
            "city": "Екатеринбург",
            "team_name": "Забаненные в гугле",
            "total": "63"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "3",
            "5": "9",
            "6": "14",
            "7": "8",
            "city": "Нижний Новгород",
            "team_name": "Контрагент 007",
            "total": "63"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "8",
            "6": "14",
            "7": "8",
            "city": "Гродно",
            "team_name": "Тюлень-монах",
            "total": "63"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "6",
            "5": "7",
            "6": "14",
            "7": "8",
            "city": "Могилев",
            "team_name": "Юра! Где ключи от танка?!",
            "total": "63"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "14",
            "7": "8",
            "city": "Минск",
            "team_name": "Паток Явi",
            "total": "63"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "8",
            "6": "13",
            "7": "8",
            "city": "Барановичи",
            "team_name": "Сыч Хрустальный",
            "total": "63"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "8",
            "6": "14",
            "7": "6",
            "city": "Челябинск",
            "team_name": "Брейн Аддамс",
            "total": "63"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "5",
            "6": "13",
            "7": "12",
            "city": "Пермь",
            "team_name": "Проблески разума",
            "total": "62"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "6",
            "5": "7",
            "6": "12",
            "7": "12",
            "city": "Кострома",
            "team_name": "Понты Пилата",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "12",
            "city": "Тель Авив",
            "team_name": "Шах и Мат",
            "total": "62"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "10",
            "4": "3",
            "5": "7",
            "6": "11",
            "7": "12",
            "city": "Кирово-Чепецк",
            "team_name": "Адреналин",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "9",
            "4": "5",
            "5": "8",
            "6": "9",
            "7": "12",
            "city": "Чайковский",
            "team_name": "Родственники",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "8",
            "6": "13",
            "7": "11",
            "city": "Бобруйск",
            "team_name": "Angry beavers",
            "total": "62"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "7",
            "6": "11",
            "7": "11",
            "city": "Минск",
            "team_name": "Лё Биг Мак",
            "total": "62"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "6",
            "6": "14",
            "7": "10",
            "city": "Тюмень",
            "team_name": "ForУм",
            "total": "62"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "12",
            "7": "10",
            "city": "Могилев",
            "team_name": "Фриденсрайх Хундертвассер",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "7",
            "6": "12",
            "7": "10",
            "city": "Пинск",
            "team_name": "Fissura Calcarina",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "10",
            "city": "Варшава",
            "team_name": "Заводной мандарин",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "6",
            "4": "4",
            "5": "8",
            "6": "14",
            "7": "9",
            "city": "Санкт-Петербург",
            "team_name": "Perpetuum debile",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "14",
            "7": "9",
            "city": "Минск",
            "team_name": "Сборная Тринидада",
            "total": "62"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "6",
            "6": "14",
            "7": "9",
            "city": "Пермь",
            "team_name": "НЕНУАЧÖ?",
            "total": "62"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "5",
            "6": "14",
            "7": "9",
            "city": "Минск",
            "team_name": "Пьяный филин",
            "total": "62"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "13",
            "7": "9",
            "city": "Кострома",
            "team_name": "Я есть Грут",
            "total": "62"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "7",
            "6": "13",
            "7": "9",
            "city": "Санкт-Петербург",
            "team_name": "Мама знает!",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "7",
            "6": "13",
            "7": "9",
            "city": "Нефтеюганск",
            "team_name": "Отваренные",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "7",
            "6": "12",
            "7": "9",
            "city": "Гомель",
            "team_name": "Сисечки недоверия",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "9",
            "city": "Тюмень",
            "team_name": "Солнечные зайцы",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "11",
            "7": "9",
            "city": "Брест",
            "team_name": "Без понятия",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "7",
            "6": "13",
            "7": "8",
            "city": "Челябинск",
            "team_name": "Deadline",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "7",
            "6": "13",
            "7": "8",
            "city": "Оренбург",
            "team_name": "Полнейший Шмебьюлок",
            "total": "62"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "8",
            "6": "12",
            "7": "8",
            "city": "Лондон",
            "team_name": "Ярость топора",
            "total": "62"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "10",
            "4": "6",
            "5": "8",
            "6": "10",
            "7": "8",
            "city": "Слободской",
            "team_name": "В Яблочко!",
            "total": "62"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "12",
            "7": "14",
            "city": "Белгород",
            "team_name": "Один дома",
            "total": "61"
        },
        {
            "0": "4",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "7",
            "5": "6",
            "6": "12",
            "7": "12",
            "city": "Брест",
            "team_name": "Праходзiлi мiма",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "6",
            "5": "6",
            "6": "12",
            "7": "12",
            "city": "Зеленоград",
            "team_name": "Протяни рукколу помощи",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "2",
            "5": "6",
            "6": "14",
            "7": "11",
            "city": "Минск",
            "team_name": "Молекула компота",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "3",
            "6": "14",
            "7": "11",
            "city": "Симферополь",
            "team_name": "Сексуальный лимонад",
            "total": "61"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "13",
            "7": "11",
            "city": "Минск",
            "team_name": "Глаза дятла",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "7",
            "6": "12",
            "7": "11",
            "city": "Ташкент",
            "team_name": "Абырвалг",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "12",
            "7": "11",
            "city": "Воронеж",
            "team_name": "Банный дух",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "10",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "11",
            "city": "Витебск",
            "team_name": "Ума Турман",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "11",
            "7": "11",
            "city": "Ташкент",
            "team_name": "BeerTeam",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "11",
            "city": "Гомель",
            "team_name": "Жигули",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "11",
            "city": "Иваново",
            "team_name": "Ветер в голове",
            "total": "61"
        },
        {
            "0": "6",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "14",
            "7": "10",
            "city": "Пермь",
            "team_name": "Другая логика",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "14",
            "7": "10",
            "city": "Гомель",
            "team_name": "Понты Пилата",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "14",
            "7": "10",
            "city": "Брест",
            "team_name": "В десятку",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "7",
            "6": "13",
            "7": "10",
            "city": "Тверь",
            "team_name": "Лосось в кустах черники",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "7",
            "5": "5",
            "6": "13",
            "7": "10",
            "city": "Екатеринбург",
            "team_name": "Постсмекалочка",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "3",
            "6": "13",
            "7": "10",
            "city": "Пермь",
            "team_name": "29 баллов за ЕГЭ",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "6",
            "6": "12",
            "7": "10",
            "city": "Иваново",
            "team_name": "МОСФИЛЬМ",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "7",
            "5": "5",
            "6": "12",
            "7": "10",
            "city": "Тюмень",
            "team_name": "Посторонним В",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "7",
            "6": "9",
            "7": "10",
            "city": "Гомель",
            "team_name": "Алё-Алё",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "7",
            "6": "14",
            "7": "9",
            "city": "Екатеринбург",
            "team_name": "4tuna 4ever!",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "2",
            "5": "7",
            "6": "13",
            "7": "9",
            "city": "Минск",
            "team_name": "Сын маминой подруги",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "5",
            "5": "8",
            "6": "12",
            "7": "9",
            "city": "Рязань",
            "team_name": "Двойной форсаж",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "7",
            "5": "6",
            "6": "12",
            "7": "9",
            "city": "Гомель",
            "team_name": "Не отпускает",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "10",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "9",
            "city": "Тюмень",
            "team_name": "Аист с герба Гааги",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "9",
            "city": "Владимир",
            "team_name": "Анонимные собутыльники",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "7",
            "5": "6",
            "6": "11",
            "7": "9",
            "city": "Гомель",
            "team_name": "А на деле Лев Толстой",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "10",
            "4": "5",
            "5": "7",
            "6": "10",
            "7": "9",
            "city": "Зеленоград",
            "team_name": "Скораблянабал",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "7",
            "6": "14",
            "7": "8",
            "city": "Борисов",
            "team_name": "Гарь",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "7",
            "6": "14",
            "7": "8",
            "city": "Пермь",
            "team_name": "Мозги Трески",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "12",
            "7": "8",
            "city": "Пермь",
            "team_name": "Пиво повторите",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "12",
            "7": "8",
            "city": "Ижевск",
            "team_name": "Radio-активные ",
            "total": "61"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "7",
            "4": "7",
            "5": "7",
            "6": "14",
            "7": "7",
            "city": "Лида",
            "team_name": "Гэндальф и хоббиты",
            "total": "61"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "13",
            "7": "7",
            "city": "Екатеринбург",
            "team_name": "Рик и Морти",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "8",
            "6": "14",
            "7": "6",
            "city": "Омск",
            "team_name": "Господин Поташот",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "14",
            "7": "6",
            "city": "Пермь",
            "team_name": "Это край!",
            "total": "61"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "7",
            "5": "8",
            "6": "13",
            "7": "5",
            "city": "Гомель",
            "team_name": "Стоячие сады Придонья",
            "total": "61"
        },
        {
            "0": "7",
            "1": "4",
            "2": "7",
            "3": "8",
            "4": "2",
            "5": "7",
            "6": "12",
            "7": "13",
            "city": "Хельсинки",
            "team_name": "Маракуйя ",
            "total": "60"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "5",
            "6": "14",
            "7": "12",
            "city": "Северодвинск",
            "team_name": "Копыто инженера",
            "total": "60"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "14",
            "7": "12",
            "city": "Гомель",
            "team_name": "Мексиканский залив",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "12",
            "city": "Петрозаводск",
            "team_name": "Пирамида",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "5",
            "6": "14",
            "7": "11",
            "city": "Гродно",
            "team_name": "Пришли пива попить",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "8",
            "6": "13",
            "7": "11",
            "city": "Архангельск",
            "team_name": "На трезвую голову",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "5",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "11",
            "city": "Архангельск",
            "team_name": "Без ОшЫбок",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "12",
            "7": "11",
            "city": "Петропавловск",
            "team_name": "Люди Х",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "11",
            "city": "Тверь",
            "team_name": "Дети Феликса",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "3",
            "6": "14",
            "7": "10",
            "city": "Екатеринбург",
            "team_name": "#ЯЖеГоворила",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "10",
            "city": "Минск",
            "team_name": "The Rebranders",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "12",
            "7": "10",
            "city": "Петропавловск",
            "team_name": "Оу Джи",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "4",
            "6": "12",
            "7": "10",
            "city": "Норильск",
            "team_name": "Лебедь, рак и щука",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "7",
            "6": "11",
            "7": "10",
            "city": "Омск",
            "team_name": "Потупим вместе",
            "total": "60"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "10",
            "city": "Гродно",
            "team_name": "Манго Освобождённый",
            "total": "60"
        },
        {
            "0": "6",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "10",
            "city": "Минск",
            "team_name": "NB",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "10",
            "7": "10",
            "city": "Бишкек",
            "team_name": "Эйяфьядлайёкюдль",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "14",
            "7": "9",
            "city": "Минск",
            "team_name": "Минск2019",
            "total": "60"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "7",
            "6": "13",
            "7": "9",
            "city": "Санкт-Петербург",
            "team_name": "2106",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "3",
            "5": "7",
            "6": "13",
            "7": "9",
            "city": "Екатеринбург",
            "team_name": "По ту сторону капусты",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "5",
            "6": "13",
            "7": "9",
            "city": "Минск",
            "team_name": "Вумныя",
            "total": "60"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "9",
            "city": "Таллин",
            "team_name": "Ка-тет",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "6",
            "6": "12",
            "7": "9",
            "city": "Владимир",
            "team_name": "Бананы-Кокосы",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "8",
            "6": "11",
            "7": "9",
            "city": "Гомель",
            "team_name": "Синдром Рандом",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "7",
            "5": "6",
            "6": "10",
            "7": "9",
            "city": "Минск",
            "team_name": "Птица-шпатель",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "7",
            "6": "14",
            "7": "8",
            "city": "Тверь",
            "team_name": "Азбука плохого вкуса",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "14",
            "7": "8",
            "city": "Кострома",
            "team_name": "Юнайтед",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "5",
            "5": "7",
            "6": "13",
            "7": "8",
            "city": "Красногорск",
            "team_name": "Аы",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "7",
            "6": "13",
            "7": "8",
            "city": "Киров",
            "team_name": "Цельномеховые лапки",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "7",
            "6": "13",
            "7": "8",
            "city": "Северодвинск",
            "team_name": "вжух",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "7",
            "5": "3",
            "6": "13",
            "7": "8",
            "city": "Гродно",
            "team_name": "Мензоберранзанское гетто",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "7",
            "6": "12",
            "7": "8",
            "city": "Ярославль",
            "team_name": "Бла-Бла-Ленд",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "5",
            "6": "14",
            "7": "7",
            "city": "Екатеринбург",
            "team_name": "Hello, my friends!",
            "total": "60"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "8",
            "6": "13",
            "7": "7",
            "city": "Кострома",
            "team_name": "Капитан Кэп",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "7",
            "city": "Санкт-Петербург",
            "team_name": "Кто эти люди? Где мои вещи?",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "8",
            "6": "12",
            "7": "7",
            "city": "Пенза",
            "team_name": "Как Челентаны!",
            "total": "60"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "7",
            "6": "12",
            "7": "7",
            "city": "Пермь",
            "team_name": "*Та*Семья*",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "7",
            "6": "14",
            "7": "6",
            "city": "Тель Авив",
            "team_name": "Полуфабрикаты",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "7",
            "6": "14",
            "7": "6",
            "city": "Брест",
            "team_name": "Папа может",
            "total": "60"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "8",
            "6": "13",
            "7": "6",
            "city": "Витебск",
            "team_name": "Это не мы",
            "total": "60"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "1",
            "5": "6",
            "6": "13",
            "7": "14",
            "city": "Гродно",
            "team_name": "Боже, как приятно",
            "total": "59"
        },
        {
            "0": "6",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "3",
            "6": "10",
            "7": "14",
            "city": "Снежинск",
            "team_name": "Пофэншуй",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "4",
            "4": "5",
            "5": "5",
            "6": "14",
            "7": "12",
            "city": "Северодвинск",
            "team_name": "Служба \"05\"",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "12",
            "7": "12",
            "city": "Пермь",
            "team_name": "Моя Любимая Команда",
            "total": "59"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "5",
            "4": "6",
            "5": "5",
            "6": "12",
            "7": "12",
            "city": "Гомель",
            "team_name": "Бобер Шрёдингера",
            "total": "59"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "5",
            "6": "11",
            "7": "12",
            "city": "Санкт-Петербург",
            "team_name": "Второй закон декантера",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "14",
            "7": "11",
            "city": "Хельсинки",
            "team_name": "Финское лето ",
            "total": "59"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "4",
            "6": "13",
            "7": "11",
            "city": "Киров",
            "team_name": "Пирожок, уходи",
            "total": "59"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "12",
            "7": "11",
            "city": "Ижевск",
            "team_name": "Слегка не замужем ",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "11",
            "city": "Минск",
            "team_name": "Дылетанты",
            "total": "59"
        },
        {
            "0": "6",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "7",
            "5": "6",
            "6": "7",
            "7": "11",
            "city": "Гродно",
            "team_name": "ДежаВю",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "6",
            "5": "5",
            "6": "14",
            "7": "10",
            "city": "Курган",
            "team_name": "Тёмная лошадка",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "6",
            "4": "1",
            "5": "8",
            "6": "13",
            "7": "10",
            "city": "Омск",
            "team_name": "Болимения",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "4",
            "6": "13",
            "7": "10",
            "city": "Симферополь",
            "team_name": "Команда 21",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "7",
            "6": "12",
            "7": "10",
            "city": "Минск",
            "team_name": "Щас сыграем!",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "12",
            "7": "10",
            "city": "Хельсинки",
            "team_name": "Понты Пилата ",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "10",
            "city": "Гродно",
            "team_name": "ГДЕНЬГИ",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "7",
            "6": "11",
            "7": "10",
            "city": "Бишкек",
            "team_name": "Desperados Snow",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "10",
            "city": "Лида",
            "team_name": "Филипп - король Испании",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "10",
            "city": "Гомель",
            "team_name": "Будь киской",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "5",
            "4": "4",
            "5": "6",
            "6": "14",
            "7": "9",
            "city": "Екатеринбург",
            "team_name": "Альфа у кентавра",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "5",
            "6": "14",
            "7": "9",
            "city": "Санкт-Петербург",
            "team_name": "Дуайт Шрут",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "7",
            "6": "12",
            "7": "9",
            "city": "Первоуральск",
            "team_name": "Левостороннее движение",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "6",
            "6": "12",
            "7": "9",
            "city": "Гомель",
            "team_name": "Мальчишник",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "5",
            "6": "12",
            "7": "9",
            "city": "Севастополь",
            "team_name": "Invino Veritas",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "9",
            "city": "Пермь",
            "team_name": "Пуговицы Пушкина",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "5",
            "6": "11",
            "7": "9",
            "city": "Симферополь",
            "team_name": "Педальный конь",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "8",
            "6": "10",
            "7": "9",
            "city": "Тюмень",
            "team_name": "Ну такое...",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "14",
            "7": "8",
            "city": "Ярославль",
            "team_name": "Руки-крюки",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "8",
            "city": "Севастополь",
            "team_name": "Злюки Добры",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "13",
            "7": "8",
            "city": "Петрозаводск",
            "team_name": "Связисты",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "6",
            "6": "13",
            "7": "8",
            "city": "Санкт-Петербург",
            "team_name": "Борщ Мягкобулкин",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "13",
            "7": "8",
            "city": "Пермь",
            "team_name": "Горизонт событий",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "9",
            "4": "4",
            "5": "7",
            "6": "12",
            "7": "8",
            "city": "Минск",
            "team_name": "Сокол тысячелистника",
            "total": "59"
        },
        {
            "0": "6",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "8",
            "city": "Электросталь",
            "team_name": "Мама, я в танке!",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "8",
            "city": "Петрозаводск",
            "team_name": "Олонецкая губерния",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "7",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Кемерово",
            "team_name": "Poker Face",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "7",
            "5": "6",
            "6": "14",
            "7": "7",
            "city": "Гомель",
            "team_name": "Кот да Винчи",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "6",
            "6": "14",
            "7": "7",
            "city": "Архангельск",
            "team_name": "Барсукины дети",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "7",
            "6": "11",
            "7": "7",
            "city": "Гомель",
            "team_name": "Led Zeppelin",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "7",
            "6": "10",
            "7": "7",
            "city": "Витебск",
            "team_name": "Усёроўна",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "5",
            "6": "13",
            "7": "6",
            "city": "Могилев",
            "team_name": "3-4 ЕВС!",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "14",
            "7": "5",
            "city": "Оренбург",
            "team_name": "No name",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "5",
            "city": "Лида",
            "team_name": "Экспресс",
            "total": "59"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "8",
            "6": "12",
            "7": "5",
            "city": "Симферополь",
            "team_name": "Ингеборга Дапкунайте",
            "total": "59"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "4",
            "6": "14",
            "7": "12",
            "city": "Королев",
            "team_name": "Все за!",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "13",
            "7": "12",
            "city": "Могилев",
            "team_name": "ViP",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "12",
            "city": "Гомель",
            "team_name": "Прованс",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "12",
            "city": "Тель Авив",
            "team_name": "Если вы понимаете, о чем я",
            "total": "58"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "12",
            "city": "Санкт-Петербург",
            "team_name": "Бомбический.сом",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "3",
            "6": "11",
            "7": "11",
            "city": "Минск",
            "team_name": "Стоптанные грабли",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "10",
            "4": "3",
            "5": "7",
            "6": "8",
            "7": "11",
            "city": "Петропавловск",
            "team_name": "Buchweizengrütze",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "6",
            "6": "13",
            "7": "10",
            "city": "Нижняя Тура",
            "team_name": "Интеллекта.net",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "13",
            "7": "10",
            "city": "Иваново",
            "team_name": "Лабутены",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "10",
            "city": "Жуковский",
            "team_name": "ИБД+",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "9",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "10",
            "city": "Тверь",
            "team_name": "В джазе только Котики",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "10",
            "city": "Ростов на Дону",
            "team_name": "Чак Норрис",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "10",
            "city": "Иваново",
            "team_name": "Бардак в чердаке",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "10",
            "city": "Минск",
            "team_name": "Выживет только баклажан",
            "total": "58"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "8",
            "6": "10",
            "7": "10",
            "city": "Хельсинки",
            "team_name": "Коты Кадырова ",
            "total": "58"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "7",
            "6": "10",
            "7": "10",
            "city": "Минск",
            "team_name": "Мне нужно посмотреть свой ежедневник",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "7",
            "6": "14",
            "7": "9",
            "city": "Могилев",
            "team_name": "Аперитивная группа",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "14",
            "7": "9",
            "city": "Владимир",
            "team_name": "Вудкрафт",
            "total": "58"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "14",
            "7": "9",
            "city": "Ухта",
            "team_name": "Лёха Панин",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "7",
            "6": "13",
            "7": "9",
            "city": "Владимир",
            "team_name": "Первый Спутниковый",
            "total": "58"
        },
        {
            "0": "5",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "9",
            "city": "Брест",
            "team_name": "Фениксы",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "7",
            "5": "5",
            "6": "12",
            "7": "9",
            "city": "Ухта",
            "team_name": "Я хочу от тебя идей",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "9",
            "city": "Симферополь",
            "team_name": "Зайчатки разума",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "7",
            "6": "10",
            "7": "9",
            "city": "Гомель",
            "team_name": "Кабина от КАМАЗа",
            "total": "58"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "12",
            "7": "8",
            "city": "Архангельск",
            "team_name": "Дырки и болты",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "8",
            "city": "Екатеринбург",
            "team_name": "Так себе умники",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "6",
            "5": "5",
            "6": "12",
            "7": "8",
            "city": "Пермь",
            "team_name": "Сиси Кейджа",
            "total": "58"
        },
        {
            "0": "6",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "8",
            "city": "Ковров",
            "team_name": "Тормозное диско",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "11",
            "7": "8",
            "city": "Снежинск",
            "team_name": "Нажившие вступенку",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "4",
            "6": "11",
            "7": "8",
            "city": "Санкт-Петербург",
            "team_name": "42",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "6",
            "4": "5",
            "5": "7",
            "6": "14",
            "7": "7",
            "city": "Омск",
            "team_name": "Лайкбанда",
            "total": "58"
        },
        {
            "0": "6",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "6",
            "6": "14",
            "7": "7",
            "city": "Омск",
            "team_name": "Не в полном составе",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "14",
            "7": "7",
            "city": "Ростов на Дону",
            "team_name": "Кооператив С.",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "10",
            "7": "7",
            "city": "Москва",
            "team_name": "Вдоль рядов Кукуруку",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "8",
            "6": "14",
            "7": "6",
            "city": "Минск",
            "team_name": "Искусство и интеллект",
            "total": "58"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "7",
            "6": "13",
            "7": "6",
            "city": "Иркутск",
            "team_name": "Уличные акулы",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "9",
            "4": "4",
            "5": "7",
            "6": "13",
            "7": "6",
            "city": "Москва",
            "team_name": "Не то",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "6",
            "city": "Тюмень",
            "team_name": "#манускрипт_всевластия",
            "total": "58"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "12",
            "7": "6",
            "city": "Гомель",
            "team_name": "Сантьяго-де-Куба",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "7",
            "6": "12",
            "7": "6",
            "city": "Пенза",
            "team_name": "Куда, блин? To Dublin!",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "6",
            "5": "6",
            "6": "12",
            "7": "6",
            "city": "Ухта",
            "team_name": "Ной, не плачь",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "11",
            "7": "5",
            "city": "Зеленоград",
            "team_name": "Интеллект Шрёдингера",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "9",
            "4": "5",
            "5": "8",
            "6": "13",
            "7": "4",
            "city": "Гродно",
            "team_name": "Шутка Фейербаха",
            "total": "58"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "7",
            "5": "5",
            "6": "13",
            "7": "4",
            "city": "Гродно",
            "team_name": "United ШНГ",
            "total": "58"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "13",
            "7": "12",
            "city": "Омск",
            "team_name": "Норма - дело наживное",
            "total": "57"
        },
        {
            "0": "5",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "12",
            "city": "Тель Авив",
            "team_name": "Мозголобы",
            "total": "57"
        },
        {
            "0": "6",
            "1": "5",
            "2": "7",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "12",
            "city": "Истра",
            "team_name": "Смайлики",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "5",
            "5": "4",
            "6": "11",
            "7": "12",
            "city": "Кирово-Чепецк",
            "team_name": "Как пройти в библиотеку?",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "1",
            "5": "6",
            "6": "10",
            "7": "12",
            "city": "Гродно",
            "team_name": "Нас тупит ночь",
            "total": "57"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "11",
            "city": "Тель Авив",
            "team_name": "кино вино домино",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "3",
            "6": "11",
            "7": "11",
            "city": "Петропавловск",
            "team_name": "Добрый лев",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "8",
            "4": "1",
            "5": "7",
            "6": "14",
            "7": "10",
            "city": "Тюмень",
            "team_name": "Варагараду",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "3",
            "4": "4",
            "5": "7",
            "6": "13",
            "7": "10",
            "city": "Обнинск",
            "team_name": "Драйв-Клуб ",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "10",
            "city": "Владимир",
            "team_name": "#Буй",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "4",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "10",
            "city": "Северодвинск",
            "team_name": "Хорошие, но не очень",
            "total": "57"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "6",
            "5": "4",
            "6": "12",
            "7": "10",
            "city": "Оренбург",
            "team_name": "Команда имени Че ",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "6",
            "5": "3",
            "6": "12",
            "7": "10",
            "city": "Могилев",
            "team_name": "Хогвартс-Шмогвартс",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "5",
            "5": "8",
            "6": "11",
            "7": "10",
            "city": "Великий Новгород",
            "team_name": "Мел игры",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "7",
            "6": "11",
            "7": "10",
            "city": "Екатеринбург",
            "team_name": "Случайные нейронные связи",
            "total": "57"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "8",
            "4": "7",
            "5": "4",
            "6": "11",
            "7": "10",
            "city": "Санкт-Петербург",
            "team_name": "Кот ушел",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "7",
            "6": "10",
            "7": "10",
            "city": "Югорск",
            "team_name": "Норд реклама",
            "total": "57"
        },
        {
            "0": "5",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "13",
            "7": "9",
            "city": "Минск",
            "team_name": "DEVXED",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "13",
            "7": "9",
            "city": "Пермь",
            "team_name": "3,14 здесь",
            "total": "57"
        },
        {
            "0": "5",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "4",
            "6": "13",
            "7": "9",
            "city": "Екатеринбург",
            "team_name": "#шпильдрузей",
            "total": "57"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "4",
            "6": "13",
            "7": "9",
            "city": "Пермь",
            "team_name": "сборная Шибанова",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "3",
            "5": "7",
            "6": "12",
            "7": "9",
            "city": "Нижний Новгород",
            "team_name": "Инна Друзь",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "9",
            "city": "Кропоткин",
            "team_name": "Дружба народов",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "12",
            "7": "9",
            "city": "Минск",
            "team_name": "Сомнительный сом",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "9",
            "city": "Минск",
            "team_name": "Предел хомяка",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "9",
            "city": "Зеленоград",
            "team_name": "Геолог Георгий",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "9",
            "city": "Нижняя Тура",
            "team_name": "World Of Hod Ezhom®",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "6",
            "5": "3",
            "6": "11",
            "7": "9",
            "city": "Могилев",
            "team_name": "Кактусы",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "3",
            "6": "14",
            "7": "8",
            "city": "Омск",
            "team_name": "Comeback",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "1",
            "5": "7",
            "6": "13",
            "7": "8",
            "city": "Екатеринбург",
            "team_name": "То князи, то в грязи",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "13",
            "7": "8",
            "city": "Омск",
            "team_name": "Dream ITeam",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "8",
            "city": "Чайковский",
            "team_name": "Вечное сияние чистого разума",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "8",
            "city": "Гродно",
            "team_name": "Сарра, неси хороший карандаш",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "8",
            "city": "Ковров",
            "team_name": "Котик в хату",
            "total": "57"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Минск",
            "team_name": "Джессика",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "5",
            "6": "10",
            "7": "8",
            "city": "Владимир",
            "team_name": "Bazinga! Без понятия",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "6",
            "5": "4",
            "6": "10",
            "7": "8",
            "city": "Таллин",
            "team_name": "МысLi",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "7",
            "6": "9",
            "7": "8",
            "city": "Тверь",
            "team_name": "Уроки по флексу",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "14",
            "7": "7",
            "city": "Омск",
            "team_name": "Долго запрягаем",
            "total": "57"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "7",
            "city": "Брест",
            "team_name": "Молоток х",
            "total": "57"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "7",
            "6": "12",
            "7": "7",
            "city": "Пермь",
            "team_name": "7 Слонов",
            "total": "57"
        },
        {
            "0": "6",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "14",
            "7": "6",
            "city": "Пермь",
            "team_name": "Рефлексирующие гедонисты",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "13",
            "7": "6",
            "city": "Севастополь",
            "team_name": "Мыс.Li",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "13",
            "7": "6",
            "city": "Екатеринбург",
            "team_name": "Я|Мы Верхний ярус",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "5",
            "6": "12",
            "7": "6",
            "city": "Владимир",
            "team_name": "Спечула",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "7",
            "6": "11",
            "7": "6",
            "city": "Пермь",
            "team_name": "#настроениеРИО",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "7",
            "6": "12",
            "7": "5",
            "city": "Зеленоград",
            "team_name": "Бес сознания",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "7",
            "5": "6",
            "6": "10",
            "7": "5",
            "city": "Чайковский",
            "team_name": "Отряд Василия",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "7",
            "5": "6",
            "6": "14",
            "7": "4",
            "city": "Курган",
            "team_name": "Профитролли",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "7",
            "6": "10",
            "7": "4",
            "city": "Кострома",
            "team_name": "Майор Пейн - друг Капитана Кэпа",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "6",
            "6": "14",
            "7": "2",
            "city": "Гомель",
            "team_name": "СвидетелиПроКотика",
            "total": "57"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "5",
            "6": "14",
            "7": "2",
            "city": "Алматы",
            "team_name": "Драники",
            "total": "57"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "2",
            "6": "10",
            "7": "12",
            "city": "Минск",
            "team_name": "Декрет №3",
            "total": "56"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "11",
            "7": "11",
            "city": "Бишкек",
            "team_name": "Азазель",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "11",
            "city": "Владимир",
            "team_name": "Без динамики",
            "total": "56"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "6",
            "5": "3",
            "6": "14",
            "7": "10",
            "city": "Гомель",
            "team_name": "Маковый пирог",
            "total": "56"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "3",
            "6": "14",
            "7": "10",
            "city": "Рязань",
            "team_name": "Выпрями извилину",
            "total": "56"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "13",
            "7": "10",
            "city": "Пермь",
            "team_name": "Азбука",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "3",
            "4": "5",
            "5": "7",
            "6": "11",
            "7": "10",
            "city": "Ярославль",
            "team_name": "Soviet Champange",
            "total": "56"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "13",
            "7": "9",
            "city": "Молодечно",
            "team_name": "Dream Team",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "9",
            "city": "Щелково",
            "team_name": "Команда ЩА",
            "total": "56"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "9",
            "city": "Берёзовский",
            "team_name": "50 извилин серого",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "9",
            "city": "Минск",
            "team_name": "Частный случай",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "7",
            "6": "9",
            "7": "9",
            "city": "Брест",
            "team_name": "Мачу Пикчу",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "6",
            "5": "5",
            "6": "14",
            "7": "8",
            "city": "Березники",
            "team_name": "InTeam",
            "total": "56"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "14",
            "7": "8",
            "city": "Щелково",
            "team_name": "Просто Космос",
            "total": "56"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "14",
            "7": "8",
            "city": "Омск",
            "team_name": "Акулий Торнадо",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "8",
            "city": "Нижний Новгород",
            "team_name": "Аннигиляторная пушка",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "4",
            "6": "12",
            "7": "8",
            "city": "Санкт-Петербург",
            "team_name": "Большая слива",
            "total": "56"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "7",
            "6": "11",
            "7": "8",
            "city": "Слободской",
            "team_name": "Секта Красных Утюгов",
            "total": "56"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "7",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "8",
            "city": "Петрозаводск",
            "team_name": "Авантюра",
            "total": "56"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "6",
            "6": "11",
            "7": "8",
            "city": "Хельсинки",
            "team_name": "Я здесь! ",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "8",
            "city": "Молодечно",
            "team_name": "МысLiprut",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Таганрог",
            "team_name": "НИИ Мозги",
            "total": "56"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Архангельск",
            "team_name": "Игзомены",
            "total": "56"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "7",
            "6": "10",
            "7": "8",
            "city": "Тюмень",
            "team_name": "Творожок ВАССЕРМАНА",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "9",
            "7": "8",
            "city": "Жуковский",
            "team_name": "Ногавногу",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "2",
            "5": "6",
            "6": "14",
            "7": "7",
            "city": "Гродно",
            "team_name": "Cheers!",
            "total": "56"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "9",
            "4": "6",
            "5": "4",
            "6": "14",
            "7": "7",
            "city": "Екатеринбург",
            "team_name": "кОргия",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "1",
            "5": "8",
            "6": "13",
            "7": "7",
            "city": "Таллин",
            "team_name": "Жилетка Вассермана",
            "total": "56"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "13",
            "7": "7",
            "city": "Минск",
            "team_name": "Бойцы невидимого мозга",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "4",
            "5": "7",
            "6": "12",
            "7": "7",
            "city": "Воронеж",
            "team_name": "Мой бывший",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "5",
            "5": "5",
            "6": "12",
            "7": "7",
            "city": "Ташкент",
            "team_name": "Тухляки на Волге",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "4",
            "5": "3",
            "6": "14",
            "7": "6",
            "city": "Омск",
            "team_name": "Они знают, что мы знаем",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "6",
            "5": "6",
            "6": "13",
            "7": "6",
            "city": "Санкт-Петербург",
            "team_name": "NullPointerException",
            "total": "56"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "7",
            "6": "12",
            "7": "6",
            "city": "Ижевск",
            "team_name": "Безмандатные ",
            "total": "56"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "4",
            "6": "12",
            "7": "6",
            "city": "Минск",
            "team_name": "Профсоюзные функционеры",
            "total": "56"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "3",
            "6": "12",
            "7": "6",
            "city": "Пермь",
            "team_name": "Потусторонним В",
            "total": "56"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "11",
            "7": "6",
            "city": "Ростов на Дону",
            "team_name": "Limoncello & captain Morgancello",
            "total": "56"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "7",
            "6": "14",
            "7": "5",
            "city": "Ташкент",
            "team_name": "#Дичь",
            "total": "56"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "6",
            "6": "14",
            "7": "5",
            "city": "Ялта",
            "team_name": "Борщ",
            "total": "56"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "4",
            "5": "7",
            "6": "14",
            "7": "4",
            "city": "Владимир",
            "team_name": "Бузотеры",
            "total": "56"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "7",
            "5": "5",
            "6": "12",
            "7": "4",
            "city": "Рязань",
            "team_name": "42",
            "total": "56"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "13",
            "7": "12",
            "city": "Минск",
            "team_name": "Кицман",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "4",
            "4": "5",
            "5": "3",
            "6": "11",
            "7": "12",
            "city": "Иваново",
            "team_name": "Дядя Игорь",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "1",
            "6": "10",
            "7": "12",
            "city": "Чернигов",
            "team_name": "Полёт нормальный",
            "total": "55"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "13",
            "7": "11",
            "city": "Пенза",
            "team_name": "Ассорти",
            "total": "55"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "5",
            "6": "13",
            "7": "10",
            "city": "Курган",
            "team_name": "Skyhawk",
            "total": "55"
        },
        {
            "0": "5",
            "1": "7",
            "2": "6",
            "3": "3",
            "4": "5",
            "5": "7",
            "6": "12",
            "7": "10",
            "city": "Москва",
            "team_name": "Я думал, нас шестеро",
            "total": "55"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "4",
            "5": "7",
            "6": "12",
            "7": "10",
            "city": "Гомель",
            "team_name": "The English team",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "6",
            "6": "12",
            "7": "10",
            "city": "Раменское",
            "team_name": "Drinkers Team",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "6",
            "6": "12",
            "7": "10",
            "city": "Ярославль",
            "team_name": "Липогорцы",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "10",
            "city": "Ярославль",
            "team_name": "Вспышка справа",
            "total": "55"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "11",
            "7": "10",
            "city": "Варшава",
            "team_name": "Краснолюды",
            "total": "55"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "10",
            "city": "Пинск",
            "team_name": "Белые росы",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "8",
            "6": "10",
            "7": "10",
            "city": "Санкт-Петербург",
            "team_name": "The Hateful Seven",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "10",
            "4": "2",
            "5": "5",
            "6": "10",
            "7": "10",
            "city": "Петропавловск",
            "team_name": "Новаяпапка(37,2)",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "2",
            "5": "7",
            "6": "9",
            "7": "10",
            "city": "Екатеринбург",
            "team_name": "Моджо",
            "total": "55"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "4",
            "6": "9",
            "7": "10",
            "city": "Севастополь",
            "team_name": "А нас рать!",
            "total": "55"
        },
        {
            "0": "6",
            "1": "7",
            "2": "4",
            "3": "6",
            "4": "5",
            "5": "5",
            "6": "13",
            "7": "9",
            "city": "Пинск",
            "team_name": "Ля-Бульба",
            "total": "55"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "4",
            "6": "12",
            "7": "9",
            "city": "Молодечно",
            "team_name": "Ordinary people",
            "total": "55"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "3",
            "4": "6",
            "5": "7",
            "6": "11",
            "7": "9",
            "city": "Воронеж",
            "team_name": "Крошки и Сухарики",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "11",
            "7": "9",
            "city": "Архангельск",
            "team_name": "Тридевятое царство!",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "9",
            "city": "Каменск-Уральский",
            "team_name": "Во все тяжкие",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "6",
            "5": "5",
            "6": "10",
            "7": "9",
            "city": "Санкт-Петербург",
            "team_name": "Бррря",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "4",
            "6": "10",
            "7": "9",
            "city": "Екатеринбург",
            "team_name": "Какого рожна?",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "14",
            "7": "8",
            "city": "Санкт-Петербург",
            "team_name": "Резус Фикуса",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "4",
            "6": "13",
            "7": "8",
            "city": "Омск",
            "team_name": "Куриный бульон с косточкой",
            "total": "55"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "8",
            "city": "Гродно",
            "team_name": "Инкогнито",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "12",
            "7": "8",
            "city": "Лида",
            "team_name": "Оптимисты",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "12",
            "7": "8",
            "city": "Гродно",
            "team_name": "Унесённые Егором",
            "total": "55"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "12",
            "7": "8",
            "city": "Раменское",
            "team_name": "All-in",
            "total": "55"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "8",
            "city": "Королев",
            "team_name": "Которая не придумала название",
            "total": "55"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "3",
            "6": "12",
            "7": "8",
            "city": "Орехово-Зуево",
            "team_name": "Метазавры",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "4",
            "6": "11",
            "7": "8",
            "city": "Тула",
            "team_name": "Зима Близко",
            "total": "55"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "8",
            "city": "Гомель",
            "team_name": "Плинтус",
            "total": "55"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "5",
            "5": "7",
            "6": "13",
            "7": "7",
            "city": "Редмонд",
            "team_name": "Скрепка",
            "total": "55"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "4",
            "6": "13",
            "7": "7",
            "city": "Минск",
            "team_name": "savvy?",
            "total": "55"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "3",
            "5": "7",
            "6": "12",
            "7": "7",
            "city": "Ростов на Дону",
            "team_name": "Идеальные незнакомцы",
            "total": "55"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "7",
            "city": "Екатеринбург",
            "team_name": "Советская машина для разрезания яблок на 4 части",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "7",
            "city": "Петрозаводск",
            "team_name": "Мюсли с ух",
            "total": "55"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "7",
            "city": "Раменское",
            "team_name": "Пассажиры",
            "total": "55"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "4",
            "6": "12",
            "7": "7",
            "city": "Березники",
            "team_name": "В смысле?",
            "total": "55"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "4",
            "6": "12",
            "7": "7",
            "city": "Борисов",
            "team_name": "Чужой в иллюминаторе",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "8",
            "6": "11",
            "7": "7",
            "city": "Ростов на Дону",
            "team_name": "Сверхъестественный отбор",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "7",
            "city": "Турку",
            "team_name": "Эндорфин",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "5",
            "6": "11",
            "7": "7",
            "city": "Минск",
            "team_name": "СТЕКЛОПАКЕТЫ. НЕДОРОГО",
            "total": "55"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "7",
            "6": "10",
            "7": "7",
            "city": "Екатеринбург",
            "team_name": "Бывает и хуже",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "6",
            "5": "5",
            "6": "10",
            "7": "7",
            "city": "Щелково",
            "team_name": "Всё. Пока!",
            "total": "55"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "5",
            "6": "9",
            "7": "7",
            "city": "Брест",
            "team_name": "Риона",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "14",
            "7": "6",
            "city": "Рязань",
            "team_name": "Собаки Павлова",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "12",
            "7": "6",
            "city": "Екатеринбург",
            "team_name": "Улыбаемся и пишем",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "7",
            "6": "11",
            "7": "6",
            "city": "Петропавловск",
            "team_name": "iPhuck",
            "total": "55"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "11",
            "7": "6",
            "city": "Екатеринбург",
            "team_name": "Pa pesto falle",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "6",
            "city": "Павловский Посад",
            "team_name": "Killed by Cola",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Пермь",
            "team_name": "При всём увлажнении",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "6",
            "5": "5",
            "6": "10",
            "7": "6",
            "city": "Петрозаводск",
            "team_name": "Барышни и не Толька",
            "total": "55"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "9",
            "7": "6",
            "city": "Гомель",
            "team_name": "Маленький Гаврош",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "5",
            "6": "9",
            "7": "6",
            "city": "Симферополь",
            "team_name": "неИгорьки",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "4",
            "5": "7",
            "6": "14",
            "7": "5",
            "city": "Воронеж",
            "team_name": "Чердаки",
            "total": "55"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "8",
            "6": "11",
            "7": "5",
            "city": "Балашиха",
            "team_name": "Космобублики",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "7",
            "6": "11",
            "7": "5",
            "city": "Киров",
            "team_name": "ЯХЗ",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "6",
            "6": "14",
            "7": "4",
            "city": "Хельсинки",
            "team_name": "Жесткий сыч и шальные камни ",
            "total": "55"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "7",
            "6": "13",
            "7": "4",
            "city": "Тюмень",
            "team_name": "Дежурные по апрелю",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "10",
            "4": "5",
            "5": "4",
            "6": "12",
            "7": "4",
            "city": "Таллин",
            "team_name": "Mixfit",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "6",
            "6": "12",
            "7": "3",
            "city": "Алматы",
            "team_name": "К литру литр",
            "total": "55"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "10",
            "4": "6",
            "5": "5",
            "6": "11",
            "7": "3",
            "city": "Воронеж",
            "team_name": "Кот Веган",
            "total": "55"
        },
        {
            "0": "4",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "3",
            "6": "12",
            "7": "12",
            "city": "Минск",
            "team_name": "Чистая компания",
            "total": "54"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "5",
            "6": "11",
            "7": "12",
            "city": "Тель Авив",
            "team_name": "Розовые Фламинго",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "5",
            "5": "4",
            "6": "11",
            "7": "12",
            "city": "Гомель",
            "team_name": "Импульсивная натура",
            "total": "54"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "9",
            "7": "12",
            "city": "Челябинск",
            "team_name": "Яблоко Ньютона",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "11",
            "city": "Щелково",
            "team_name": "Друзья ДРУЗЯ",
            "total": "54"
        },
        {
            "0": "4",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "3",
            "6": "10",
            "7": "11",
            "city": "Воронеж",
            "team_name": "Масло, вводы, два отвода",
            "total": "54"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "3",
            "5": "6",
            "6": "14",
            "7": "10",
            "city": "Жуковский",
            "team_name": "Весёлые химикаты",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "10",
            "city": "Гомель",
            "team_name": "Анаграмма Хиспа",
            "total": "54"
        },
        {
            "0": "4",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "3",
            "5": "7",
            "6": "11",
            "7": "10",
            "city": "Архангельск",
            "team_name": "Капитан Морган",
            "total": "54"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "10",
            "city": "Редмонд",
            "team_name": "Ещё одна команда",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "7",
            "7": "10",
            "city": "Гомель",
            "team_name": "Куда приткнуться?",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "9",
            "city": "Барановичи",
            "team_name": "Бернадетки and Co",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "4",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "9",
            "city": "Чернигов",
            "team_name": "Монтажнаязона",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "3",
            "6": "11",
            "7": "9",
            "city": "Кирово-Чепецк",
            "team_name": "Капитанская почка",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "9",
            "city": "Королев",
            "team_name": "Воображаемые Друзя",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "3",
            "5": "6",
            "6": "14",
            "7": "8",
            "city": "Екатеринбург",
            "team_name": "Выпуклые предпочтения",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "13",
            "7": "8",
            "city": "Нефтеюганск",
            "team_name": "BIG 10",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "13",
            "7": "8",
            "city": "Киров",
            "team_name": "Если не мы, то Кот!",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "12",
            "7": "8",
            "city": "Омск",
            "team_name": "Непрямая извилина",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "3",
            "3": "6",
            "4": "6",
            "5": "5",
            "6": "12",
            "7": "8",
            "city": "Екатеринбург",
            "team_name": "Чувства верующих",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "5",
            "5": "5",
            "6": "12",
            "7": "8",
            "city": "Снежинск",
            "team_name": "Итаксойдёт",
            "total": "54"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "8",
            "city": "Челябинск",
            "team_name": "Пик Балмера",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "8",
            "city": "Москва",
            "team_name": "Команда с подвыподвертом",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "3",
            "6": "12",
            "7": "8",
            "city": "Тель Авив",
            "team_name": "42",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "1",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Хельсинки",
            "team_name": "РУИНА ",
            "total": "54"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "4",
            "6": "11",
            "7": "8",
            "city": "Чернигов",
            "team_name": "Невгамовні",
            "total": "54"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "3",
            "6": "11",
            "7": "8",
            "city": "Хельсинки",
            "team_name": "Stadin Hummerit ",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "10",
            "7": "8",
            "city": "Борисов",
            "team_name": "Аматары амарэта",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "5",
            "5": "4",
            "6": "10",
            "7": "8",
            "city": "Иркутск",
            "team_name": "Конь огонь тыг-дык тыг-дык",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "7",
            "6": "8",
            "7": "8",
            "city": "Слободской",
            "team_name": "Дзен Уиллис",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "7",
            "6": "13",
            "7": "7",
            "city": "Королев",
            "team_name": "Быки и двое",
            "total": "54"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "13",
            "7": "7",
            "city": "Великий Новгород",
            "team_name": "Ну я же говорил",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "13",
            "7": "7",
            "city": "Минск",
            "team_name": "Без царя в голове",
            "total": "54"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "2",
            "6": "13",
            "7": "7",
            "city": "Ухта",
            "team_name": "Зачеркни правильный ответ",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "7",
            "5": "5",
            "6": "10",
            "7": "7",
            "city": "Гомель",
            "team_name": "НИИЧАВО",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "4",
            "6": "13",
            "7": "6",
            "city": "Санкт-Петербург",
            "team_name": "В смысле",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "4",
            "6": "13",
            "7": "6",
            "city": "Петрозаводск",
            "team_name": "Винтерфелл",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "4",
            "6": "13",
            "7": "6",
            "city": "Архангельск",
            "team_name": "Далеко до пенсии",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "13",
            "7": "6",
            "city": "Тюмень",
            "team_name": "Однажды в…",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "5",
            "4": "4",
            "5": "6",
            "6": "12",
            "7": "6",
            "city": "Курган",
            "team_name": "Рэй Брэдбери",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "3",
            "5": "6",
            "6": "12",
            "7": "6",
            "city": "Ставрополь",
            "team_name": "Спрут с пруд",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "5",
            "4": "6",
            "5": "4",
            "6": "12",
            "7": "6",
            "city": "Молодечно",
            "team_name": "Black Дуб",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "3",
            "6": "12",
            "7": "6",
            "city": "Омск",
            "team_name": "Бета-самцы",
            "total": "54"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "11",
            "7": "6",
            "city": "Ялта",
            "team_name": "Ялтинский филиал ПТУ им. Бузовой",
            "total": "54"
        },
        {
            "0": "6",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "14",
            "7": "5",
            "city": "Пенза",
            "team_name": "СМА ПО",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "13",
            "7": "5",
            "city": "Челябинск",
            "team_name": "1-е место",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "5",
            "city": "Киров",
            "team_name": "Мужицкий дождь",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "12",
            "7": "5",
            "city": "Краснотурьинск",
            "team_name": "TURBO 4x4",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "5",
            "6": "12",
            "7": "5",
            "city": "Гомель",
            "team_name": "Дедушкин стеклянный глаз",
            "total": "54"
        },
        {
            "0": "6",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "4",
            "6": "12",
            "7": "5",
            "city": "Минск",
            "team_name": "Некло",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "5",
            "city": "Пермь",
            "team_name": "Офис Ленина",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "10",
            "7": "5",
            "city": "Челябинск",
            "team_name": "Надо подумать",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "1",
            "5": "8",
            "6": "14",
            "7": "4",
            "city": "Минск",
            "team_name": "gipnogaba",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "6",
            "5": "5",
            "6": "14",
            "7": "4",
            "city": "Таганрог",
            "team_name": "Family guys",
            "total": "54"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "12",
            "7": "4",
            "city": "Воронеж",
            "team_name": "Любители Халявы",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "10",
            "4": "5",
            "5": "3",
            "6": "12",
            "7": "4",
            "city": "Пермь",
            "team_name": "Дайте наводку",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "3",
            "city": "Краснотурьинск",
            "team_name": "Ну мааам",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "5",
            "6": "11",
            "7": "3",
            "city": "Бобруйск",
            "team_name": "Подводный ин100грамм",
            "total": "54"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "5",
            "6": "12",
            "7": "2",
            "city": "Березники",
            "team_name": "Рассольник",
            "total": "54"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "2",
            "city": "Челябинск",
            "team_name": "Трудно быть блогом",
            "total": "54"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "4",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "12",
            "city": "Каменск-Уральский",
            "team_name": "ИТ-С My life",
            "total": "53"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "13",
            "7": "10",
            "city": "Зеленоград",
            "team_name": "Веселый кактус",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "4",
            "5": "4",
            "6": "13",
            "7": "10",
            "city": "Каменск-Уральский",
            "team_name": "Картель",
            "total": "53"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "12",
            "7": "10",
            "city": "Бишкек",
            "team_name": "Мушкетёры",
            "total": "53"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "6",
            "5": "5",
            "6": "11",
            "7": "10",
            "city": "Санкт-Петербург",
            "team_name": "Что делать, и кто виноват?",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "11",
            "7": "10",
            "city": "Петрозаводск",
            "team_name": "Филипп Бедросович",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "11",
            "7": "10",
            "city": "Кострома",
            "team_name": "Сковородка",
            "total": "53"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "6",
            "6": "10",
            "7": "10",
            "city": "Могилев",
            "team_name": "Весёлый Брут",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "10",
            "city": "Раменское",
            "team_name": "Лебедь, рак и щука",
            "total": "53"
        },
        {
            "0": "5",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "10",
            "city": "Петропавловск",
            "team_name": "In Team",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "5",
            "5": "4",
            "6": "10",
            "7": "10",
            "city": "Кирово-Чепецк",
            "team_name": "Ну, допустим",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "4",
            "6": "10",
            "7": "10",
            "city": "Норильск",
            "team_name": "Команда Р",
            "total": "53"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "3",
            "4": "7",
            "5": "3",
            "6": "10",
            "7": "10",
            "city": "Ижевск",
            "team_name": "ВеселаяДинамика ",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "5",
            "5": "5",
            "6": "9",
            "7": "10",
            "city": "Могилев",
            "team_name": "404 not found",
            "total": "53"
        },
        {
            "0": "6",
            "1": "4",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "14",
            "7": "9",
            "city": "Бобруйск",
            "team_name": "Baker Street",
            "total": "53"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "9",
            "city": "Молодечно",
            "team_name": "Весёлая комПашка",
            "total": "53"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "12",
            "7": "9",
            "city": "Иваново",
            "team_name": "Облепиховый чай",
            "total": "53"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "3",
            "4": "6",
            "5": "5",
            "6": "10",
            "7": "9",
            "city": "Глазов",
            "team_name": "Я же говорил",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "9",
            "city": "Курган",
            "team_name": "БубльГум",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "7",
            "6": "9",
            "7": "9",
            "city": "Лида",
            "team_name": "Тунеядцы",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "2",
            "5": "6",
            "6": "9",
            "7": "9",
            "city": "Гомель",
            "team_name": "Просто попутчица",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "14",
            "7": "8",
            "city": "Симферополь",
            "team_name": "Завтра победим",
            "total": "53"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "5",
            "5": "6",
            "6": "13",
            "7": "8",
            "city": "Таганрог",
            "team_name": "Ой, всё",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "6",
            "5": "4",
            "6": "13",
            "7": "8",
            "city": "Северодвинск",
            "team_name": "Разные люди",
            "total": "53"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "4",
            "6": "12",
            "7": "8",
            "city": "Тель Авив",
            "team_name": "Чеширский Кот",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "4",
            "6": "12",
            "7": "8",
            "city": "Молодечно",
            "team_name": "Соноселикафобы",
            "total": "53"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "8",
            "city": "Могилев",
            "team_name": "Вокруг Светы за 80 дней",
            "total": "53"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Королев",
            "team_name": "1+1",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Санкт-Петербург",
            "team_name": "Ветры Расторгуева",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Краснотурьинск",
            "team_name": "Дахусим",
            "total": "53"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "6",
            "4": "6",
            "5": "5",
            "6": "10",
            "7": "8",
            "city": "Севастополь",
            "team_name": "Миллениум",
            "total": "53"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "8",
            "city": "Кирово-Чепецк",
            "team_name": "Ой, всё!",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "8",
            "city": "Киров",
            "team_name": "#НЭНТ",
            "total": "53"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "9",
            "4": "5",
            "5": "4",
            "6": "10",
            "7": "8",
            "city": "Снежинск",
            "team_name": "#побарабану",
            "total": "53"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "3",
            "5": "3",
            "6": "10",
            "7": "8",
            "city": "Иваново",
            "team_name": "Пилатус",
            "total": "53"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "6",
            "4": "6",
            "5": "5",
            "6": "9",
            "7": "8",
            "city": "Владимир",
            "team_name": "Была бы Лена",
            "total": "53"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "2",
            "5": "5",
            "6": "9",
            "7": "8",
            "city": "Гродно",
            "team_name": "Лига справедливости",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "8",
            "city": "Севастополь",
            "team_name": "Жак-Из-Кустов",
            "total": "53"
        },
        {
            "0": "5",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "7",
            "5": "7",
            "6": "8",
            "7": "8",
            "city": "Воронеж",
            "team_name": "Цевет",
            "total": "53"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "3",
            "5": "7",
            "6": "7",
            "7": "8",
            "city": "Рязань",
            "team_name": "Заработаем - сделаем",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "14",
            "7": "7",
            "city": "Гомель",
            "team_name": "sostankoff",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "8",
            "4": "6",
            "5": "4",
            "6": "11",
            "7": "7",
            "city": "Архангельск",
            "team_name": "afrolatin dance",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "7",
            "city": "Гомель",
            "team_name": "Да как так-то, а?!",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "6",
            "5": "5",
            "6": "10",
            "7": "7",
            "city": "Пинск",
            "team_name": "Моргенмуффели",
            "total": "53"
        },
        {
            "0": "6",
            "1": "7",
            "2": "7",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "14",
            "7": "6",
            "city": "Кострома",
            "team_name": "СБ",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "3",
            "4": "5",
            "5": "6",
            "6": "13",
            "7": "6",
            "city": "Раменское",
            "team_name": "Без ГМО",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "13",
            "7": "6",
            "city": "Омск",
            "team_name": "Короеды",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "6",
            "5": "3",
            "6": "13",
            "7": "6",
            "city": "Северодвинск",
            "team_name": "Бабушка Кори Тейлора",
            "total": "53"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "6",
            "5": "6",
            "6": "12",
            "7": "6",
            "city": "Снежинск",
            "team_name": "АК-74",
            "total": "53"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "6",
            "6": "12",
            "7": "6",
            "city": "Ярославль",
            "team_name": "Турагентство \"GSM-Тур\"",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "6",
            "6": "11",
            "7": "6",
            "city": "Хельсинки",
            "team_name": "ОргиИ_результат",
            "total": "53"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Кирово-Чепецк",
            "team_name": "Динамит FM",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "6",
            "city": "Архангельск",
            "team_name": "Брызги шампанского",
            "total": "53"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "6",
            "city": "Тюмень",
            "team_name": "Куюмба",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "6",
            "city": "Киров",
            "team_name": "#бицабороца",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "6",
            "5": "5",
            "6": "9",
            "7": "6",
            "city": "Воронеж",
            "team_name": "Б.Э.М.С.",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "2",
            "6": "13",
            "7": "5",
            "city": "Алматы",
            "team_name": "Дилетанты",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "5",
            "city": "Барановичи",
            "team_name": "Z72.6",
            "total": "53"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "7",
            "6": "11",
            "7": "5",
            "city": "Истра",
            "team_name": "Рога и Копыта",
            "total": "53"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "10",
            "7": "5",
            "city": "Екатеринбург",
            "team_name": "Red Hot Mary Poppins",
            "total": "53"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "4",
            "6": "10",
            "7": "5",
            "city": "Челябинск",
            "team_name": "Солянка",
            "total": "53"
        },
        {
            "0": "6",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "5",
            "5": "6",
            "6": "11",
            "7": "4",
            "city": "Гродно",
            "team_name": "Зов Импульса",
            "total": "53"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "7",
            "6": "11",
            "7": "3",
            "city": "Владимир",
            "team_name": "Шевелюра Шевелёва",
            "total": "53"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "3",
            "6": "12",
            "7": "11",
            "city": "Могилев",
            "team_name": "Три орешка для принца",
            "total": "52"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "5",
            "4": "4",
            "5": "2",
            "6": "12",
            "7": "11",
            "city": "Красногорск",
            "team_name": "ДрыгНога",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "6",
            "7": "11",
            "city": "Ижевск",
            "team_name": "Елюди ",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "4",
            "7": "11",
            "city": "Киев",
            "team_name": "100 в летнюю ночь",
            "total": "52"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "3",
            "4": "6",
            "5": "5",
            "6": "13",
            "7": "10",
            "city": "Минск",
            "team_name": "Лёгкие на подъем",
            "total": "52"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "10",
            "city": "Брест",
            "team_name": "Иррудиты",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "3",
            "6": "12",
            "7": "10",
            "city": "Нижняя Тура",
            "team_name": "Все свои",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "11",
            "7": "10",
            "city": "Зеленоград",
            "team_name": "ГЛЮКИ",
            "total": "52"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "2",
            "5": "5",
            "6": "11",
            "7": "10",
            "city": "Гродно",
            "team_name": "Колбаса докторская с ГМО",
            "total": "52"
        },
        {
            "0": "6",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "5",
            "6": "11",
            "7": "10",
            "city": "Омск",
            "team_name": "Кеды не чешутся",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "3",
            "6": "11",
            "7": "10",
            "city": "Екатеринбург",
            "team_name": "_CтаРпон",
            "total": "52"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "9",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "10",
            "city": "Жуковский",
            "team_name": "Большая Красная Акула",
            "total": "52"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "4",
            "4": "6",
            "5": "6",
            "6": "7",
            "7": "10",
            "city": "Пятигорск",
            "team_name": "Тапочки Эйнштейна",
            "total": "52"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "7",
            "7": "10",
            "city": "Барановичи",
            "team_name": "Кг/Ам",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "13",
            "7": "9",
            "city": "Раменское",
            "team_name": "Додо",
            "total": "52"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "4",
            "5": "7",
            "6": "11",
            "7": "9",
            "city": "Великий Новгород",
            "team_name": "Ещё не придумали",
            "total": "52"
        },
        {
            "0": "4",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "7",
            "6": "10",
            "7": "9",
            "city": "Королев",
            "team_name": "IQGrey",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "9",
            "city": "Королев",
            "team_name": "Десперадос",
            "total": "52"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "7",
            "7": "9",
            "city": "Глазов",
            "team_name": "Мозги в тиски",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "4",
            "6": "14",
            "7": "8",
            "city": "Тула",
            "team_name": "Дружочки Движочков",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "13",
            "7": "8",
            "city": "Гомель",
            "team_name": "Камуфляжный олень",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "13",
            "7": "8",
            "city": "Симферополь",
            "team_name": "Клюква",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "4",
            "5": "6",
            "6": "12",
            "7": "8",
            "city": "Архангельск",
            "team_name": "Дайте мне мартини",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "8",
            "city": "Петрозаводск",
            "team_name": "Коммунальная квартира",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "1",
            "5": "5",
            "6": "12",
            "7": "8",
            "city": "Минск",
            "team_name": "Тюлитка и Улень",
            "total": "52"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "5",
            "4": "3",
            "5": "3",
            "6": "12",
            "7": "8",
            "city": "Королев",
            "team_name": "Карманы Вассермана",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "8",
            "city": "Зеленоград",
            "team_name": "Шевелящие опилками",
            "total": "52"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Барановичи",
            "team_name": "Орион",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "4",
            "5": "3",
            "6": "11",
            "7": "8",
            "city": "Варшава",
            "team_name": "PingWins",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "6",
            "6": "9",
            "7": "8",
            "city": "Барановичи",
            "team_name": "Мышка Клава",
            "total": "52"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "8",
            "city": "Киров",
            "team_name": "Друзья Друзя",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "4",
            "6": "9",
            "7": "8",
            "city": "Истра",
            "team_name": "Друзь-Я",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "6",
            "5": "2",
            "6": "14",
            "7": "7",
            "city": "Ростов на Дону",
            "team_name": "Свидетели Панкова",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "7",
            "city": "Ногинск",
            "team_name": "Конь в пальто",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "7",
            "city": "Владимир",
            "team_name": "Пряные специи",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "4",
            "6": "12",
            "7": "7",
            "city": "Хельсинки",
            "team_name": "Альфа Дрим ",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "11",
            "7": "7",
            "city": "Молодечно",
            "team_name": "TрохLiтровы Слоік",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "10",
            "7": "7",
            "city": "Брест",
            "team_name": "Профессор Шварценгольд",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "10",
            "7": "7",
            "city": "Витебск",
            "team_name": "Ok google",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "7",
            "4": "5",
            "5": "8",
            "6": "9",
            "7": "7",
            "city": "Глазов",
            "team_name": "Операция мы",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "6",
            "5": "5",
            "6": "14",
            "7": "6",
            "city": "Обнинск",
            "team_name": "Журавль в руках ",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "14",
            "7": "6",
            "city": "Пермь",
            "team_name": "КОМАНДИРОВАННЫЕ",
            "total": "52"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "8",
            "6": "13",
            "7": "6",
            "city": "Омск",
            "team_name": "Сибирские мажоры",
            "total": "52"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "3",
            "5": "4",
            "6": "13",
            "7": "6",
            "city": "Гродно",
            "team_name": "Изопеур",
            "total": "52"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "5",
            "5": "7",
            "6": "12",
            "7": "6",
            "city": "Иваново",
            "team_name": "Метарепрезентация",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "7",
            "6": "11",
            "7": "6",
            "city": "Тверь",
            "team_name": "Жесткая заделка",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "1",
            "5": "7",
            "6": "11",
            "7": "6",
            "city": "Челябинск",
            "team_name": "AVE Mafia",
            "total": "52"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "6",
            "4": "6",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Ростов на Дону",
            "team_name": "Соучастники",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Екатеринбург",
            "team_name": "Ложка дёгтя 2",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "6",
            "city": "Электросталь",
            "team_name": "Без котиков",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "7",
            "6": "10",
            "7": "6",
            "city": "Санкт-Петербург",
            "team_name": "Чурчхела БЕЗ каракатиц",
            "total": "52"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "5",
            "4": "4",
            "5": "6",
            "6": "10",
            "7": "6",
            "city": "Минск",
            "team_name": "Школа ля Мулен Ружу",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "10",
            "7": "6",
            "city": "Гомель",
            "team_name": "СК Кабина",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "6",
            "city": "Ухта",
            "team_name": "Это твои дети, Василий!",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "6",
            "city": "Екатеринбург",
            "team_name": "Прибухнём – и в караоке!",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "7",
            "4": "6",
            "5": "4",
            "6": "10",
            "7": "6",
            "city": "Варшава",
            "team_name": "Культ черного огурца",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "6",
            "city": "Минск",
            "team_name": "Пшистко",
            "total": "52"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "5",
            "6": "8",
            "7": "6",
            "city": "Пенза",
            "team_name": "50/50",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "5",
            "5": "8",
            "6": "13",
            "7": "4",
            "city": "Гомель",
            "team_name": "ЗОЖ",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "2",
            "5": "6",
            "6": "13",
            "7": "4",
            "city": "Екатеринбург",
            "team_name": "АКУ",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "2",
            "5": "6",
            "6": "12",
            "7": "4",
            "city": "Каменск-Уральский",
            "team_name": "Шестое доказательство",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "6",
            "6": "11",
            "7": "4",
            "city": "Таганрог",
            "team_name": "Ничоси",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "5",
            "6": "11",
            "7": "4",
            "city": "Хельсинки",
            "team_name": "Была не была ",
            "total": "52"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "6",
            "6": "9",
            "7": "4",
            "city": "Екатеринбург",
            "team_name": "Щас котлетку доем",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "3",
            "city": "Лида",
            "team_name": "Джаред, где лето?",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "9",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "3",
            "city": "Петрозаводск",
            "team_name": "Паутина разума",
            "total": "52"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "2",
            "5": "6",
            "6": "13",
            "7": "2",
            "city": "Омск",
            "team_name": "Uncle Fedor, Druz' and Co",
            "total": "52"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "7",
            "6": "9",
            "7": "2",
            "city": "Воронеж",
            "team_name": "Братство Винца",
            "total": "52"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "10",
            "4": "5",
            "5": "7",
            "6": "8",
            "7": "2",
            "city": "Гродно",
            "team_name": "Nemo",
            "total": "52"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "2",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "11",
            "city": "Снежинск",
            "team_name": "Вредные ископаемые",
            "total": "51"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "2",
            "5": "6",
            "6": "14",
            "7": "10",
            "city": "Архангельск",
            "team_name": "Тесный круг",
            "total": "51"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "4",
            "5": "3",
            "6": "13",
            "7": "10",
            "city": "Санкт-Петербург",
            "team_name": "¯\\_(ツ)_/¯",
            "total": "51"
        },
        {
            "0": "4",
            "1": "4",
            "2": "4",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "10",
            "city": "Тампере",
            "team_name": "РомашкИ",
            "total": "51"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "11",
            "7": "10",
            "city": "Омск",
            "team_name": "Извилины",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "6",
            "5": "2",
            "6": "11",
            "7": "10",
            "city": "Ставрополь",
            "team_name": "Генератор случайных ответов",
            "total": "51"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "10",
            "7": "10",
            "city": "Пинск",
            "team_name": "Дерзкие смайлы",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "10",
            "city": "Ярославль",
            "team_name": "ЗВЕЗДЫ",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "5",
            "5": "3",
            "6": "9",
            "7": "10",
            "city": "Симферополь",
            "team_name": "Пришли поесть",
            "total": "51"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "8",
            "7": "10",
            "city": "Бишкек",
            "team_name": "НЛО",
            "total": "51"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "0",
            "5": "5",
            "6": "12",
            "7": "9",
            "city": "Гродно",
            "team_name": "Борода патриарха",
            "total": "51"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "11",
            "7": "9",
            "city": "Турку",
            "team_name": "Фантастические твари",
            "total": "51"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "5",
            "5": "3",
            "6": "11",
            "7": "9",
            "city": "Зеленоград",
            "team_name": "Мама сказала ХамонЭврибади",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "11",
            "7": "9",
            "city": "Снежинск",
            "team_name": "О как!",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "10",
            "7": "9",
            "city": "Ярославль",
            "team_name": "Экстракт валерианы",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "2",
            "5": "7",
            "6": "8",
            "7": "9",
            "city": "Нижняя Тура",
            "team_name": "Сваты. Расслабились",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "3",
            "4": "3",
            "5": "7",
            "6": "12",
            "7": "8",
            "city": "Великий Новгород",
            "team_name": "СПС",
            "total": "51"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "7",
            "6": "12",
            "7": "8",
            "city": "Турку",
            "team_name": "Ежики в тумане",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Иркутск",
            "team_name": "А мы так и думали!",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "3",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Жуковский",
            "team_name": "Кратовские Учёные",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "8",
            "city": "Екатеринбург",
            "team_name": "Миллеры",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "8",
            "city": "Могилев",
            "team_name": "Японский котик Намахай",
            "total": "51"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "8",
            "city": "Таганрог",
            "team_name": "18+ Big People",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "3",
            "6": "10",
            "7": "8",
            "city": "Омск",
            "team_name": "имени Великой Октябрьской Революции",
            "total": "51"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "9",
            "7": "8",
            "city": "Североуральск",
            "team_name": "Ваше сиятельство",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "2",
            "5": "6",
            "6": "9",
            "7": "8",
            "city": "Первоуральск",
            "team_name": "Расчеши манту",
            "total": "51"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "8",
            "6": "8",
            "7": "8",
            "city": "Белгород",
            "team_name": "220 и 3/4 вольт",
            "total": "51"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "8",
            "7": "8",
            "city": "Глазов",
            "team_name": "Аркадий Паровозов",
            "total": "51"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "3",
            "6": "8",
            "7": "8",
            "city": "Архангельск",
            "team_name": "Акуна Матата",
            "total": "51"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "4",
            "4": "6",
            "5": "4",
            "6": "13",
            "7": "7",
            "city": "Брест",
            "team_name": "Берасцейскiя БуррагоZZы",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "1",
            "5": "6",
            "6": "12",
            "7": "7",
            "city": "Нефтеюганск",
            "team_name": "Funny people",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "4",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "7",
            "city": "Хельсинки",
            "team_name": "Друзья Бориса ",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "11",
            "7": "7",
            "city": "Минск",
            "team_name": "Вторая смена",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "6",
            "5": "3",
            "6": "11",
            "7": "7",
            "city": "Владимир",
            "team_name": "Дас Ист Айне Шикардос, Отвечаем на вопрос!",
            "total": "51"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "8",
            "6": "10",
            "7": "7",
            "city": "Нефтеюганск",
            "team_name": "Модуль ЮНГа",
            "total": "51"
        },
        {
            "0": "6",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "6",
            "6": "10",
            "7": "7",
            "city": "Краснотурьинск",
            "team_name": "Новый хор",
            "total": "51"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "4",
            "6": "9",
            "7": "7",
            "city": "Ялта",
            "team_name": "Частный клуб \"Свиной рог\"",
            "total": "51"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "9",
            "7": "7",
            "city": "Домодедово",
            "team_name": "Жгучие Красные перцы",
            "total": "51"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "0",
            "5": "6",
            "6": "14",
            "7": "6",
            "city": "Варшава",
            "team_name": "Хождение под мухой",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "13",
            "7": "6",
            "city": "Екатеринбург",
            "team_name": "Элен и ребята",
            "total": "51"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "6",
            "6": "12",
            "7": "6",
            "city": "Норильск",
            "team_name": "Октоберфест",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "6",
            "5": "5",
            "6": "12",
            "7": "6",
            "city": "Тюмень",
            "team_name": "9 человек",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "6",
            "city": "Северодвинск",
            "team_name": "Bob J Crew",
            "total": "51"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "12",
            "7": "6",
            "city": "Ярославль",
            "team_name": "Раки в атаке",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "6",
            "5": "4",
            "6": "12",
            "7": "6",
            "city": "Ростов на Дону",
            "team_name": "Медвежье Ухо",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "1",
            "5": "7",
            "6": "11",
            "7": "6",
            "city": "Раменское",
            "team_name": "Темная вселенная",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "4",
            "4": "4",
            "5": "6",
            "6": "11",
            "7": "6",
            "city": "Воронеж",
            "team_name": "Смазка для ракеты Маска",
            "total": "51"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Обнинск",
            "team_name": "Траволта! ",
            "total": "51"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Гомель",
            "team_name": "ПЭСТЭЦ",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "4",
            "6": "11",
            "7": "6",
            "city": "Киров",
            "team_name": "Мищ Ушатэк",
            "total": "51"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "4",
            "4": "5",
            "5": "4",
            "6": "11",
            "7": "6",
            "city": "Ташкент",
            "team_name": "Вунш Пунш",
            "total": "51"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "6",
            "city": "Бишкек",
            "team_name": "Тыщь тыдыщь бах и все",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "9",
            "7": "6",
            "city": "Таллин",
            "team_name": "No Brain Just Luck",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "6",
            "7": "6",
            "city": "Киров",
            "team_name": "Собака Пастернака",
            "total": "51"
        },
        {
            "0": "5",
            "1": "7",
            "2": "4",
            "3": "9",
            "4": "1",
            "5": "7",
            "6": "13",
            "7": "5",
            "city": "Ковров",
            "team_name": "Мясное рандеву",
            "total": "51"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "4",
            "4": "5",
            "5": "5",
            "6": "13",
            "7": "5",
            "city": "Пенза",
            "team_name": "И поприжать!",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "13",
            "7": "5",
            "city": "Минск",
            "team_name": "Имени 100 лет Октября",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "5",
            "city": "Санкт-Петербург",
            "team_name": "Пыльные гантели",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "5",
            "city": "Таганрог",
            "team_name": "Мозжечок с гармошкой",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "13",
            "7": "4",
            "city": "Москва",
            "team_name": "Омсквичи",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "13",
            "7": "4",
            "city": "Севастополь",
            "team_name": "КОМАТОЗНИКИ",
            "total": "51"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "8",
            "6": "12",
            "7": "4",
            "city": "Рязань",
            "team_name": "Мачете",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "4",
            "city": "Борисов",
            "team_name": "Исландский вулкан",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "4",
            "city": "Слободской",
            "team_name": "Бухарест",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "2",
            "5": "6",
            "6": "11",
            "7": "4",
            "city": "Омск",
            "team_name": "Опухоль мозга",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "4",
            "6": "11",
            "7": "4",
            "city": "Снежинск",
            "team_name": "Инвариант",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "7",
            "5": "3",
            "6": "11",
            "7": "4",
            "city": "Воронеж",
            "team_name": "А нас рать!",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "4",
            "6": "10",
            "7": "4",
            "city": "Ухта",
            "team_name": "Омерзительная Девятка",
            "total": "51"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "6",
            "4": "6",
            "5": "5",
            "6": "9",
            "7": "4",
            "city": "Петрозаводск",
            "team_name": "Зато красивые",
            "total": "51"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "14",
            "7": "3",
            "city": "Курган",
            "team_name": "Анонимные атлеты",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "8",
            "4": "7",
            "5": "4",
            "6": "12",
            "7": "3",
            "city": "Рязань",
            "team_name": "Кунжуть",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "4",
            "6": "11",
            "7": "3",
            "city": "Бобруйск",
            "team_name": "Полено Гагарина",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "2",
            "city": "Санкт-Петербург",
            "team_name": "Внук Отца Синди",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "2",
            "city": "Челябинск",
            "team_name": "Сделано в СССР Золото партии",
            "total": "51"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "7",
            "6": "14",
            "7": "1",
            "city": "Зеленоград",
            "team_name": "Zлоба дня",
            "total": "51"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "7",
            "5": "4",
            "6": "14",
            "7": "-1",
            "city": "Брест",
            "team_name": "Brest Stand Up",
            "total": "51"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "7",
            "7": "12",
            "city": "Екатеринбург",
            "team_name": "Оператор в босоножках",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "2",
            "4": "4",
            "5": "3",
            "6": "12",
            "7": "10",
            "city": "Раменское",
            "team_name": "Хорошо быть пивоваром",
            "total": "50"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "11",
            "7": "10",
            "city": "Санкт-Петербург",
            "team_name": "Твоя бабушка",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "2",
            "5": "3",
            "6": "11",
            "7": "10",
            "city": "Обнинск",
            "team_name": "Пятьдесят оттенков зелёного",
            "total": "50"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "10",
            "7": "10",
            "city": "Барановичи",
            "team_name": "Кузя и К",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "5",
            "5": "2",
            "6": "9",
            "7": "10",
            "city": "Киров",
            "team_name": "Комок нервов",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "7",
            "7": "10",
            "city": "Люберцы",
            "team_name": "Синие вечера",
            "total": "50"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "9",
            "city": "Гродно",
            "team_name": "Мутный глаз",
            "total": "50"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "12",
            "7": "9",
            "city": "Кропоткин",
            "team_name": "Лёгкая эйфория",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "3",
            "5": "7",
            "6": "10",
            "7": "9",
            "city": "Кострома",
            "team_name": "Пусть говорят",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "9",
            "7": "9",
            "city": "Раменское",
            "team_name": "Яблоки Ньютона",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "5",
            "5": "4",
            "6": "13",
            "7": "8",
            "city": "Раменское",
            "team_name": "Бардотка Пахельбеля",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "3",
            "5": "4",
            "6": "13",
            "7": "8",
            "city": "Екатеринбург",
            "team_name": "Мозголада",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "3",
            "5": "7",
            "6": "11",
            "7": "8",
            "city": "Хельсинки",
            "team_name": "Ну жесть! ",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "2",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Пенза",
            "team_name": "115 проспект",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Балашиха",
            "team_name": "Балашиха Рулит!",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "11",
            "7": "8",
            "city": "Иваново",
            "team_name": "Plan B-52",
            "total": "50"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "3",
            "6": "11",
            "7": "8",
            "city": "Снежинск",
            "team_name": "П0№ТbI Пил@т@",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "6",
            "6": "10",
            "7": "8",
            "city": "Хельсинки",
            "team_name": "Вареники с вишней ",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "8",
            "city": "Пермь",
            "team_name": "Ежи и Петруччо",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "8",
            "city": "Киров",
            "team_name": "#корпорациямонстров",
            "total": "50"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "10",
            "7": "8",
            "city": "Ставрополь",
            "team_name": "Вино и котики",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "5",
            "6": "10",
            "7": "8",
            "city": "Ярославль",
            "team_name": "Фикус",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "5",
            "5": "5",
            "6": "9",
            "7": "8",
            "city": "Могилев",
            "team_name": "Горе без ума",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "5",
            "7": "8",
            "city": "Поставы",
            "team_name": "Сборная солярка",
            "total": "50"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "5",
            "7": "8",
            "city": "Магнитогорск",
            "team_name": "Смелыеумелые",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "0",
            "5": "6",
            "6": "14",
            "7": "7",
            "city": "Кропоткин",
            "team_name": "Полный улёт",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "4",
            "6": "14",
            "7": "7",
            "city": "Санкт-Петербург",
            "team_name": "клитрулитр",
            "total": "50"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "4",
            "5": "6",
            "6": "13",
            "7": "7",
            "city": "Барановичи",
            "team_name": "Березовый фреш",
            "total": "50"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "2",
            "6": "13",
            "7": "7",
            "city": "Киров",
            "team_name": "Паклюкер Куземпаив",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "2",
            "6": "13",
            "7": "7",
            "city": "Гомель",
            "team_name": "Алиса в стране Чаэс",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "6",
            "6": "12",
            "7": "7",
            "city": "Челябинск",
            "team_name": "Росвопрос",
            "total": "50"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "7",
            "city": "Симферополь",
            "team_name": "Мандарин",
            "total": "50"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "7",
            "city": "Ялта",
            "team_name": "Сидр Акуна Матата",
            "total": "50"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "10",
            "7": "7",
            "city": "Омск",
            "team_name": "Шутёхи от Лёхи",
            "total": "50"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "7",
            "city": "Курган",
            "team_name": "Бобродобр",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "5",
            "6": "8",
            "7": "7",
            "city": "Первоуральск",
            "team_name": "Только Хардкор",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "13",
            "7": "6",
            "city": "Тула",
            "team_name": "Внуки Ван Гога",
            "total": "50"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "3",
            "6": "13",
            "7": "6",
            "city": "Зеленоград",
            "team_name": "Легендарные хроники",
            "total": "50"
        },
        {
            "0": "6",
            "1": "4",
            "2": "7",
            "3": "7",
            "4": "2",
            "5": "6",
            "6": "12",
            "7": "6",
            "city": "Минск",
            "team_name": "Штаб",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "6",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Архангельск",
            "team_name": "Конь, изба и маленький молот",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Симферополь",
            "team_name": "Агонь",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Алматы",
            "team_name": "Святые негодники ⛔",
            "total": "50"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "6",
            "4": "6",
            "5": "4",
            "6": "11",
            "7": "6",
            "city": "Гомель",
            "team_name": "Второй пилот Дринкинс",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "3",
            "6": "11",
            "7": "6",
            "city": "Санкт-Петербург",
            "team_name": "ДичьбезСени",
            "total": "50"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "7",
            "6": "10",
            "7": "6",
            "city": "Иваново",
            "team_name": "Вспомнить всё",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "10",
            "7": "6",
            "city": "Орск",
            "team_name": "Баркас имени Чапаева",
            "total": "50"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "10",
            "7": "6",
            "city": "Екатеринбург",
            "team_name": "18 берёз, я их сам считал",
            "total": "50"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "5",
            "4": "5",
            "5": "3",
            "6": "10",
            "7": "6",
            "city": "Иваново",
            "team_name": "Товарищи Ленины",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "4",
            "5": "6",
            "6": "9",
            "7": "6",
            "city": "Гродно",
            "team_name": "Коктейль Молотова",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "2",
            "5": "6",
            "6": "9",
            "7": "6",
            "city": "Гродно",
            "team_name": "Ты Че?",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "9",
            "7": "6",
            "city": "Ковров",
            "team_name": "Финики",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "6",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Петрозаводск",
            "team_name": "ЧГП",
            "total": "50"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "8",
            "7": "6",
            "city": "Ижевск",
            "team_name": "Полныйпердимонокль ",
            "total": "50"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "7",
            "7": "6",
            "city": "Гродно",
            "team_name": "Обездмитренные",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "12",
            "7": "5",
            "city": "Каменск-Уральский",
            "team_name": "Во славу Зигмунда",
            "total": "50"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "11",
            "7": "5",
            "city": "Киров",
            "team_name": "Йети Эйнштейна",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "2",
            "6": "11",
            "7": "5",
            "city": "Екатеринбург",
            "team_name": "Катя так сказала",
            "total": "50"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "10",
            "7": "5",
            "city": "Молодечно",
            "team_name": "Ален_Димон",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "10",
            "7": "5",
            "city": "Тель Авив",
            "team_name": "Остатки роскоши",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "6",
            "5": "3",
            "6": "9",
            "7": "5",
            "city": "Могилев",
            "team_name": "На Мальдивы надо ехать",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "6",
            "5": "5",
            "6": "13",
            "7": "4",
            "city": "Киров",
            "team_name": "Мафия бессмертна",
            "total": "50"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "3",
            "6": "13",
            "7": "4",
            "city": "Ташкент",
            "team_name": "Poker Face",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "5",
            "5": "5",
            "6": "12",
            "7": "4",
            "city": "Санкт-Петербург",
            "team_name": "Выпьем за любовь",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "4",
            "city": "Североуральск",
            "team_name": "Полный бред",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "11",
            "7": "4",
            "city": "Ухта",
            "team_name": "Ум за разум",
            "total": "50"
        },
        {
            "0": "7",
            "1": "4",
            "2": "7",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "4",
            "city": "Ростов на Дону",
            "team_name": "Noname",
            "total": "50"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "10",
            "7": "4",
            "city": "Севастополь",
            "team_name": "ИзАлупкислюбовью",
            "total": "50"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "7",
            "6": "9",
            "7": "4",
            "city": "Архангельск",
            "team_name": "Котики",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "9",
            "7": "4",
            "city": "Брест",
            "team_name": "Веселые Павлики",
            "total": "50"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "7",
            "6": "8",
            "7": "4",
            "city": "Омутнинск",
            "team_name": "Друзья",
            "total": "50"
        },
        {
            "0": "5",
            "1": "7",
            "2": "7",
            "3": "5",
            "4": "5",
            "5": "5",
            "6": "13",
            "7": "3",
            "city": "Гомель",
            "team_name": "НОГА",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "1",
            "5": "5",
            "6": "12",
            "7": "3",
            "city": "Минск",
            "team_name": "Кот дай виньчик",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "10",
            "7": "3",
            "city": "Пенза",
            "team_name": "Где Петров?",
            "total": "50"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "5",
            "6": "14",
            "7": "2",
            "city": "Омск",
            "team_name": "Но это не точно О5",
            "total": "50"
        },
        {
            "0": "5",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "8",
            "6": "12",
            "7": "2",
            "city": "Сургут",
            "team_name": "Нитроверты",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "8",
            "6": "11",
            "7": "2",
            "city": "Югорск",
            "team_name": "Минус ставь",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "2",
            "5": "7",
            "6": "11",
            "7": "2",
            "city": "Иваново",
            "team_name": "Я же говорил !!!",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "6",
            "6": "13",
            "7": "0",
            "city": "Ярославль",
            "team_name": "Дефект Вассермана",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "10",
            "4": "3",
            "5": "6",
            "6": "12",
            "7": "0",
            "city": "Тампере",
            "team_name": "Партизаны",
            "total": "50"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "9",
            "4": "6",
            "5": "5",
            "6": "10",
            "7": "-1",
            "city": "Москва",
            "team_name": "Чингисхан Тротил",
            "total": "50"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "14",
            "7": "-2",
            "city": "Владимир",
            "team_name": "Оууу Ессс",
            "total": "50"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "0",
            "5": "3",
            "6": "12",
            "7": "11",
            "city": "Екатеринбург",
            "team_name": "Узуфрукты сервитуток",
            "total": "49"
        },
        {
            "0": "4",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "12",
            "7": "10",
            "city": "Киров",
            "team_name": "Штрудель",
            "total": "49"
        },
        {
            "0": "5",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "12",
            "7": "10",
            "city": "Жуковский",
            "team_name": "N ёжиков",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "1",
            "5": "6",
            "6": "10",
            "7": "10",
            "city": "Архангельск",
            "team_name": "Панда-банда",
            "total": "49"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "6",
            "5": "2",
            "6": "10",
            "7": "10",
            "city": "Глазов",
            "team_name": "Carpe diem",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "5",
            "7": "10",
            "city": "Пятигорск",
            "team_name": "Мозгойоги",
            "total": "49"
        },
        {
            "0": "3",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "12",
            "7": "9",
            "city": "Гродно",
            "team_name": "Зодчие на всю голову",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "2",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "9",
            "city": "Санкт-Петербург",
            "team_name": "Ума Тюрьма",
            "total": "49"
        },
        {
            "0": "6",
            "1": "5",
            "2": "7",
            "3": "5",
            "4": "3",
            "5": "7",
            "6": "7",
            "7": "9",
            "city": "Пятигорск",
            "team_name": "Энергетики",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "6",
            "5": "5",
            "6": "7",
            "7": "9",
            "city": "Люберцы",
            "team_name": "ЖЭК потрошитель",
            "total": "49"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "0",
            "5": "6",
            "6": "10",
            "7": "8",
            "city": "Минск",
            "team_name": "Выше плинтуса",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "1",
            "5": "4",
            "6": "10",
            "7": "8",
            "city": "Санкт-Петербург",
            "team_name": "АБВГДйка",
            "total": "49"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "6",
            "6": "9",
            "7": "8",
            "city": "Санкт-Петербург",
            "team_name": "НедоПоташев",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "7",
            "6": "8",
            "7": "8",
            "city": "Белгород",
            "team_name": "Мозгоюбки и их Жертвы",
            "total": "49"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "6",
            "6": "8",
            "7": "8",
            "city": "Петропавловск",
            "team_name": "Всякие",
            "total": "49"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "6",
            "7": "8",
            "city": "Воронеж",
            "team_name": "Омары Хайяма",
            "total": "49"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "4",
            "4": "3",
            "5": "8",
            "6": "12",
            "7": "7",
            "city": "Вольск",
            "team_name": "Мы",
            "total": "49"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "7",
            "city": "Чернигов",
            "team_name": "Между нами девочками",
            "total": "49"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "7",
            "city": "Омск",
            "team_name": "Ультра",
            "total": "49"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "10",
            "7": "7",
            "city": "Таганрог",
            "team_name": "Лихие извилины",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "7",
            "city": "Тверь",
            "team_name": "Old school",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "1",
            "5": "5",
            "6": "8",
            "7": "7",
            "city": "Нефтеюганск",
            "team_name": "200 грамм мозгов",
            "total": "49"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "9",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "7",
            "city": "Минск",
            "team_name": "Voyage Voyage",
            "total": "49"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "7",
            "7": "7",
            "city": "Махачкала",
            "team_name": "НаВи",
            "total": "49"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "13",
            "7": "6",
            "city": "Екатеринбург",
            "team_name": "Отряд тюленеводов им. монаха Бертольда Шварца",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "4",
            "4": "4",
            "5": "6",
            "6": "12",
            "7": "6",
            "city": "Архангельск",
            "team_name": "ПСИ-фактор",
            "total": "49"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "3",
            "4": "3",
            "5": "6",
            "6": "12",
            "7": "6",
            "city": "Зеленоград",
            "team_name": "Фо О'Клок",
            "total": "49"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "9",
            "4": "3",
            "5": "4",
            "6": "12",
            "7": "6",
            "city": "Москва",
            "team_name": "Диана Андреевна",
            "total": "49"
        },
        {
            "0": "6",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "11",
            "7": "6",
            "city": "Минск",
            "team_name": "Метод кнута и драника",
            "total": "49"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "6",
            "city": "Воронеж",
            "team_name": "Тык-мык",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "5",
            "city": "Артемовский",
            "team_name": "Окей, Гоголь!",
            "total": "49"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "5",
            "city": "Лондон",
            "team_name": "Фавориты инквизиции",
            "total": "49"
        },
        {
            "0": "5",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "5",
            "city": "Барановичи",
            "team_name": "Восхождение к безумию",
            "total": "49"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "9",
            "7": "5",
            "city": "Оренбург",
            "team_name": "НИПИ_без_НЕФТИ ",
            "total": "49"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "6",
            "6": "9",
            "7": "5",
            "city": "Берёзовский",
            "team_name": "Светлые головы",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "7",
            "6": "8",
            "7": "5",
            "city": "Барнаул",
            "team_name": "Капитан Доигралес",
            "total": "49"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "8",
            "7": "5",
            "city": "Барановичи",
            "team_name": "МИКС",
            "total": "49"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "2",
            "5": "4",
            "6": "12",
            "7": "4",
            "city": "Владимир",
            "team_name": "ТеплоГазМяс",
            "total": "49"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "9",
            "4": "4",
            "5": "6",
            "6": "11",
            "7": "4",
            "city": "Омск",
            "team_name": "Генератор случайных ответов",
            "total": "49"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "4",
            "city": "Златоуст",
            "team_name": "Ровная кровля",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "2",
            "6": "11",
            "7": "4",
            "city": "Санкт-Петербург",
            "team_name": "Лакидос",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "3",
            "6": "10",
            "7": "4",
            "city": "Рязань",
            "team_name": "ФЛЮГЕГЕНХАЙМЕН",
            "total": "49"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "3",
            "6": "10",
            "7": "4",
            "city": "Архангельск",
            "team_name": "Мюсли Фрейда",
            "total": "49"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "6",
            "6": "8",
            "7": "4",
            "city": "Гомель",
            "team_name": "Вообще, однако",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "8",
            "7": "4",
            "city": "Пермь",
            "team_name": "Особый сговор",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "8",
            "7": "4",
            "city": "Кропоткин",
            "team_name": "Vegas",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "13",
            "7": "3",
            "city": "Кострома",
            "team_name": "Теория невероятности",
            "total": "49"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "4",
            "6": "10",
            "7": "3",
            "city": "Пермь",
            "team_name": "Ой, всё!",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "6",
            "6": "8",
            "7": "3",
            "city": "Красногорск",
            "team_name": "П.Д.Т.Х.",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "6",
            "6": "13",
            "7": "2",
            "city": "Екатеринбург",
            "team_name": "Rastus",
            "total": "49"
        },
        {
            "0": "5",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "2",
            "city": "Владимир",
            "team_name": "Мэйсон Кэпвэлл",
            "total": "49"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "6",
            "4": "7",
            "5": "4",
            "6": "12",
            "7": "2",
            "city": "Омск",
            "team_name": "Косеночки",
            "total": "49"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "4",
            "6": "11",
            "7": "2",
            "city": "Москва",
            "team_name": "Крутое пике!",
            "total": "49"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "6",
            "5": "4",
            "6": "11",
            "7": "2",
            "city": "Владимир",
            "team_name": "Острые козырьки",
            "total": "49"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "7",
            "6": "12",
            "7": "1",
            "city": "Петрозаводск",
            "team_name": "Кнехт Рупрехт",
            "total": "49"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "1",
            "city": "Воронеж",
            "team_name": "Okay Google",
            "total": "49"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "7",
            "4": "7",
            "5": "5",
            "6": "11",
            "7": "1",
            "city": "Архангельск",
            "team_name": "puffins",
            "total": "49"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "10",
            "7": "10",
            "city": "Обнинск",
            "team_name": "Нобели ",
            "total": "48"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "5",
            "4": "0",
            "5": "4",
            "6": "10",
            "7": "10",
            "city": "Орск",
            "team_name": "Туристы дьявола",
            "total": "48"
        },
        {
            "0": "5",
            "1": "5",
            "2": "7",
            "3": "6",
            "4": "3",
            "5": "2",
            "6": "10",
            "7": "10",
            "city": "Пинск",
            "team_name": "Ягодки А5",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "3",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "10",
            "city": "Обнинск",
            "team_name": "Спорная солянка",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "1",
            "5": "3",
            "6": "9",
            "7": "10",
            "city": "Минск",
            "team_name": "Дубовый сок",
            "total": "48"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "10",
            "city": "Раменское",
            "team_name": "Sexy Pistols",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "3",
            "6": "8",
            "7": "10",
            "city": "Архангельск",
            "team_name": "МАЛИНА!",
            "total": "48"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "5",
            "6": "10",
            "7": "9",
            "city": "Химки",
            "team_name": "Впопыхах состряпана",
            "total": "48"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "10",
            "7": "9",
            "city": "Ставрополь",
            "team_name": "Оп, мизантроп!",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "9",
            "7": "9",
            "city": "Лондон",
            "team_name": "UK Google",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "1",
            "5": "5",
            "6": "9",
            "7": "9",
            "city": "Минск",
            "team_name": "Мы все скучаем",
            "total": "48"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "2",
            "5": "3",
            "6": "8",
            "7": "9",
            "city": "Омск",
            "team_name": "Призраки разума",
            "total": "48"
        },
        {
            "0": "6",
            "1": "5",
            "2": "7",
            "3": "3",
            "4": "1",
            "5": "4",
            "6": "14",
            "7": "8",
            "city": "Пермь",
            "team_name": "Черепаха с тротилом",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "11",
            "7": "8",
            "city": "Иваново",
            "team_name": "Игры Разума",
            "total": "48"
        },
        {
            "0": "5",
            "1": "6",
            "2": "7",
            "3": "4",
            "4": "4",
            "5": "3",
            "6": "11",
            "7": "8",
            "city": "Москва",
            "team_name": "Двоичные антилопы",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "1",
            "5": "2",
            "6": "10",
            "7": "8",
            "city": "Кирово-Чепецк",
            "team_name": "Пи_здесь!",
            "total": "48"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "5",
            "5": "5",
            "6": "9",
            "7": "8",
            "city": "Омутнинск",
            "team_name": "Палата №6",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "5",
            "5": "2",
            "6": "9",
            "7": "8",
            "city": "Сургут",
            "team_name": "Зайчатки разума",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "8",
            "city": "Хельсинки",
            "team_name": "Те еще штучки ",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "0",
            "5": "4",
            "6": "8",
            "7": "8",
            "city": "Пенза",
            "team_name": "В джазе только мы",
            "total": "48"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "7",
            "7": "8",
            "city": "Ковров",
            "team_name": "Нас Рать",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "5",
            "5": "4",
            "6": "7",
            "7": "8",
            "city": "Жуковский",
            "team_name": "Леший с нами",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "3",
            "4": "2",
            "5": "4",
            "6": "14",
            "7": "7",
            "city": "Минск",
            "team_name": "Балаболы",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "5",
            "5": "2",
            "6": "13",
            "7": "7",
            "city": "Кирово-Чепецк",
            "team_name": "Трое в лодке, не стесняясь собаки",
            "total": "48"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "1",
            "5": "7",
            "6": "12",
            "7": "7",
            "city": "Иваново",
            "team_name": "Ум за разум",
            "total": "48"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "12",
            "7": "7",
            "city": "Лондон",
            "team_name": "Зато красивые",
            "total": "48"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "5",
            "4": "1",
            "5": "5",
            "6": "11",
            "7": "7",
            "city": "Брест",
            "team_name": "Paradoxx",
            "total": "48"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "5",
            "5": "2",
            "6": "11",
            "7": "7",
            "city": "Екатеринбург",
            "team_name": "Консилиум",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "4",
            "5": "2",
            "6": "11",
            "7": "7",
            "city": "Екатеринбург",
            "team_name": "Точка",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "10",
            "7": "7",
            "city": "Пинск",
            "team_name": "МоzгиВбанке",
            "total": "48"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "9",
            "4": "5",
            "5": "2",
            "6": "10",
            "7": "7",
            "city": "Ташкент",
            "team_name": "#inTeam",
            "total": "48"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "7",
            "city": "Владимир",
            "team_name": "Команда им. Ктулху",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "7",
            "city": "Таганрог",
            "team_name": "Тити Нефертити",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "2",
            "6": "9",
            "7": "7",
            "city": "Екатеринбург",
            "team_name": "7 раз отпей, 1 раз отъешь",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "5",
            "7": "7",
            "city": "Пятигорск",
            "team_name": "Стакановцы",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "13",
            "7": "6",
            "city": "Северодвинск",
            "team_name": "Будем бобры!",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "1",
            "5": "6",
            "6": "12",
            "7": "6",
            "city": "Барановичи",
            "team_name": "Светлые и тёмные",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "6",
            "city": "Таганрог",
            "team_name": "Мозговые штурманы",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "12",
            "7": "6",
            "city": "Нижний Новгород",
            "team_name": "Вот такой пердимонокль!",
            "total": "48"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "3",
            "6": "12",
            "7": "6",
            "city": "Пермь",
            "team_name": "Сквош Band",
            "total": "48"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "1",
            "5": "6",
            "6": "11",
            "7": "6",
            "city": "Витебск",
            "team_name": "ЗОЖ Самое То",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Глазов",
            "team_name": "Сила места",
            "total": "48"
        },
        {
            "0": "6",
            "1": "4",
            "2": "7",
            "3": "8",
            "4": "1",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Минск",
            "team_name": "Баобаб",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "5",
            "5": "3",
            "6": "11",
            "7": "6",
            "city": "Нижний Новгород",
            "team_name": "Атомная Облепиха",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "6",
            "city": "Снежинск",
            "team_name": "Друзь ответит",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "5",
            "5": "6",
            "6": "9",
            "7": "6",
            "city": "Снежинск",
            "team_name": "Шестерёнка",
            "total": "48"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "6",
            "city": "Симферополь",
            "team_name": "За Орду!",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Берёзовский",
            "team_name": "Связанные одной целью",
            "total": "48"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Санкт-Петербург",
            "team_name": "IN BEer We Trust",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "3",
            "5": "3",
            "6": "8",
            "7": "6",
            "city": "Челябинск",
            "team_name": "Напряги извилины",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "6",
            "5": "5",
            "6": "6",
            "7": "6",
            "city": "Брест",
            "team_name": "Боевые хомяки",
            "total": "48"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "12",
            "7": "5",
            "city": "Снежинск",
            "team_name": "Джуманджи",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "5",
            "city": "Екатеринбург",
            "team_name": "Лига Шампиньонов",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "5",
            "city": "Киров",
            "team_name": "Поесть пришли",
            "total": "48"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "6",
            "5": "3",
            "6": "10",
            "7": "5",
            "city": "Молодечно",
            "team_name": "Денискины каракули",
            "total": "48"
        },
        {
            "0": "4",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "5",
            "city": "Туапсе",
            "team_name": "Эрудированные эрудиты",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "1",
            "5": "5",
            "6": "9",
            "7": "5",
            "city": "Владимир",
            "team_name": "Ухи Винни Пуха",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "3",
            "6": "9",
            "7": "5",
            "city": "Ухта",
            "team_name": "Семейка Адамс",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "5",
            "5": "3",
            "6": "13",
            "7": "4",
            "city": "Ухта",
            "team_name": "Б-52",
            "total": "48"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "4",
            "city": "Королев",
            "team_name": "БЕЗ ДУРАКОВ!",
            "total": "48"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "12",
            "7": "4",
            "city": "Симферополь",
            "team_name": "Salsaголики",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "2",
            "6": "12",
            "7": "4",
            "city": "Симферополь",
            "team_name": "Дорогая редакция",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "7",
            "6": "11",
            "7": "4",
            "city": "Великий Новгород",
            "team_name": "Нахимичили",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "4",
            "city": "Санкт-Петербург",
            "team_name": "Дикие кабаны из глубокого космоса",
            "total": "48"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "10",
            "7": "4",
            "city": "Барнаул",
            "team_name": "Палата 236",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "9",
            "4": "3",
            "5": "5",
            "6": "9",
            "7": "4",
            "city": "Брест",
            "team_name": "ПАН ТОМАШ",
            "total": "48"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "1",
            "5": "6",
            "6": "8",
            "7": "4",
            "city": "Иваново",
            "team_name": "СПАСИЛЬНИКИ",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "4",
            "city": "Хельсинки",
            "team_name": "Динамо",
            "total": "48"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "7",
            "7": "4",
            "city": "Воронеж",
            "team_name": "Вишневый бластер",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "7",
            "6": "10",
            "7": "3",
            "city": "Раменское",
            "team_name": "Над пропастью поржи!",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "10",
            "7": "3",
            "city": "Челябинск",
            "team_name": "Вставить название",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "6",
            "5": "6",
            "6": "8",
            "7": "3",
            "city": "Снежинск",
            "team_name": "Несекретные материалы",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "2",
            "city": "Киров",
            "team_name": "Сломай язык о Камбербэтча",
            "total": "48"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "7",
            "6": "13",
            "7": "1",
            "city": "Гомель",
            "team_name": "Сладкий Бубалех",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "5",
            "5": "6",
            "6": "13",
            "7": "1",
            "city": "Хельсинки",
            "team_name": "ФреÑдзона ",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "4",
            "6": "12",
            "7": "1",
            "city": "Могилев",
            "team_name": "★",
            "total": "48"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "12",
            "7": "0",
            "city": "Гродно",
            "team_name": "Братство тепла",
            "total": "48"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "-1",
            "5": "4",
            "6": "7",
            "7": "14",
            "city": "Москва",
            "team_name": "Мохнатый шмель",
            "total": "47"
        },
        {
            "0": "4",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "4",
            "5": "3",
            "6": "12",
            "7": "10",
            "city": "Гродно",
            "team_name": "Берта",
            "total": "47"
        },
        {
            "0": "3",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "10",
            "city": "Редмонд",
            "team_name": "Прокрастинаторы",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "0",
            "5": "3",
            "6": "10",
            "7": "10",
            "city": "Бобруйск",
            "team_name": "Бручилки: \"Бамболейло!\"",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "1",
            "5": "5",
            "6": "9",
            "7": "10",
            "city": "Москва",
            "team_name": "Городские пижоны",
            "total": "47"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "10",
            "city": "Хельсинки",
            "team_name": "Без ума от ума",
            "total": "47"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "1",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "9",
            "city": "Омск",
            "team_name": "Слепой камин",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "3",
            "6": "10",
            "7": "9",
            "city": "Омск",
            "team_name": "Свидетели Илона Маска",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "2",
            "6": "10",
            "7": "9",
            "city": "Варшава",
            "team_name": "Ракамакафон",
            "total": "47"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "5",
            "6": "9",
            "7": "9",
            "city": "Чернигов",
            "team_name": "Underdog Team",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "5",
            "5": "5",
            "6": "5",
            "7": "9",
            "city": "Поставы",
            "team_name": "День сырка",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "3",
            "4": "2",
            "5": "6",
            "6": "12",
            "7": "8",
            "city": "Жуковский",
            "team_name": "Oneteam - onedream",
            "total": "47"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "3",
            "5": "4",
            "6": "12",
            "7": "8",
            "city": "Хельсинки",
            "team_name": "Спотрохами ",
            "total": "47"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "12",
            "7": "8",
            "city": "Редмонд",
            "team_name": "Экспромт",
            "total": "47"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "11",
            "7": "8",
            "city": "Кирово-Чепецк",
            "team_name": "Акуна матата",
            "total": "47"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "5",
            "4": "1",
            "5": "3",
            "6": "11",
            "7": "8",
            "city": "Тверь",
            "team_name": "Тупи-тормози",
            "total": "47"
        },
        {
            "0": "6",
            "1": "5",
            "2": "7",
            "3": "4",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "8",
            "city": "Белгород",
            "team_name": "Двое из ларца - Петра Зусмана лица",
            "total": "47"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "4",
            "5": "7",
            "6": "9",
            "7": "8",
            "city": "Екатеринбург",
            "team_name": "Илона Маскова",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "3",
            "6": "9",
            "7": "8",
            "city": "Пермь",
            "team_name": "Fox и Компания",
            "total": "47"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "8",
            "city": "Тверь",
            "team_name": "Неадекватные котята",
            "total": "47"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "5",
            "5": "4",
            "6": "8",
            "7": "8",
            "city": "Глазов",
            "team_name": "ОсТАНКиНО",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "-1",
            "5": "3",
            "6": "13",
            "7": "7",
            "city": "Тюмень",
            "team_name": "Сборная Разборная",
            "total": "47"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "1",
            "6": "12",
            "7": "7",
            "city": "Гродно",
            "team_name": "Аджарим",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "5",
            "5": "3",
            "6": "11",
            "7": "7",
            "city": "Слободской",
            "team_name": "Одноклассники",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "3",
            "5": "7",
            "6": "10",
            "7": "7",
            "city": "Омск",
            "team_name": "Во славу Толи",
            "total": "47"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "7",
            "city": "Жуковский",
            "team_name": "cBRAINдили",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "3",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "7",
            "city": "Киров",
            "team_name": "Градус Цельсия",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "10",
            "7": "7",
            "city": "Иркутск",
            "team_name": "Клоны Друзей",
            "total": "47"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "7",
            "city": "Витебск",
            "team_name": "Спритни Бирс",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "0",
            "5": "7",
            "6": "11",
            "7": "6",
            "city": "Севастополь",
            "team_name": "Это не кризис...",
            "total": "47"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "6",
            "city": "Москва",
            "team_name": "Сири",
            "total": "47"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "2",
            "5": "3",
            "6": "11",
            "7": "6",
            "city": "Ташкент",
            "team_name": "ХЗ",
            "total": "47"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "10",
            "7": "6",
            "city": "Тверь",
            "team_name": "Адреналин",
            "total": "47"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "6",
            "4": "1",
            "5": "4",
            "6": "10",
            "7": "6",
            "city": "Чайковский",
            "team_name": "Идея фикс",
            "total": "47"
        },
        {
            "0": "4",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "6",
            "5": "3",
            "6": "10",
            "7": "6",
            "city": "Бобруйск",
            "team_name": "Электроники",
            "total": "47"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "3",
            "6": "10",
            "7": "6",
            "city": "Щелково",
            "team_name": "Так и решили",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "6",
            "5": "3",
            "6": "9",
            "7": "6",
            "city": "Пинск",
            "team_name": "Царь-батюшка",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "9",
            "7": "6",
            "city": "Киров",
            "team_name": "Адреналин",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "3",
            "5": "8",
            "6": "8",
            "7": "6",
            "city": "Вольск",
            "team_name": "Угарный газ",
            "total": "47"
        },
        {
            "0": "5",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "3",
            "5": "6",
            "6": "8",
            "7": "6",
            "city": "Санкт-Петербург",
            "team_name": "Просто кашкорсе",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "7",
            "7": "6",
            "city": "Иваново",
            "team_name": "НЕслучайные связи",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "3",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "5",
            "city": "Минск",
            "team_name": "ОленьСобакаЕжевика",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "4",
            "4": "2",
            "5": "5",
            "6": "12",
            "7": "5",
            "city": "Гомель",
            "team_name": "Easy Breezy",
            "total": "47"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "12",
            "7": "5",
            "city": "Барановичи",
            "team_name": "Luxury",
            "total": "47"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "1",
            "5": "6",
            "6": "11",
            "7": "5",
            "city": "Королев",
            "team_name": "Маски Гая Фокса",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "2",
            "5": "7",
            "6": "10",
            "7": "5",
            "city": "Владимир",
            "team_name": "Сектор сглаза",
            "total": "47"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "5",
            "city": "Ташкент",
            "team_name": "Некриминальное к Пиву",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "5",
            "city": "Серпухов",
            "team_name": "#и_так_сойдет",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "3",
            "6": "10",
            "7": "5",
            "city": "Варшава",
            "team_name": "СлабоумиеиОтвага",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "2",
            "6": "10",
            "7": "5",
            "city": "Каменск-Уральский",
            "team_name": "БеZMозгOFF",
            "total": "47"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "9",
            "7": "5",
            "city": "Хельсинки",
            "team_name": "Оладушки",
            "total": "47"
        },
        {
            "0": "5",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "5",
            "city": "Ухта",
            "team_name": "Бесстыжая курага где-то под Керками",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "5",
            "city": "Великий Новгород",
            "team_name": "Эстеты",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "3",
            "6": "9",
            "7": "5",
            "city": "Первоуральск",
            "team_name": "Капитошки с гравицапой",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "7",
            "7": "5",
            "city": "Пермь",
            "team_name": "Оранжевый тент",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "7",
            "4": "6",
            "5": "6",
            "6": "4",
            "7": "5",
            "city": "Магнитогорск",
            "team_name": "Люди мИКС",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "5",
            "5": "4",
            "6": "12",
            "7": "4",
            "city": "Глазов",
            "team_name": "Бригада",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "4",
            "city": "Чайковский",
            "team_name": "Семейка Аддамс",
            "total": "47"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "8",
            "4": "1",
            "5": "6",
            "6": "10",
            "7": "4",
            "city": "Омск",
            "team_name": "Nasty plov",
            "total": "47"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "1",
            "5": "5",
            "6": "10",
            "7": "4",
            "city": "Северодвинск",
            "team_name": "Группа-в-ухо молодости нашей",
            "total": "47"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "4",
            "city": "Туапсе",
            "team_name": "Умственно усталые",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "4",
            "city": "Екатеринбург",
            "team_name": "Никому не известные радиоведущие",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "4",
            "city": "Ярославль",
            "team_name": "Синяя чахохобля",
            "total": "47"
        },
        {
            "0": "6",
            "1": "5",
            "2": "7",
            "3": "8",
            "4": "2",
            "5": "6",
            "6": "9",
            "7": "4",
            "city": "Минск",
            "team_name": "Голос овощей",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "4",
            "city": "Нефтеюганск",
            "team_name": "Коба",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "5",
            "6": "8",
            "7": "4",
            "city": "Владимир",
            "team_name": "На вкус и цвет все фломастеры вкусные",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "13",
            "7": "3",
            "city": "Архангельск",
            "team_name": "Дети северных цветов",
            "total": "47"
        },
        {
            "0": "6",
            "1": "3",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "7",
            "6": "8",
            "7": "3",
            "city": "Хельсинки",
            "team_name": "Хомячок или жизнь ",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "3",
            "6": "12",
            "7": "2",
            "city": "Берёзовский",
            "team_name": "Не подружки",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "2",
            "city": "Кирово-Чепецк",
            "team_name": "Пока несут саке",
            "total": "47"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "5",
            "5": "3",
            "6": "11",
            "7": "2",
            "city": "Гомель",
            "team_name": "Wish Ня",
            "total": "47"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "8",
            "7": "2",
            "city": "Рязань",
            "team_name": "Лизинг Черноземья",
            "total": "47"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "2",
            "city": "Бишкек",
            "team_name": "Вуд Хеликоптер",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "1",
            "city": "Балашиха",
            "team_name": "ТроЯ в лодке, нищета и собаки",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "13",
            "7": "0",
            "city": "Архангельск",
            "team_name": "Veni, vidi, vici",
            "total": "47"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "5",
            "4": "3",
            "5": "6",
            "6": "12",
            "7": "0",
            "city": "Петропавловск",
            "team_name": "Солярис",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "5",
            "5": "5",
            "6": "11",
            "7": "0",
            "city": "Пермь",
            "team_name": "Альфа Центавра",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "10",
            "7": "0",
            "city": "Владимир",
            "team_name": "Dode pa",
            "total": "47"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "6",
            "5": "4",
            "6": "13",
            "7": "-1",
            "city": "Альметьевск",
            "team_name": "Старые Друзья",
            "total": "47"
        },
        {
            "0": "7",
            "1": "3",
            "2": "6",
            "3": "6",
            "4": "2",
            "5": "6",
            "6": "6",
            "7": "10",
            "city": "Рязань",
            "team_name": "Окей Google",
            "total": "46"
        },
        {
            "0": "7",
            "1": "7",
            "2": "3",
            "3": "4",
            "4": "2",
            "5": "4",
            "6": "10",
            "7": "9",
            "city": "Зеленоград",
            "team_name": "Слабоумие и отвага",
            "total": "46"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "8",
            "7": "9",
            "city": "Киров",
            "team_name": "Аннушка купила масло",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "1",
            "5": "6",
            "6": "7",
            "7": "9",
            "city": "Нижняя Тура",
            "team_name": "«Время первых»",
            "total": "46"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "7",
            "7": "9",
            "city": "Ногинск",
            "team_name": "Зайчатки разума",
            "total": "46"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "2",
            "6": "12",
            "7": "8",
            "city": "Курган",
            "team_name": "Гравицапа",
            "total": "46"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "5",
            "5": "3",
            "6": "10",
            "7": "8",
            "city": "Тель Авив",
            "team_name": "Хатуль Мадан",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "4",
            "4": "2",
            "5": "6",
            "6": "9",
            "7": "8",
            "city": "Борисов",
            "team_name": "Неестественный отбор",
            "total": "46"
        },
        {
            "0": "5",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "2",
            "5": "3",
            "6": "9",
            "7": "8",
            "city": "Обнинск",
            "team_name": "Дело в Юнге ",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "9",
            "4": "2",
            "5": "2",
            "6": "9",
            "7": "8",
            "city": "Минск",
            "team_name": "Радон",
            "total": "46"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "8",
            "city": "Гомель",
            "team_name": "TITIKAKA DREAM",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "2",
            "6": "8",
            "7": "8",
            "city": "Барановичи",
            "team_name": "Крути4еры",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "7",
            "7": "8",
            "city": "Кирово-Чепецк",
            "team_name": "И ежу понятно!",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "2",
            "5": "2",
            "6": "11",
            "7": "7",
            "city": "Иваново",
            "team_name": "Бинго",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "7",
            "city": "Пермь",
            "team_name": "Пытливые умы",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "6",
            "6": "5",
            "7": "7",
            "city": "Магнитогорск",
            "team_name": "Дубовая роща",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "0",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Ставрополь",
            "team_name": "Конюх Федоров",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "2",
            "6": "11",
            "7": "6",
            "city": "Щелково",
            "team_name": "ТНТ",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "5",
            "5": "2",
            "6": "10",
            "7": "6",
            "city": "Пермь",
            "team_name": "Котики в тумане",
            "total": "46"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "2",
            "6": "10",
            "7": "6",
            "city": "Челябинск",
            "team_name": "Ходячие Мудрецы",
            "total": "46"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "6",
            "4": "3",
            "5": "0",
            "6": "10",
            "7": "6",
            "city": "Тула",
            "team_name": "ММММВЖУХ",
            "total": "46"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "6",
            "6": "9",
            "7": "6",
            "city": "Слободской",
            "team_name": "Пятница",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "6",
            "6": "8",
            "7": "6",
            "city": "Пермь",
            "team_name": "Бетон брют",
            "total": "46"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "7",
            "7": "6",
            "city": "Алматы",
            "team_name": "Большой куш",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "1",
            "5": "5",
            "6": "11",
            "7": "5",
            "city": "Омск",
            "team_name": "Николай Матулис. Человек и пароход",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "10",
            "7": "5",
            "city": "Екатеринбург",
            "team_name": "Феличита",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "3",
            "5": "7",
            "6": "9",
            "7": "5",
            "city": "Омутнинск",
            "team_name": "Головастики",
            "total": "46"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "7",
            "6": "9",
            "7": "5",
            "city": "Златоуст",
            "team_name": "А чё мы то ?",
            "total": "46"
        },
        {
            "0": "6",
            "1": "6",
            "2": "3",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "5",
            "city": "Люберцы",
            "team_name": "Хмельбург",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "5",
            "city": "Ижевск",
            "team_name": "Ятъ ",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "2",
            "4": "4",
            "5": "4",
            "6": "14",
            "7": "4",
            "city": "Владимир",
            "team_name": "ГАРАЖ",
            "total": "46"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "4",
            "6": "13",
            "7": "4",
            "city": "Симферополь",
            "team_name": "Дыр-Дыр",
            "total": "46"
        },
        {
            "0": "6",
            "1": "5",
            "2": "2",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "12",
            "7": "4",
            "city": "Ялта",
            "team_name": "Банда-на",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "4",
            "city": "Альметьевск",
            "team_name": "Дон Дигидон",
            "total": "46"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "3",
            "4": "5",
            "5": "3",
            "6": "12",
            "7": "4",
            "city": "Ярославль",
            "team_name": "Том Кукуруз",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "5",
            "5": "6",
            "6": "11",
            "7": "4",
            "city": "Балашиха",
            "team_name": "Инсайт",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "11",
            "7": "4",
            "city": "Гомель",
            "team_name": "Голова2уха",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "10",
            "7": "4",
            "city": "Глазов",
            "team_name": "Алмазная пуля",
            "total": "46"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "9",
            "4": "1",
            "5": "5",
            "6": "10",
            "7": "4",
            "city": "Ташкент",
            "team_name": "Совершенно своя игра",
            "total": "46"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "4",
            "city": "Раменское",
            "team_name": "Туманный альбион",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "4",
            "5": "6",
            "6": "9",
            "7": "4",
            "city": "Витебск",
            "team_name": "Агонь",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "9",
            "7": "4",
            "city": "Березники",
            "team_name": "БезУмно храбрые",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "8",
            "4": "5",
            "5": "3",
            "6": "9",
            "7": "4",
            "city": "Зеленоград",
            "team_name": "КИТО26",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "4",
            "5": "2",
            "6": "9",
            "7": "4",
            "city": "Асбест",
            "team_name": "Колючки",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "6",
            "6": "8",
            "7": "4",
            "city": "Березники",
            "team_name": "YES",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "6",
            "5": "3",
            "6": "8",
            "7": "4",
            "city": "Нефтеюганск",
            "team_name": "Top team",
            "total": "46"
        },
        {
            "0": "5",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "7",
            "7": "4",
            "city": "Бишкек",
            "team_name": "Пусикэтбойс",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "4",
            "6": "7",
            "7": "4",
            "city": "Курган",
            "team_name": "На своей волне",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "5",
            "5": "3",
            "6": "6",
            "7": "4",
            "city": "Туапсе",
            "team_name": "Разумные мЮсли",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "14",
            "7": "3",
            "city": "Санкт-Петербург",
            "team_name": "Команда номер 8",
            "total": "46"
        },
        {
            "0": "5",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "2",
            "6": "11",
            "7": "3",
            "city": "Гродно",
            "team_name": "Бригада имени Орнеллы Мути",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "9",
            "4": "2",
            "5": "6",
            "6": "10",
            "7": "3",
            "city": "Таллин",
            "team_name": "Невротик",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "2",
            "city": "Хельсинки",
            "team_name": "Пипидастр ",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "6",
            "5": "6",
            "6": "11",
            "7": "2",
            "city": "Гомель",
            "team_name": "Лапка геккона",
            "total": "46"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "3",
            "6": "11",
            "7": "2",
            "city": "Белгород",
            "team_name": "Ведмеди",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "10",
            "7": "2",
            "city": "Раменское",
            "team_name": "Ребята с нашего двора",
            "total": "46"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "8",
            "7": "2",
            "city": "Минск",
            "team_name": "`${teamName}`",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "1",
            "city": "Могилев",
            "team_name": "Пяточка Пятачка",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "7",
            "5": "4",
            "6": "8",
            "7": "1",
            "city": "Пермь",
            "team_name": "Хемингуёвина",
            "total": "46"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "12",
            "7": "0",
            "city": "Туапсе",
            "team_name": "Всмысл?",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "0",
            "city": "Ярославль",
            "team_name": "Мозгойоги",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "-1",
            "city": "Пинск",
            "team_name": "Намочи манту",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "6",
            "6": "11",
            "7": "-2",
            "city": "Слободской",
            "team_name": "МысLee",
            "total": "46"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "7",
            "6": "10",
            "7": "-2",
            "city": "Киров",
            "team_name": "ASTраханские арбузы",
            "total": "46"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "6",
            "5": "4",
            "6": "12",
            "7": "-4",
            "city": "Гомель",
            "team_name": "Да Пошло Оно!",
            "total": "46"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "4",
            "6": "5",
            "7": "12",
            "city": "Киев",
            "team_name": "Герасим и пивко",
            "total": "45"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "11",
            "city": "Тель Авив",
            "team_name": "Вчетвером",
            "total": "45"
        },
        {
            "0": "5",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "10",
            "7": "10",
            "city": "Берёзовский",
            "team_name": "Женсовет",
            "total": "45"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "2",
            "6": "9",
            "7": "10",
            "city": "Иркутск",
            "team_name": "Бритва Оккама",
            "total": "45"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "2",
            "5": "3",
            "6": "5",
            "7": "10",
            "city": "Киев",
            "team_name": "Kocmozg",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "2",
            "4": "2",
            "5": "7",
            "6": "7",
            "7": "9",
            "city": "Омутнинск",
            "team_name": "Наша жизнь",
            "total": "45"
        },
        {
            "0": "4",
            "1": "5",
            "2": "7",
            "3": "6",
            "4": "4",
            "5": "3",
            "6": "7",
            "7": "9",
            "city": "Барановичи",
            "team_name": "Фантики",
            "total": "45"
        },
        {
            "0": "3",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "0",
            "5": "3",
            "6": "13",
            "7": "8",
            "city": "Минск",
            "team_name": "Решения масс",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "3",
            "4": "3",
            "5": "4",
            "6": "12",
            "7": "8",
            "city": "Снежинск",
            "team_name": "#яжеговорила",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "10",
            "7": "8",
            "city": "Архангельск",
            "team_name": "Мне только спросить",
            "total": "45"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "2",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "8",
            "city": "Орск",
            "team_name": "И таак сойдёт!",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "-2",
            "5": "3",
            "6": "8",
            "7": "8",
            "city": "Полевской",
            "team_name": "Почему бы и не поиграть",
            "total": "45"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "2",
            "6": "7",
            "7": "8",
            "city": "Ногинск",
            "team_name": "Мантия величия",
            "total": "45"
        },
        {
            "0": "4",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "4",
            "6": "13",
            "7": "7",
            "city": "Редмонд",
            "team_name": "Мозгодранцы",
            "total": "45"
        },
        {
            "0": "4",
            "1": "3",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "1",
            "6": "12",
            "7": "7",
            "city": "Екатеринбург",
            "team_name": "Чуи, мы дома",
            "total": "45"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "2",
            "5": "6",
            "6": "10",
            "7": "7",
            "city": "Архангельск",
            "team_name": "Ложка дёгтя",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "2",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "7",
            "city": "Воронеж",
            "team_name": "Ренегаты",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "0",
            "5": "5",
            "6": "10",
            "7": "7",
            "city": "Минск",
            "team_name": "Крошки в постели",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "7",
            "city": "Обнинск",
            "team_name": "Бесславные Обрезки ",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "7",
            "city": "Кирово-Чепецк",
            "team_name": "Законченный случай",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "7",
            "city": "Екатеринбург",
            "team_name": "Сбежавшие из зоопарка",
            "total": "45"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "5",
            "4": "0",
            "5": "4",
            "6": "12",
            "7": "6",
            "city": "Санкт-Петербург",
            "team_name": "Цезаря убил брют",
            "total": "45"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "2",
            "6": "11",
            "7": "6",
            "city": "Гомель",
            "team_name": "Rammstein",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "8",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Киров",
            "team_name": "За Магадан",
            "total": "45"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "4",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Воронеж",
            "team_name": "Сюткины дети",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "6",
            "city": "Тюмень",
            "team_name": "Ледяные Драконы",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "6",
            "city": "Истра",
            "team_name": "Олд Скул",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "6",
            "city": "Алматы",
            "team_name": "После титров",
            "total": "45"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "8",
            "7": "6",
            "city": "Ижевск",
            "team_name": "КрымскийПятилитровчик ",
            "total": "45"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "1",
            "5": "3",
            "6": "8",
            "7": "6",
            "city": "Химки",
            "team_name": "Лоботомический сад",
            "total": "45"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "7",
            "4": "4",
            "5": "2",
            "6": "8",
            "7": "6",
            "city": "Иваново",
            "team_name": "С образованием только бабы",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "5",
            "6": "7",
            "7": "6",
            "city": "Таганрог",
            "team_name": "Обходящие гору",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "5",
            "city": "Нижний Новгород",
            "team_name": "Мишки-гризли на Средном",
            "total": "45"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "4",
            "5": "3",
            "6": "12",
            "7": "5",
            "city": "Брест",
            "team_name": "Йобибайт",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "2",
            "6": "11",
            "7": "5",
            "city": "Балашиха",
            "team_name": "Дублинская мыловарня",
            "total": "45"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "5",
            "city": "Нефтеюганск",
            "team_name": "Велосипедисты 7 дня",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "4",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "5",
            "city": "Оренбург",
            "team_name": "ЙОШКИН_КОТ ",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "3",
            "4": "3",
            "5": "5",
            "6": "10",
            "7": "5",
            "city": "Воронеж",
            "team_name": "Есть и хуже",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "5",
            "5": "6",
            "6": "9",
            "7": "5",
            "city": "Глазов",
            "team_name": "Дети понедельника",
            "total": "45"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "5",
            "5": "4",
            "6": "9",
            "7": "5",
            "city": "Павловский Посад",
            "team_name": "Грибы и рыбы",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "5",
            "city": "Иваново",
            "team_name": "Экивоки",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "7",
            "7": "5",
            "city": "Белгород",
            "team_name": "Аповторитевопрос?!",
            "total": "45"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "5",
            "7": "5",
            "city": "Пятигорск",
            "team_name": "Экспонента",
            "total": "45"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "13",
            "7": "4",
            "city": "Киров",
            "team_name": "ГОРЛОПАНЫ",
            "total": "45"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "13",
            "7": "4",
            "city": "Туапсе",
            "team_name": "ИК \"Сфера\"",
            "total": "45"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "1",
            "6": "12",
            "7": "4",
            "city": "Снежинск",
            "team_name": "MOZGWANTED",
            "total": "45"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "2",
            "6": "11",
            "7": "4",
            "city": "Ставрополь",
            "team_name": "Надо подумать",
            "total": "45"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "6",
            "5": "5",
            "6": "10",
            "7": "4",
            "city": "Кирово-Чепецк",
            "team_name": "Несём пургу",
            "total": "45"
        },
        {
            "0": "6",
            "1": "6",
            "2": "2",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "4",
            "city": "Владимир",
            "team_name": "F.R.I.E.N.D.S.",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "9",
            "7": "4",
            "city": "Воронеж",
            "team_name": "Дети Йети",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "4",
            "city": "Пинск",
            "team_name": "Explore Uranus",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "5",
            "4": "3",
            "5": "6",
            "6": "8",
            "7": "4",
            "city": "Лида",
            "team_name": "Happy End",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "8",
            "7": "4",
            "city": "Норильск",
            "team_name": "Ржаворонки",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "5",
            "7": "4",
            "city": "Белгород",
            "team_name": "Молодость",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "3",
            "city": "Глазов",
            "team_name": "Квас заказан",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "3",
            "4": "6",
            "5": "3",
            "6": "12",
            "7": "3",
            "city": "Владимир",
            "team_name": "Нам фиолетово",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "1",
            "5": "6",
            "6": "11",
            "7": "3",
            "city": "Владимир",
            "team_name": "Дуй на одуваны",
            "total": "45"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "6",
            "6": "10",
            "7": "3",
            "city": "Обнинск",
            "team_name": "Не те люди",
            "total": "45"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "1",
            "5": "7",
            "6": "9",
            "7": "3",
            "city": "Рязань",
            "team_name": "WD-40",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "7",
            "6": "8",
            "7": "3",
            "city": "Омск",
            "team_name": "Комсомол",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "4",
            "6": "8",
            "7": "3",
            "city": "Каменск-Уральский",
            "team_name": "BrainMix",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "11",
            "7": "2",
            "city": "Лида",
            "team_name": "Окей, google!",
            "total": "45"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "2",
            "city": "Тюмень",
            "team_name": "Команда 206",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "6",
            "6": "10",
            "7": "2",
            "city": "Павловский Посад",
            "team_name": "Петровны",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "5",
            "5": "5",
            "6": "10",
            "7": "2",
            "city": "Витебск",
            "team_name": "Candy Acid",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "2",
            "5": "6",
            "6": "12",
            "7": "1",
            "city": "Златоуст",
            "team_name": "Витаминки",
            "total": "45"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "11",
            "7": "1",
            "city": "Пермь",
            "team_name": "ХЕБА",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "3",
            "6": "12",
            "7": "0",
            "city": "Иркутск",
            "team_name": "Мама отпустила",
            "total": "45"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "5",
            "5": "4",
            "6": "10",
            "7": "0",
            "city": "Архангельск",
            "team_name": "ЧК",
            "total": "45"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "2",
            "5": "5",
            "6": "11",
            "7": "-2",
            "city": "Гродно",
            "team_name": "Ракамакафо",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "6",
            "5": "4",
            "6": "10",
            "7": "-3",
            "city": "Ростов на Дону",
            "team_name": "M&M's",
            "total": "45"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "-1",
            "5": "5",
            "6": "8",
            "7": "10",
            "city": "Челябинск",
            "team_name": "Лидеры России",
            "total": "44"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "2",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "9",
            "city": "Слободской",
            "team_name": "УиУ",
            "total": "44"
        },
        {
            "0": "5",
            "1": "6",
            "2": "3",
            "3": "7",
            "4": "1",
            "5": "3",
            "6": "11",
            "7": "8",
            "city": "Ковров",
            "team_name": "Чёрный бумер",
            "total": "44"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "0",
            "5": "3",
            "6": "11",
            "7": "8",
            "city": "Альметьевск",
            "team_name": "Солянка",
            "total": "44"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "2",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "8",
            "city": "Реж",
            "team_name": "Непростая команда",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "4",
            "5": "2",
            "6": "9",
            "7": "8",
            "city": "Киров",
            "team_name": "#НичеНеСмущает!?",
            "total": "44"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "5",
            "5": "3",
            "6": "6",
            "7": "8",
            "city": "Барнаул",
            "team_name": "Yuppi",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "2",
            "5": "5",
            "6": "4",
            "7": "8",
            "city": "Киев",
            "team_name": "ООО «Зеленоглазое такси»",
            "total": "44"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "3",
            "4": "5",
            "5": "4",
            "6": "9",
            "7": "7",
            "city": "Снежинск",
            "team_name": "Нови4ок",
            "total": "44"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "7",
            "7": "7",
            "city": "Полевской",
            "team_name": "Давайте короче",
            "total": "44"
        },
        {
            "0": "6",
            "1": "7",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "6",
            "7": "7",
            "city": "Челябинск",
            "team_name": "Играй гормон",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "4",
            "6": "5",
            "7": "7",
            "city": "Домодедово",
            "team_name": "Мозговой шторм",
            "total": "44"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "2",
            "4": "1",
            "5": "3",
            "6": "13",
            "7": "6",
            "city": "Орск",
            "team_name": "Ассорти",
            "total": "44"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "6",
            "city": "Красногорск",
            "team_name": "НеКвартет",
            "total": "44"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "3",
            "4": "4",
            "5": "2",
            "6": "12",
            "7": "6",
            "city": "Лида",
            "team_name": "Старик Хоттабыч",
            "total": "44"
        },
        {
            "0": "6",
            "1": "3",
            "2": "4",
            "3": "6",
            "4": "1",
            "5": "7",
            "6": "11",
            "7": "6",
            "city": "Тампере",
            "team_name": "Априори Оптимисты",
            "total": "44"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "2",
            "4": "3",
            "5": "5",
            "6": "11",
            "7": "6",
            "city": "Омутнинск",
            "team_name": "LetsГОУ",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "4",
            "4": "1",
            "5": "2",
            "6": "11",
            "7": "6",
            "city": "Кострома",
            "team_name": "Интеллектуальное меньшинство",
            "total": "44"
        },
        {
            "0": "5",
            "1": "6",
            "2": "3",
            "3": "4",
            "4": "4",
            "5": "6",
            "6": "10",
            "7": "6",
            "city": "Раменское",
            "team_name": "Пуп земли",
            "total": "44"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "3",
            "6": "10",
            "7": "6",
            "city": "Архангельск",
            "team_name": "Эщкере",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "3",
            "6": "10",
            "7": "6",
            "city": "Каменск-Уральский",
            "team_name": "Компот",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "3",
            "5": "2",
            "6": "10",
            "7": "6",
            "city": "Северодвинск",
            "team_name": "Есть мЫслЯ",
            "total": "44"
        },
        {
            "0": "4",
            "1": "6",
            "2": "4",
            "3": "4",
            "4": "4",
            "5": "7",
            "6": "9",
            "7": "6",
            "city": "Вольск",
            "team_name": "Доктор Зло",
            "total": "44"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "3",
            "4": "5",
            "5": "6",
            "6": "9",
            "7": "6",
            "city": "Гомель",
            "team_name": "Two Pizza",
            "total": "44"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "2",
            "5": "6",
            "6": "9",
            "7": "6",
            "city": "Борисов",
            "team_name": "#смирись",
            "total": "44"
        },
        {
            "0": "6",
            "1": "4",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Киров",
            "team_name": "Зато красивые",
            "total": "44"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "9",
            "7": "6",
            "city": "Нижний Новгород",
            "team_name": "Господин Барщевский",
            "total": "44"
        },
        {
            "0": "6",
            "1": "4",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "2",
            "6": "9",
            "7": "6",
            "city": "Ялта",
            "team_name": "Красногубый Жерех",
            "total": "44"
        },
        {
            "0": "7",
            "1": "4",
            "2": "3",
            "3": "8",
            "4": "1",
            "5": "7",
            "6": "8",
            "7": "6",
            "city": "Серпухов",
            "team_name": "Три колена",
            "total": "44"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "9",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "6",
            "city": "Омск",
            "team_name": "Borat",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "1",
            "5": "6",
            "6": "7",
            "7": "6",
            "city": "Норильск",
            "team_name": "ФеникС",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "5",
            "7": "6",
            "city": "Барановичи",
            "team_name": "Синдром Дориана Грея",
            "total": "44"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "4",
            "7": "6",
            "city": "Киев",
            "team_name": "Клуб Почитателей Олега Винника",
            "total": "44"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "6",
            "5": "3",
            "6": "4",
            "7": "6",
            "city": "Киев",
            "team_name": "Fibonacci",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "1",
            "5": "5",
            "6": "10",
            "7": "5",
            "city": "Первоуральск",
            "team_name": "Обратная сторона колена",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "9",
            "7": "5",
            "city": "Омск",
            "team_name": "Баба Яга против!",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "5",
            "city": "Архангельск",
            "team_name": "Мохнатый шмель",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "9",
            "7": "5",
            "city": "Снежинск",
            "team_name": "#Шляпа",
            "total": "44"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "5",
            "city": "Белгород",
            "team_name": "Те еще умники",
            "total": "44"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "2",
            "5": "4",
            "6": "7",
            "7": "5",
            "city": "Иваново",
            "team_name": "Паратрупер",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "1",
            "5": "6",
            "6": "10",
            "7": "4",
            "city": "Ярославль",
            "team_name": "AllХимики",
            "total": "44"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "2",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "4",
            "city": "Туапсе",
            "team_name": "No name",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "10",
            "7": "4",
            "city": "Балашиха",
            "team_name": "Жирафы",
            "total": "44"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "3",
            "6": "10",
            "7": "4",
            "city": "Ухта",
            "team_name": "Потомушто Гладиолус",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "4",
            "5": "2",
            "6": "10",
            "7": "4",
            "city": "Омск",
            "team_name": "Интригалы",
            "total": "44"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "9",
            "7": "4",
            "city": "Могилев",
            "team_name": "Кирзовый штрудель",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "5",
            "5": "4",
            "6": "9",
            "7": "4",
            "city": "Первоуральск",
            "team_name": "Ноги - не главное",
            "total": "44"
        },
        {
            "0": "6",
            "1": "5",
            "2": "7",
            "3": "5",
            "4": "5",
            "5": "3",
            "6": "9",
            "7": "4",
            "city": "Екатеринбург",
            "team_name": "G-гурда",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "3",
            "6": "9",
            "7": "4",
            "city": "Альметьевск",
            "team_name": "2Кай",
            "total": "44"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "2",
            "6": "9",
            "7": "4",
            "city": "Киров",
            "team_name": "Саботёры",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "5",
            "4": "6",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Северодвинск",
            "team_name": "Плавки металлурга",
            "total": "44"
        },
        {
            "0": "7",
            "1": "3",
            "2": "6",
            "3": "9",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Алматы",
            "team_name": "Жұрттың баласы",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Балашиха",
            "team_name": "Бюст Всемогущий!",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Архангельск",
            "team_name": "Восток 1 на орбите",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Москва",
            "team_name": "Черствы потравины",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Киров",
            "team_name": "Вятские ребята",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Балашиха",
            "team_name": "Ой, всё!!!",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "7",
            "7": "4",
            "city": "Киров",
            "team_name": "И так сойдёт",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "5",
            "5": "4",
            "6": "7",
            "7": "4",
            "city": "Нижний Новгород",
            "team_name": "Пёс да лис",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "9",
            "4": "3",
            "5": "3",
            "6": "11",
            "7": "3",
            "city": "Омск",
            "team_name": "Здрасьте, забор покрасьте!",
            "total": "44"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "1",
            "5": "3",
            "6": "11",
            "7": "3",
            "city": "Ставрополь",
            "team_name": "Family brains",
            "total": "44"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "1",
            "5": "6",
            "6": "10",
            "7": "3",
            "city": "Кропоткин",
            "team_name": "Адаптация",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "6",
            "4": "1",
            "5": "5",
            "6": "9",
            "7": "3",
            "city": "Архангельск",
            "team_name": "Братство винца",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "9",
            "7": "3",
            "city": "Брест",
            "team_name": "Розум, логіка, кабеты",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "5",
            "5": "3",
            "6": "9",
            "7": "3",
            "city": "Санкт-Петербург",
            "team_name": "подСПАЙС ГЁРЛС",
            "total": "44"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "7",
            "6": "8",
            "7": "3",
            "city": "Санкт-Петербург",
            "team_name": "Наступны прыпынак",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "3",
            "city": "Каменск-Уральский",
            "team_name": "Бьюти фри",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "3",
            "6": "8",
            "7": "3",
            "city": "Санкт-Петербург",
            "team_name": "Эксельсиор",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "5",
            "6": "12",
            "7": "2",
            "city": "Архангельск",
            "team_name": "Кудаяпопала",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "5",
            "6": "12",
            "7": "2",
            "city": "Омск",
            "team_name": "Попадем в десятку",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "11",
            "7": "2",
            "city": "Екатеринбург",
            "team_name": "Реюнион",
            "total": "44"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "4",
            "6": "11",
            "7": "2",
            "city": "Архангельск",
            "team_name": "Адмирал и Geisha",
            "total": "44"
        },
        {
            "0": "6",
            "1": "6",
            "2": "3",
            "3": "7",
            "4": "3",
            "5": "7",
            "6": "10",
            "7": "2",
            "city": "Пинск",
            "team_name": "Солдаты неудачи",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "6",
            "6": "10",
            "7": "2",
            "city": "Борисов",
            "team_name": "Банда Командира",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "-1",
            "5": "5",
            "6": "10",
            "7": "2",
            "city": "Могилев",
            "team_name": "Фэйс в бук",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "2",
            "5": "7",
            "6": "9",
            "7": "2",
            "city": "Первоуральск",
            "team_name": "Капитанская почка",
            "total": "44"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "2",
            "city": "Владимир",
            "team_name": "Секрет Полишинеля",
            "total": "44"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "8",
            "4": "2",
            "5": "7",
            "6": "7",
            "7": "2",
            "city": "Санкт-Петербург",
            "team_name": "ПНХ",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "7",
            "7": "2",
            "city": "Бобруйск",
            "team_name": "Куртка Бейна",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "5",
            "4": "2",
            "5": "5",
            "6": "11",
            "7": "1",
            "city": "Минск",
            "team_name": "Виновата - Даша!",
            "total": "44"
        },
        {
            "0": "5",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "5",
            "5": "2",
            "6": "10",
            "7": "1",
            "city": "Реж",
            "team_name": "Банзай",
            "total": "44"
        },
        {
            "0": "6",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "9",
            "7": "1",
            "city": "Воронеж",
            "team_name": "Умпы-Лумпы",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "4",
            "6": "9",
            "7": "1",
            "city": "Воронеж",
            "team_name": "Квизард",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "4",
            "5": "5",
            "6": "8",
            "7": "0",
            "city": "Пинск",
            "team_name": "Всем полярный лис",
            "total": "44"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "12",
            "7": "-1",
            "city": "Санкт-Петербург",
            "team_name": "Хороший, плохой, глухой",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "11",
            "7": "-2",
            "city": "Омск",
            "team_name": "Поцелуй Брежнева",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "13",
            "7": "-3",
            "city": "Первоуральск",
            "team_name": "Никурица",
            "total": "44"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "9",
            "4": "3",
            "5": "6",
            "6": "10",
            "7": "-4",
            "city": "Барнаул",
            "team_name": "Тютельки",
            "total": "44"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "6",
            "4": "1",
            "5": "1",
            "6": "10",
            "7": "10",
            "city": "Тула",
            "team_name": "Глазовыколупыватели",
            "total": "43"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "0",
            "5": "4",
            "6": "10",
            "7": "9",
            "city": "Глазов",
            "team_name": "Нечего терять",
            "total": "43"
        },
        {
            "0": "5",
            "1": "2",
            "2": "4",
            "3": "5",
            "4": "3",
            "5": "7",
            "6": "9",
            "7": "8",
            "city": "Омутнинск",
            "team_name": "Мстители",
            "total": "43"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "2",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "7",
            "city": "Курган",
            "team_name": "Игры разума",
            "total": "43"
        },
        {
            "0": "4",
            "1": "4",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "5",
            "6": "10",
            "7": "7",
            "city": "Тель Авив",
            "team_name": "ЧутьЧутьЧачи",
            "total": "43"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "9",
            "4": "-1",
            "5": "4",
            "6": "9",
            "7": "7",
            "city": "Минск",
            "team_name": "Абажур",
            "total": "43"
        },
        {
            "0": "6",
            "1": "6",
            "2": "2",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "10",
            "7": "6",
            "city": "Челябинск",
            "team_name": "Эйяфьядлайёкюдль",
            "total": "43"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "6",
            "city": "Архангельск",
            "team_name": "Малиновый Фламинго",
            "total": "43"
        },
        {
            "0": "2",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "2",
            "5": "3",
            "6": "10",
            "7": "6",
            "city": "Ташкент",
            "team_name": "Дела Семейные",
            "total": "43"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "2",
            "5": "5",
            "6": "9",
            "7": "6",
            "city": "Берёзовский",
            "team_name": "Грачи улетели",
            "total": "43"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "2",
            "5": "3",
            "6": "9",
            "7": "6",
            "city": "Обнинск",
            "team_name": "Большая компания ",
            "total": "43"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "5",
            "4": "4",
            "5": "6",
            "6": "8",
            "7": "6",
            "city": "Киров",
            "team_name": "220 Вольт",
            "total": "43"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "6",
            "city": "Люберцы",
            "team_name": "Ребята с нашего двора",
            "total": "43"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "3",
            "5": "1",
            "6": "7",
            "7": "6",
            "city": "Тула",
            "team_name": "#ТВПС",
            "total": "43"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "7",
            "4": "2",
            "5": "6",
            "6": "6",
            "7": "6",
            "city": "Минск",
            "team_name": "Перлиукоги",
            "total": "43"
        },
        {
            "0": "6",
            "1": "7",
            "2": "7",
            "3": "7",
            "4": "1",
            "5": "3",
            "6": "6",
            "7": "6",
            "city": "Нижний Новгород",
            "team_name": "КружОК ВатникOFF",
            "total": "43"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "2",
            "5": "5",
            "6": "11",
            "7": "5",
            "city": "Новокубанск",
            "team_name": "Банда",
            "total": "43"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "4",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "5",
            "city": "Таганрог",
            "team_name": "Джонджоли",
            "total": "43"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "10",
            "7": "5",
            "city": "Омск",
            "team_name": "Let's do IT",
            "total": "43"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "5",
            "city": "Краснотурьинск",
            "team_name": "Mrs. Hudson",
            "total": "43"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "5",
            "5": "3",
            "6": "8",
            "7": "5",
            "city": "Полевской",
            "team_name": "Енот в лесу в декабре",
            "total": "43"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "1",
            "5": "6",
            "6": "10",
            "7": "4",
            "city": "Пинск",
            "team_name": "Пи Здесь",
            "total": "43"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "10",
            "7": "4",
            "city": "Омск",
            "team_name": "Гордые ребята",
            "total": "43"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "4",
            "city": "Северодвинск",
            "team_name": "ЗАТО КРАСИВЫЕ",
            "total": "43"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "9",
            "7": "4",
            "city": "Челябинск",
            "team_name": "Весёлые биопсийки!",
            "total": "43"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "5",
            "6": "8",
            "7": "4",
            "city": "Кирово-Чепецк",
            "team_name": "Даёшь леща",
            "total": "43"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "6",
            "6": "6",
            "7": "4",
            "city": "Кострома",
            "team_name": "Все будет СБИС",
            "total": "43"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "3",
            "4": "4",
            "5": "3",
            "6": "11",
            "7": "3",
            "city": "Пинск",
            "team_name": "Дабл Ѣ",
            "total": "43"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "3",
            "city": "Новокубанск",
            "team_name": "Пьяный расчёт",
            "total": "43"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "10",
            "7": "3",
            "city": "Глазов",
            "team_name": "Потому что гладиолус",
            "total": "43"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "6",
            "6": "9",
            "7": "3",
            "city": "Витебск",
            "team_name": "Inside Out",
            "total": "43"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "6",
            "6": "9",
            "7": "3",
            "city": "Челябинск",
            "team_name": "Контур головного мозга",
            "total": "43"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "2",
            "4": "2",
            "5": "6",
            "6": "12",
            "7": "2",
            "city": "Североуральск",
            "team_name": "Внуки ГУЛЛЛИВЕРА",
            "total": "43"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "11",
            "7": "2",
            "city": "Таллин",
            "team_name": "Гречка Inc.",
            "total": "43"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "3",
            "6": "11",
            "7": "2",
            "city": "Кирово-Чепецк",
            "team_name": "Ляськи-мосяськи",
            "total": "43"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "10",
            "7": "2",
            "city": "Пермь",
            "team_name": "ТиС",
            "total": "43"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "10",
            "7": "2",
            "city": "Екатеринбург",
            "team_name": "Шнобелевские лаурята",
            "total": "43"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "2",
            "city": "Киров",
            "team_name": "Прошнуровано, пронумеровано",
            "total": "43"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "6",
            "4": "5",
            "5": "2",
            "6": "9",
            "7": "2",
            "city": "Глазов",
            "team_name": "Мозгарики",
            "total": "43"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "2",
            "city": "Гродно",
            "team_name": "Свингер Пеппа",
            "total": "43"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "5",
            "6": "7",
            "7": "2",
            "city": "Пермь",
            "team_name": "Пофиг, регай!",
            "total": "43"
        },
        {
            "0": "5",
            "1": "7",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "2",
            "6": "11",
            "7": "1",
            "city": "Киров",
            "team_name": "СГФ",
            "total": "43"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "8",
            "4": "5",
            "5": "1",
            "6": "10",
            "7": "1",
            "city": "Минск",
            "team_name": "Фатагагуль",
            "total": "43"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "5",
            "5": "5",
            "6": "5",
            "7": "1",
            "city": "Киев",
            "team_name": "Не ЗОЖ на Лабутенах",
            "total": "43"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "5",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "0",
            "city": "Петрозаводск",
            "team_name": "Фантастические твари",
            "total": "43"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "0",
            "city": "Алматы",
            "team_name": "No Onion",
            "total": "43"
        },
        {
            "0": "7",
            "1": "7",
            "2": "7",
            "3": "8",
            "4": "1",
            "5": "5",
            "6": "8",
            "7": "0",
            "city": "Брест",
            "team_name": "Сеня, дичь!",
            "total": "43"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "0",
            "city": "Витебск",
            "team_name": "Инфузория в туфельку",
            "total": "43"
        },
        {
            "0": "6",
            "1": "7",
            "2": "4",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "11",
            "7": "-2",
            "city": "Слободской",
            "team_name": "Жуки",
            "total": "43"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "9",
            "4": "2",
            "5": "4",
            "6": "12",
            "7": "-4",
            "city": "Челябинск",
            "team_name": "Мозголомы",
            "total": "43"
        },
        {
            "0": "4",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "3",
            "6": "3",
            "7": "12",
            "city": "Киев",
            "team_name": "Клуб Почитателей Павла Зиброва",
            "total": "42"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "2",
            "5": "1",
            "6": "11",
            "7": "10",
            "city": "Норильск",
            "team_name": "Темные лошадки",
            "total": "42"
        },
        {
            "0": "5",
            "1": "2",
            "2": "4",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "10",
            "city": "Алматы",
            "team_name": "Консорциум",
            "total": "42"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "1",
            "5": "6",
            "6": "5",
            "7": "10",
            "city": "Пятигорск",
            "team_name": "Не модные",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "6",
            "4": "2",
            "5": "2",
            "6": "7",
            "7": "9",
            "city": "Иваново",
            "team_name": "УРР",
            "total": "42"
        },
        {
            "0": "3",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "10",
            "7": "8",
            "city": "Тель Авив",
            "team_name": "Отцы и дети",
            "total": "42"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "2",
            "6": "9",
            "7": "8",
            "city": "Ногинск",
            "team_name": "Мозголомы",
            "total": "42"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "3",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "8",
            "city": "Каменск-Уральский",
            "team_name": "Крокодилы",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "2",
            "5": "3",
            "6": "8",
            "7": "8",
            "city": "Чайковский",
            "team_name": "Грильяж",
            "total": "42"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "4",
            "5": "4",
            "6": "7",
            "7": "8",
            "city": "Берёзовский",
            "team_name": "Здесь и сейчас",
            "total": "42"
        },
        {
            "0": "4",
            "1": "5",
            "2": "4",
            "3": "2",
            "4": "3",
            "5": "5",
            "6": "12",
            "7": "7",
            "city": "Хельсинки",
            "team_name": "ПоFINNтроллим ",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "2",
            "4": "1",
            "5": "6",
            "6": "9",
            "7": "7",
            "city": "Бишкек",
            "team_name": "Нави в грандфинале",
            "total": "42"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "5",
            "6": "5",
            "7": "7",
            "city": "Пинск",
            "team_name": "ВСЕ СВОИ",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "-2",
            "5": "5",
            "6": "9",
            "7": "6",
            "city": "Ставрополь",
            "team_name": "Палата #205",
            "total": "42"
        },
        {
            "0": "5",
            "1": "7",
            "2": "5",
            "3": "2",
            "4": "4",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Реж",
            "team_name": "Второе дыхание",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Щелково",
            "team_name": "Всё по-честному!",
            "total": "42"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Чернигов",
            "team_name": "Витамин Д",
            "total": "42"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Витебск",
            "team_name": "Имитация сарказма",
            "total": "42"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "9",
            "7": "6",
            "city": "Нефтеюганск",
            "team_name": "Ума палата",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "1",
            "6": "9",
            "7": "6",
            "city": "Екатеринбург",
            "team_name": "Оргия на кровати у Георгия",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "0",
            "5": "5",
            "6": "8",
            "7": "6",
            "city": "Санкт-Петербург",
            "team_name": "Печеньки Шелдона",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "6",
            "city": "Королев",
            "team_name": "Еноты опосля",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "0",
            "5": "3",
            "6": "8",
            "7": "6",
            "city": "Кирово-Чепецк",
            "team_name": "Копыто инженера",
            "total": "42"
        },
        {
            "0": "7",
            "1": "4",
            "2": "7",
            "3": "8",
            "4": "2",
            "5": "2",
            "6": "6",
            "7": "6",
            "city": "Снежинск",
            "team_name": "Акуна-Матата",
            "total": "42"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "3",
            "7": "6",
            "city": "Пятигорск",
            "team_name": "ИнQUIZиция",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "3",
            "5": "1",
            "6": "9",
            "7": "5",
            "city": "Полевской",
            "team_name": "С мужикON",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "4",
            "5": "4",
            "6": "7",
            "7": "5",
            "city": "Киров",
            "team_name": "Совы",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "7",
            "7": "5",
            "city": "Полевской",
            "team_name": "Он сказал поехали",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "7",
            "7": "5",
            "city": "Хельсинки",
            "team_name": "Неадекватные ЛюЛи ",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "6",
            "4": "4",
            "5": "6",
            "6": "6",
            "7": "5",
            "city": "Пермь",
            "team_name": "Выше головы",
            "total": "42"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "2",
            "5": "3",
            "6": "13",
            "7": "4",
            "city": "Хельсинки",
            "team_name": "Внуки капитана Врунгеля ",
            "total": "42"
        },
        {
            "0": "5",
            "1": "4",
            "2": "4",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "12",
            "7": "4",
            "city": "Гродно",
            "team_name": "Будет отвечать Друзь!",
            "total": "42"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "4",
            "city": "Симферополь",
            "team_name": "Крепкий орешек",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "1",
            "5": "5",
            "6": "10",
            "7": "4",
            "city": "Петрозаводск",
            "team_name": "Как так то?",
            "total": "42"
        },
        {
            "0": "5",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "4",
            "5": "6",
            "6": "9",
            "7": "4",
            "city": "Туапсе",
            "team_name": "Sapere Aude",
            "total": "42"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "4",
            "city": "Петрозаводск",
            "team_name": "В споре рождается истина",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "1",
            "5": "5",
            "6": "8",
            "7": "4",
            "city": "Владимир",
            "team_name": "Николай и Лалилалай",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Раменское",
            "team_name": "Болт",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "5",
            "5": "4",
            "6": "7",
            "7": "4",
            "city": "Архангельск",
            "team_name": "Ты не прав!",
            "total": "42"
        },
        {
            "0": "7",
            "1": "3",
            "2": "7",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "7",
            "7": "4",
            "city": "Ногинск",
            "team_name": "Потрещим с Гейгером",
            "total": "42"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "4",
            "4": "0",
            "5": "6",
            "6": "12",
            "7": "3",
            "city": "Первоуральск",
            "team_name": "Последняя парта",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "3",
            "6": "11",
            "7": "3",
            "city": "Таганрог",
            "team_name": "Intspirit",
            "total": "42"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "3",
            "city": "Первоуральск",
            "team_name": "Не тут-то было",
            "total": "42"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "6",
            "4": "-1",
            "5": "7",
            "6": "9",
            "7": "3",
            "city": "Тюмень",
            "team_name": "Юджин объяснит.",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "6",
            "4": "2",
            "5": "6",
            "6": "9",
            "7": "3",
            "city": "Златоуст",
            "team_name": "Сова",
            "total": "42"
        },
        {
            "0": "4",
            "1": "5",
            "2": "7",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "3",
            "city": "Гомель",
            "team_name": "Дети маминой подруги",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "9",
            "7": "3",
            "city": "Рязань",
            "team_name": "троянский понь",
            "total": "42"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "2",
            "6": "9",
            "7": "3",
            "city": "Архангельск",
            "team_name": "Mari и Я",
            "total": "42"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "8",
            "7": "3",
            "city": "Владимир",
            "team_name": "Да Но Не",
            "total": "42"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "3",
            "city": "Симферополь",
            "team_name": "Посторонним В",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "3",
            "city": "Воронеж",
            "team_name": "Арбузные дольки",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "6",
            "7": "3",
            "city": "Петрозаводск",
            "team_name": "Сальвадор",
            "total": "42"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "0",
            "5": "4",
            "6": "13",
            "7": "2",
            "city": "Ставрополь",
            "team_name": "Вот и Оля",
            "total": "42"
        },
        {
            "0": "4",
            "1": "6",
            "2": "3",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "2",
            "city": "Минск",
            "team_name": "Братство винца",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "2",
            "4": "5",
            "5": "3",
            "6": "11",
            "7": "2",
            "city": "Киров",
            "team_name": "59.43 градуса по Кониплотино",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "1",
            "5": "4",
            "6": "9",
            "7": "2",
            "city": "Каменск-Уральский",
            "team_name": "Тише, Маши, я Дубровский",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "8",
            "7": "2",
            "city": "Барнаул",
            "team_name": "The БС",
            "total": "42"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "7",
            "7": "2",
            "city": "Екатеринбург",
            "team_name": "Мы будем тупить быстрее!",
            "total": "42"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "7",
            "6": "5",
            "7": "2",
            "city": "Пятигорск",
            "team_name": "Печеньки",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "1",
            "5": "6",
            "6": "5",
            "7": "2",
            "city": "Пятигорск",
            "team_name": "Adidas",
            "total": "42"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "8",
            "4": "2",
            "5": "6",
            "6": "7",
            "7": "1",
            "city": "Истра",
            "team_name": "Купер Холл",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "4",
            "5": "4",
            "6": "7",
            "7": "1",
            "city": "Пермь",
            "team_name": "Корова, которая поймала ветер",
            "total": "42"
        },
        {
            "0": "6",
            "1": "7",
            "2": "4",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "11",
            "7": "0",
            "city": "Владимир",
            "team_name": "ДЕМЕНЦИЯ БЛИЗКО",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "5",
            "5": "4",
            "6": "10",
            "7": "0",
            "city": "Брест",
            "team_name": "Веселые ребята",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "2",
            "6": "10",
            "7": "0",
            "city": "Северодвинск",
            "team_name": "Тараканы варят борщ",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "0",
            "city": "Санкт-Петербург",
            "team_name": "Кафка",
            "total": "42"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "3",
            "5": "7",
            "6": "8",
            "7": "0",
            "city": "Раменское",
            "team_name": "Коварные улитки",
            "total": "42"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "7",
            "7": "0",
            "city": "Омск",
            "team_name": "Подскочим-побормочем",
            "total": "42"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "3",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "11",
            "city": "Екатеринбург",
            "team_name": "Ветер в голове, а мы в игре!",
            "total": "41"
        },
        {
            "0": "3",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "2",
            "5": "3",
            "6": "10",
            "7": "9",
            "city": "Берёзовский",
            "team_name": "#яеебалую",
            "total": "41"
        },
        {
            "0": "6",
            "1": "4",
            "2": "6",
            "3": "2",
            "4": "3",
            "5": "4",
            "6": "7",
            "7": "9",
            "city": "Гомель",
            "team_name": "Не злите леди",
            "total": "41"
        },
        {
            "0": "4",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "4",
            "5": "4",
            "6": "4",
            "7": "9",
            "city": "Пятигорск",
            "team_name": "Кумовья и Витя",
            "total": "41"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "2",
            "5": "3",
            "6": "9",
            "7": "8",
            "city": "Норильск",
            "team_name": "Ежу понятно",
            "total": "41"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "2",
            "4": "2",
            "5": "3",
            "6": "11",
            "7": "7",
            "city": "Иваново",
            "team_name": "Дай ей шанс",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "2",
            "4": "1",
            "5": "3",
            "6": "9",
            "7": "7",
            "city": "Тюмень",
            "team_name": "Слабоумие и отвага",
            "total": "41"
        },
        {
            "0": "3",
            "1": "4",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "7",
            "city": "Хельсинки",
            "team_name": "Охотники за Удачей ",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "6",
            "4": "1",
            "5": "5",
            "6": "7",
            "7": "7",
            "city": "Севастополь",
            "team_name": "Пациенты доктора Хауса",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "9",
            "4": "1",
            "5": "4",
            "6": "5",
            "7": "7",
            "city": "Полевской",
            "team_name": "Ребята!",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "4",
            "7": "7",
            "city": "Магнитогорск",
            "team_name": "Самый сок",
            "total": "41"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "1",
            "5": "4",
            "6": "11",
            "7": "6",
            "city": "Владимир",
            "team_name": "Суздальские огурцы",
            "total": "41"
        },
        {
            "0": "2",
            "1": "6",
            "2": "6",
            "3": "2",
            "4": "5",
            "5": "4",
            "6": "10",
            "7": "6",
            "city": "Санкт-Петербург",
            "team_name": "ОНлИ",
            "total": "41"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "3",
            "5": "2",
            "6": "10",
            "7": "6",
            "city": "Асбест",
            "team_name": "4 не танкиста",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "2",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Севастополь",
            "team_name": "Свежий ветер",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "0",
            "5": "3",
            "6": "9",
            "7": "6",
            "city": "Кемерово",
            "team_name": "4ума",
            "total": "41"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "2",
            "4": "1",
            "5": "4",
            "6": "8",
            "7": "6",
            "city": "Петрозаводск",
            "team_name": "Не Эрмитаж",
            "total": "41"
        },
        {
            "0": "5",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "8",
            "7": "6",
            "city": "Кострома",
            "team_name": "Джим Бим",
            "total": "41"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "5",
            "5": "3",
            "6": "7",
            "7": "6",
            "city": "Слободской",
            "team_name": "Родня",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "2",
            "5": "3",
            "6": "7",
            "7": "6",
            "city": "Челябинск",
            "team_name": "Паноптикум",
            "total": "41"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "1",
            "5": "2",
            "6": "7",
            "7": "6",
            "city": "Великий Новгород",
            "team_name": "Идея Фикс",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "1",
            "5": "2",
            "6": "9",
            "7": "5",
            "city": "Тула",
            "team_name": "Зато красивые!",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "5",
            "city": "Иваново",
            "team_name": "Накипело!",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "5",
            "city": "Иваново",
            "team_name": "Нержавое ведро",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "8",
            "7": "5",
            "city": "Сургут",
            "team_name": "АО друзья Друзья",
            "total": "41"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "8",
            "7": "5",
            "city": "Тампа",
            "team_name": "Лига превосходства",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "6",
            "6": "4",
            "7": "5",
            "city": "Пятигорск",
            "team_name": "Провизоры",
            "total": "41"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "2",
            "5": "5",
            "6": "10",
            "7": "4",
            "city": "Петрозаводск",
            "team_name": "Парадигма",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "4",
            "5": "1",
            "6": "10",
            "7": "4",
            "city": "Слободской",
            "team_name": "Эйяфьядлайёкюдль",
            "total": "41"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "4",
            "city": "Орехово-Зуево",
            "team_name": "Плечо",
            "total": "41"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "1",
            "5": "4",
            "6": "9",
            "7": "4",
            "city": "Раменское",
            "team_name": "Пальцем в небо",
            "total": "41"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "9",
            "7": "4",
            "city": "Молодечно",
            "team_name": "Мозгойоги",
            "total": "41"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "3",
            "6": "9",
            "7": "4",
            "city": "Киров",
            "team_name": "БДСМ",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Владимир",
            "team_name": "Никтонепротив",
            "total": "41"
        },
        {
            "0": "5",
            "1": "4",
            "2": "4",
            "3": "9",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Екатеринбург",
            "team_name": "Могучая кучка",
            "total": "41"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Омутнинск",
            "team_name": "ШИК",
            "total": "41"
        },
        {
            "0": "3",
            "1": "7",
            "2": "5",
            "3": "9",
            "4": "3",
            "5": "2",
            "6": "8",
            "7": "4",
            "city": "Владимир",
            "team_name": "Другая команда",
            "total": "41"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "5",
            "5": "5",
            "6": "7",
            "7": "4",
            "city": "Асбест",
            "team_name": "Реальные кабаны",
            "total": "41"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "7",
            "7": "4",
            "city": "Гомель",
            "team_name": "Люди в черном и Дима",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "7",
            "7": "4",
            "city": "Ярославль",
            "team_name": "Стреляем вместе",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "1",
            "5": "6",
            "6": "6",
            "7": "4",
            "city": "Барнаул",
            "team_name": "Медуза Гордона",
            "total": "41"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "1",
            "5": "3",
            "6": "13",
            "7": "3",
            "city": "Турку",
            "team_name": "Колонизаторы",
            "total": "41"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "9",
            "7": "3",
            "city": "Краснотурьинск",
            "team_name": "Барсучий случай",
            "total": "41"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "1",
            "5": "2",
            "6": "9",
            "7": "3",
            "city": "Северодвинск",
            "team_name": "Пациент 120",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "3",
            "6": "8",
            "7": "3",
            "city": "Люберцы",
            "team_name": "Извилина",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "3",
            "6": "7",
            "7": "3",
            "city": "Екатеринбург",
            "team_name": "Chuslake",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "4",
            "5": "3",
            "6": "11",
            "7": "2",
            "city": "Киров",
            "team_name": "Играть-копать",
            "total": "41"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "3",
            "6": "11",
            "7": "2",
            "city": "Гомель",
            "team_name": "Бар \"Голубая устрица\"",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "3",
            "6": "10",
            "7": "2",
            "city": "Хельсинки",
            "team_name": "Козырные Остырьки ",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "2",
            "city": "Кирово-Чепецк",
            "team_name": "Борщ",
            "total": "41"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "8",
            "4": "1",
            "5": "4",
            "6": "9",
            "7": "2",
            "city": "Курган",
            "team_name": "Зато красивые",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "2",
            "city": "Ижевск",
            "team_name": "Вариант ",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "0",
            "5": "6",
            "6": "7",
            "7": "2",
            "city": "Пенза",
            "team_name": "Из одного места!",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "4",
            "6": "7",
            "7": "2",
            "city": "Омск",
            "team_name": "#SHER",
            "total": "41"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "10",
            "7": "1",
            "city": "Северодвинск",
            "team_name": "Мы не отцы, вы не дети",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "4",
            "4": "3",
            "5": "3",
            "6": "10",
            "7": "1",
            "city": "Омск",
            "team_name": "Уже можно",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "8",
            "4": "0",
            "5": "4",
            "6": "9",
            "7": "1",
            "city": "Екатеринбург",
            "team_name": "Умные и красивые",
            "total": "41"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "5",
            "5": "6",
            "6": "7",
            "7": "1",
            "city": "Борисов",
            "team_name": "Papayazahvatilpolshu",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "0",
            "city": "Владимир",
            "team_name": "Роберт Паучков",
            "total": "41"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "6",
            "6": "7",
            "7": "0",
            "city": "Ташкент",
            "team_name": "Я хочу от тебя Идей!",
            "total": "41"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "4",
            "7": "0",
            "city": "Ижевск",
            "team_name": "Пять стадий принятия ",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "4",
            "5": "4",
            "6": "12",
            "7": "-2",
            "city": "Екатеринбург",
            "team_name": "Тыковки",
            "total": "41"
        },
        {
            "0": "7",
            "1": "4",
            "2": "3",
            "3": "9",
            "4": "7",
            "5": "3",
            "6": "10",
            "7": "-2",
            "city": "Алматы",
            "team_name": "Не  грози южному централу",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "10",
            "7": "-2",
            "city": "Кирово-Чепецк",
            "team_name": "Хищные грибы Узбекистана",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "3",
            "6": "12",
            "7": "-3",
            "city": "Курган",
            "team_name": "Голова Ластик",
            "total": "41"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "9",
            "4": "2",
            "5": "5",
            "6": "11",
            "7": "-5",
            "city": "Санкт-Петербург",
            "team_name": "ЛосьАнжелес",
            "total": "41"
        },
        {
            "0": "5",
            "1": "7",
            "2": "6",
            "3": "4",
            "4": "0",
            "5": "4",
            "6": "6",
            "7": "8",
            "city": "Екатеринбург",
            "team_name": "Hello, world!",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "8",
            "4": "-1",
            "5": "5",
            "6": "5",
            "7": "8",
            "city": "Магнитогорск",
            "team_name": "Сила упругости",
            "total": "40"
        },
        {
            "0": "5",
            "1": "6",
            "2": "4",
            "3": "5",
            "4": "-1",
            "5": "4",
            "6": "10",
            "7": "7",
            "city": "Ташкент",
            "team_name": "CAMUSСУТРА",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "3",
            "4": "1",
            "5": "3",
            "6": "10",
            "7": "7",
            "city": "Тюмень",
            "team_name": "Под Жаре",
            "total": "40"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "-1",
            "5": "5",
            "6": "7",
            "7": "7",
            "city": "Брест",
            "team_name": "Хьюстон, у нас проблема!",
            "total": "40"
        },
        {
            "0": "4",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "5",
            "7": "7",
            "city": "Владимир",
            "team_name": "Здесь могла быть ваша реклама",
            "total": "40"
        },
        {
            "0": "5",
            "1": "5",
            "2": "4",
            "3": "3",
            "4": "2",
            "5": "4",
            "6": "11",
            "7": "6",
            "city": "Великий Новгород",
            "team_name": "Moreзги",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "1",
            "4": "2",
            "5": "4",
            "6": "10",
            "7": "6",
            "city": "Кемерово",
            "team_name": "SherlockBand",
            "total": "40"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "6",
            "4": "0",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Москва",
            "team_name": "Мы только спросить",
            "total": "40"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "5",
            "4": "1",
            "5": "3",
            "6": "9",
            "7": "6",
            "city": "Асбест",
            "team_name": "СМИшные",
            "total": "40"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "1",
            "5": "5",
            "6": "7",
            "7": "6",
            "city": "Краснотурьинск",
            "team_name": "Золотые сердца",
            "total": "40"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "3",
            "6": "7",
            "7": "6",
            "city": "Курган",
            "team_name": "Летний дождь",
            "total": "40"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "2",
            "6": "7",
            "7": "6",
            "city": "Туапсе",
            "team_name": "Зебра",
            "total": "40"
        },
        {
            "0": "4",
            "1": "5",
            "2": "7",
            "3": "7",
            "4": "3",
            "5": "1",
            "6": "7",
            "7": "6",
            "city": "Туапсе",
            "team_name": "Говядина",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "4",
            "7": "6",
            "city": "Барнаул",
            "team_name": "No name, no shame",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "1",
            "5": "4",
            "6": "9",
            "7": "5",
            "city": "Барановичи",
            "team_name": "Брют",
            "total": "40"
        },
        {
            "0": "4",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "3",
            "6": "9",
            "7": "5",
            "city": "Витебск",
            "team_name": "Winds",
            "total": "40"
        },
        {
            "0": "4",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "1",
            "6": "8",
            "7": "5",
            "city": "Омск",
            "team_name": "Дачники",
            "total": "40"
        },
        {
            "0": "7",
            "1": "4",
            "2": "7",
            "3": "7",
            "4": "2",
            "5": "2",
            "6": "6",
            "7": "5",
            "city": "Екатеринбург",
            "team_name": "ФКР66",
            "total": "40"
        },
        {
            "0": "6",
            "1": "7",
            "2": "3",
            "3": "9",
            "4": "3",
            "5": "4",
            "6": "3",
            "7": "5",
            "city": "Иркутск",
            "team_name": "Энергоняшки",
            "total": "40"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "3",
            "4": "4",
            "5": "3",
            "6": "11",
            "7": "4",
            "city": "Барановичи",
            "team_name": "Балалаечники",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "0",
            "5": "5",
            "6": "10",
            "7": "4",
            "city": "Нижний Новгород",
            "team_name": "Мишка на сервере",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "1",
            "5": "3",
            "6": "10",
            "7": "4",
            "city": "Берёзовский",
            "team_name": "Бамболейло",
            "total": "40"
        },
        {
            "0": "5",
            "1": "6",
            "2": "2",
            "3": "8",
            "4": "3",
            "5": "2",
            "6": "10",
            "7": "4",
            "city": "Ставрополь",
            "team_name": "КрепыЖ",
            "total": "40"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "2",
            "6": "10",
            "7": "4",
            "city": "Ростов на Дону",
            "team_name": "Иное мышление",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "2",
            "4": "4",
            "5": "4",
            "6": "9",
            "7": "4",
            "city": "Великий Новгород",
            "team_name": "Дефибриллятор",
            "total": "40"
        },
        {
            "0": "6",
            "1": "4",
            "2": "6",
            "3": "6",
            "4": "1",
            "5": "4",
            "6": "9",
            "7": "4",
            "city": "Глазов",
            "team_name": "Танцы с бубном",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "6",
            "4": "1",
            "5": "4",
            "6": "9",
            "7": "4",
            "city": "Тампере",
            "team_name": "Saunassa",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "2",
            "5": "6",
            "6": "8",
            "7": "4",
            "city": "Великий Новгород",
            "team_name": "На Позитиве",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "1",
            "5": "5",
            "6": "8",
            "7": "4",
            "city": "Хельсинки",
            "team_name": "Въяблочко ",
            "total": "40"
        },
        {
            "0": "6",
            "1": "3",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Гродно",
            "team_name": "Inspektr",
            "total": "40"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "1",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Балашиха",
            "team_name": "Газаточканет",
            "total": "40"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "7",
            "4": "1",
            "5": "7",
            "6": "7",
            "7": "4",
            "city": "Варшава",
            "team_name": "ЕБой",
            "total": "40"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "2",
            "5": "6",
            "6": "7",
            "7": "4",
            "city": "Воронеж",
            "team_name": "Запасные хромосомы",
            "total": "40"
        },
        {
            "0": "6",
            "1": "6",
            "2": "3",
            "3": "9",
            "4": "3",
            "5": "2",
            "6": "7",
            "7": "4",
            "city": "Таллин",
            "team_name": "Шмéли-сумéли",
            "total": "40"
        },
        {
            "0": "4",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "0",
            "5": "4",
            "6": "12",
            "7": "3",
            "city": "Ростов на Дону",
            "team_name": "Когда на мозгобойню?",
            "total": "40"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "3",
            "6": "11",
            "7": "3",
            "city": "Кострома",
            "team_name": "Летучий голландец",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "3",
            "5": "2",
            "6": "11",
            "7": "3",
            "city": "Архангельск",
            "team_name": "Дети маминых подруг",
            "total": "40"
        },
        {
            "0": "6",
            "1": "6",
            "2": "3",
            "3": "4",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "3",
            "city": "Снежинск",
            "team_name": "Кудаш-вы!",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "3",
            "6": "9",
            "7": "3",
            "city": "Киров",
            "team_name": "Все ходы записаны",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "1",
            "5": "5",
            "6": "8",
            "7": "3",
            "city": "Первоуральск",
            "team_name": "Эс как доллар",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "3",
            "city": "Курган",
            "team_name": "БОРМОТОГРАФ",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "3",
            "city": "Ижевск",
            "team_name": "Салют 71 ",
            "total": "40"
        },
        {
            "0": "4",
            "1": "4",
            "2": "5",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "7",
            "7": "3",
            "city": "Санкт-Петербург",
            "team_name": "Dr. Котиков",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "2",
            "5": "5",
            "6": "11",
            "7": "2",
            "city": "Великий Новгород",
            "team_name": "Эврика",
            "total": "40"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "2",
            "city": "Красногорск",
            "team_name": "Квартет Ы",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "3",
            "4": "3",
            "5": "5",
            "6": "9",
            "7": "2",
            "city": "Павловский Посад",
            "team_name": "С какого?",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "2",
            "city": "Балашиха",
            "team_name": "Пломбозавры",
            "total": "40"
        },
        {
            "0": "6",
            "1": "4",
            "2": "6",
            "3": "4",
            "4": "4",
            "5": "6",
            "6": "8",
            "7": "2",
            "city": "Владимир",
            "team_name": "Вынос мозга",
            "total": "40"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "1",
            "5": "5",
            "6": "8",
            "7": "2",
            "city": "Бобруйск",
            "team_name": "Шапито",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "3",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "2",
            "city": "Киров",
            "team_name": "Команда им. Топпера Харли",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "7",
            "7": "2",
            "city": "Альметьевск",
            "team_name": "Тамагочи",
            "total": "40"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "9",
            "4": "2",
            "5": "6",
            "6": "4",
            "7": "2",
            "city": "Гомель",
            "team_name": "Ван дер варт",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "2",
            "5": "5",
            "6": "10",
            "7": "1",
            "city": "Берёзовский",
            "team_name": "Вирус Уусикаупунки",
            "total": "40"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "4",
            "5": "4",
            "6": "10",
            "7": "1",
            "city": "Краснотурьинск",
            "team_name": "В пределах разумного",
            "total": "40"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "3",
            "5": "3",
            "6": "7",
            "7": "1",
            "city": "Краснотурьинск",
            "team_name": "Славяне",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "2",
            "4": "7",
            "5": "4",
            "6": "9",
            "7": "0",
            "city": "Пинск",
            "team_name": "Зато пришли",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "0",
            "city": "Санкт-Петербург",
            "team_name": "German Gang",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "8",
            "7": "0",
            "city": "Минск",
            "team_name": "Шершеляфамы",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "3",
            "5": "3",
            "6": "7",
            "7": "0",
            "city": "Ташкент",
            "team_name": "Малыш и Carlsberg",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "1",
            "5": "5",
            "6": "9",
            "7": "-1",
            "city": "Златоуст",
            "team_name": "Травники",
            "total": "40"
        },
        {
            "0": "7",
            "1": "7",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "1",
            "6": "11",
            "7": "-2",
            "city": "Химки",
            "team_name": "Правильный ответ",
            "total": "40"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "9",
            "7": "-2",
            "city": "Гомель",
            "team_name": "WTF?",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "9",
            "7": "-2",
            "city": "Лида",
            "team_name": "3 на 8",
            "total": "40"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "-2",
            "city": "Королев",
            "team_name": "Я протестую!",
            "total": "40"
        },
        {
            "0": "5",
            "1": "2",
            "2": "4",
            "3": "5",
            "4": "2",
            "5": "3",
            "6": "8",
            "7": "10",
            "city": "Полевской",
            "team_name": "Эммануил Гедеонович",
            "total": "39"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "2",
            "4": "4",
            "5": "5",
            "6": "4",
            "7": "10",
            "city": "Киев",
            "team_name": "Nice tattoo",
            "total": "39"
        },
        {
            "0": "3",
            "1": "3",
            "2": "7",
            "3": "7",
            "4": "0",
            "5": "5",
            "6": "8",
            "7": "6",
            "city": "Ростов на Дону",
            "team_name": "Modestos genios informáticos",
            "total": "39"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "-3",
            "5": "5",
            "6": "8",
            "7": "6",
            "city": "Санкт-Петербург",
            "team_name": "Сгущёнка 100%",
            "total": "39"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "1",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "6",
            "city": "Каменск-Уральский",
            "team_name": "Через ТРЕНИЕ - к звёздам!",
            "total": "39"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "2",
            "4": "5",
            "5": "2",
            "6": "8",
            "7": "6",
            "city": "Владимир",
            "team_name": "Всё пучком!",
            "total": "39"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "6",
            "city": "Кирово-Чепецк",
            "team_name": "Почти точно",
            "total": "39"
        },
        {
            "0": "5",
            "1": "3",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "7",
            "7": "6",
            "city": "Тюмень",
            "team_name": "ОтСечина",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "1",
            "4": "0",
            "5": "4",
            "6": "9",
            "7": "5",
            "city": "Чайковский",
            "team_name": "Коллибри",
            "total": "39"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "3",
            "4": "3",
            "5": "1",
            "6": "9",
            "7": "5",
            "city": "Петрозаводск",
            "team_name": "Мысли вслух",
            "total": "39"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "1",
            "6": "8",
            "7": "5",
            "city": "Домодедово",
            "team_name": "ПСИХсовет",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "7",
            "4": "1",
            "5": "5",
            "6": "5",
            "7": "5",
            "city": "Екатеринбург",
            "team_name": "Охотники за разумом",
            "total": "39"
        },
        {
            "0": "6",
            "1": "7",
            "2": "4",
            "3": "8",
            "4": "1",
            "5": "4",
            "6": "4",
            "7": "5",
            "city": "Екатеринбург",
            "team_name": "Ход конём",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "1",
            "5": "0",
            "6": "12",
            "7": "4",
            "city": "Челябинск",
            "team_name": "Безумный план",
            "total": "39"
        },
        {
            "0": "4",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "0",
            "5": "6",
            "6": "11",
            "7": "4",
            "city": "Ковров",
            "team_name": "Что-то с лицом",
            "total": "39"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "7",
            "4": "-1",
            "5": "4",
            "6": "10",
            "7": "4",
            "city": "Воронеж",
            "team_name": "ТопиБрат",
            "total": "39"
        },
        {
            "0": "5",
            "1": "5",
            "2": "3",
            "3": "5",
            "4": "4",
            "5": "3",
            "6": "10",
            "7": "4",
            "city": "Белгород",
            "team_name": "Девочкинесдаются",
            "total": "39"
        },
        {
            "0": "5",
            "1": "4",
            "2": "7",
            "3": "6",
            "4": "3",
            "5": "1",
            "6": "9",
            "7": "4",
            "city": "Турку",
            "team_name": "Korte",
            "total": "39"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Омск",
            "team_name": "Лыжи не едут",
            "total": "39"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "5",
            "4": "5",
            "5": "3",
            "6": "7",
            "7": "4",
            "city": "Екатеринбург",
            "team_name": "На сложных щщах",
            "total": "39"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "3",
            "6": "7",
            "7": "4",
            "city": "Тверь",
            "team_name": "Емеля не дурак",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "8",
            "4": "0",
            "5": "3",
            "6": "7",
            "7": "4",
            "city": "Глазов",
            "team_name": "ПТУ им. О.И. Бузовой",
            "total": "39"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "2",
            "5": "2",
            "6": "7",
            "7": "4",
            "city": "Минск",
            "team_name": "Сiнiя дзюбы",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "5",
            "4": "4",
            "5": "3",
            "6": "6",
            "7": "4",
            "city": "Кирово-Чепецк",
            "team_name": "ПионЭры",
            "total": "39"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "5",
            "7": "4",
            "city": "Гродно",
            "team_name": "Мой господин",
            "total": "39"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "1",
            "6": "12",
            "7": "3",
            "city": "Киров",
            "team_name": "Сладкоеды",
            "total": "39"
        },
        {
            "0": "4",
            "1": "5",
            "2": "6",
            "3": "1",
            "4": "3",
            "5": "6",
            "6": "11",
            "7": "3",
            "city": "Кострома",
            "team_name": "Аэрозомби",
            "total": "39"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "2",
            "6": "9",
            "7": "3",
            "city": "Омск",
            "team_name": "Костян,названиестебя!",
            "total": "39"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "6",
            "7": "3",
            "city": "Гомель",
            "team_name": "Друзь и я",
            "total": "39"
        },
        {
            "0": "5",
            "1": "6",
            "2": "2",
            "3": "6",
            "4": "4",
            "5": "3",
            "6": "11",
            "7": "2",
            "city": "Пермь",
            "team_name": "Неконтактный зоопарк",
            "total": "39"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "2",
            "5": "1",
            "6": "10",
            "7": "2",
            "city": "Пермь",
            "team_name": "Сквош team",
            "total": "39"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "7",
            "6": "8",
            "7": "2",
            "city": "Алматы",
            "team_name": "чемпионы KFC в тяжелом весе",
            "total": "39"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "5",
            "6": "7",
            "7": "2",
            "city": "Омск",
            "team_name": "Красивые люди",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "1",
            "5": "5",
            "6": "7",
            "7": "2",
            "city": "Нижняя Тура",
            "team_name": "Трёшка",
            "total": "39"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "7",
            "4": "4",
            "5": "3",
            "6": "7",
            "7": "2",
            "city": "Киров",
            "team_name": "S как доллар",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "5",
            "4": "4",
            "5": "6",
            "6": "5",
            "7": "2",
            "city": "Норильск",
            "team_name": "Непьющие в Норильске",
            "total": "39"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "5",
            "5": "5",
            "6": "5",
            "7": "2",
            "city": "Петрозаводск",
            "team_name": "Кантеле style",
            "total": "39"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "4",
            "6": "5",
            "7": "2",
            "city": "Домодедово",
            "team_name": "Моя любимая команда",
            "total": "39"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "7",
            "4": "0",
            "5": "4",
            "6": "11",
            "7": "1",
            "city": "Нижний Новгород",
            "team_name": "Мансарда",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "8",
            "4": "3",
            "5": "3",
            "6": "8",
            "7": "1",
            "city": "Екатеринбург",
            "team_name": "Кусь-кусь клан",
            "total": "39"
        },
        {
            "0": "6",
            "1": "4",
            "2": "3",
            "3": "8",
            "4": "4",
            "5": "6",
            "6": "7",
            "7": "1",
            "city": "Люберцы",
            "team_name": "ЛОЖ",
            "total": "39"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "5",
            "5": "3",
            "6": "10",
            "7": "0",
            "city": "Архангельск",
            "team_name": "Double fault",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "1",
            "6": "10",
            "7": "0",
            "city": "Березники",
            "team_name": "Те ещё фрукты",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "5",
            "6": "9",
            "7": "0",
            "city": "Красногорск",
            "team_name": "Ква",
            "total": "39"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "0",
            "city": "Симферополь",
            "team_name": "Снова ошиблись дверью",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "2",
            "6": "8",
            "7": "0",
            "city": "Гродно",
            "team_name": "Твоя бывшая",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "5",
            "5": "3",
            "6": "7",
            "7": "0",
            "city": "Великий Новгород",
            "team_name": "Нефтяники",
            "total": "39"
        },
        {
            "0": "6",
            "1": "5",
            "2": "7",
            "3": "8",
            "4": "3",
            "5": "4",
            "6": "6",
            "7": "0",
            "city": "Таллин",
            "team_name": "Crazy Gang",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "1",
            "5": "5",
            "6": "5",
            "7": "0",
            "city": "Воронеж",
            "team_name": "Сливки",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "1",
            "5": "5",
            "6": "12",
            "7": "-1",
            "city": "Воронеж",
            "team_name": "Богема",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "3",
            "6": "10",
            "7": "-1",
            "city": "Воронеж",
            "team_name": "Это всё от нервов",
            "total": "39"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "8",
            "4": "5",
            "5": "5",
            "6": "7",
            "7": "-1",
            "city": "Архангельск",
            "team_name": "Воспаленные хитростью",
            "total": "39"
        },
        {
            "0": "5",
            "1": "6",
            "2": "4",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "13",
            "7": "-2",
            "city": "Киров",
            "team_name": "Массовка",
            "total": "39"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "2",
            "4": "4",
            "5": "4",
            "6": "13",
            "7": "-2",
            "city": "Владимир",
            "team_name": "Тик Так Бум",
            "total": "39"
        },
        {
            "0": "6",
            "1": "4",
            "2": "3",
            "3": "2",
            "4": "3",
            "5": "2",
            "6": "8",
            "7": "10",
            "city": "Туапсе",
            "team_name": "Торнадо",
            "total": "38"
        },
        {
            "0": "4",
            "1": "5",
            "2": "4",
            "3": "2",
            "4": "-1",
            "5": "6",
            "6": "9",
            "7": "9",
            "city": "Вольск",
            "team_name": "Шоколадки",
            "total": "38"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "2",
            "4": "0",
            "5": "2",
            "6": "9",
            "7": "8",
            "city": "Пенза",
            "team_name": "Теперь объект",
            "total": "38"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "9",
            "4": "0",
            "5": "2",
            "6": "4",
            "7": "8",
            "city": "Киев",
            "team_name": "Соседи Павла Григоровича",
            "total": "38"
        },
        {
            "0": "5",
            "1": "2",
            "2": "5",
            "3": "3",
            "4": "1",
            "5": "3",
            "6": "12",
            "7": "7",
            "city": "Югорск",
            "team_name": "#вротмненоги",
            "total": "38"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "7",
            "4": "1",
            "5": "2",
            "6": "5",
            "7": "7",
            "city": "Киров",
            "team_name": "Пожуём увидим",
            "total": "38"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "6",
            "city": "Хельсинки",
            "team_name": "Kauniit ja rohkeat ",
            "total": "38"
        },
        {
            "0": "3",
            "1": "7",
            "2": "5",
            "3": "5",
            "4": "0",
            "5": "4",
            "6": "8",
            "7": "6",
            "city": "Реж",
            "team_name": "Девчата и Он",
            "total": "38"
        },
        {
            "0": "5",
            "1": "6",
            "2": "4",
            "3": "3",
            "4": "3",
            "5": "4",
            "6": "7",
            "7": "6",
            "city": "Гродно",
            "team_name": "Ой, все!",
            "total": "38"
        },
        {
            "0": "4",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "5",
            "7": "6",
            "city": "Северодвинск",
            "team_name": "Tony Montana",
            "total": "38"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "9",
            "4": "-1",
            "5": "4",
            "6": "4",
            "7": "6",
            "city": "Киев",
            "team_name": "Unagi",
            "total": "38"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "3",
            "6": "4",
            "7": "6",
            "city": "Барнаул",
            "team_name": "Че и бониты",
            "total": "38"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "3",
            "7": "6",
            "city": "Киев",
            "team_name": "Влажность",
            "total": "38"
        },
        {
            "0": "5",
            "1": "4",
            "2": "3",
            "3": "6",
            "4": "1",
            "5": "4",
            "6": "10",
            "7": "5",
            "city": "Тюмень",
            "team_name": "СокРАТ",
            "total": "38"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "1",
            "5": "1",
            "6": "9",
            "7": "5",
            "city": "Санкт-Петербург",
            "team_name": "Мегакудли",
            "total": "38"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "1",
            "5": "3",
            "6": "8",
            "7": "5",
            "city": "Воронеж",
            "team_name": "Девичник+",
            "total": "38"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "0",
            "5": "3",
            "6": "8",
            "7": "5",
            "city": "Варшава",
            "team_name": "Дайте подумать",
            "total": "38"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "3",
            "5": "4",
            "6": "7",
            "7": "5",
            "city": "Киров",
            "team_name": "Ёжики ХОХОчут",
            "total": "38"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "3",
            "4": "4",
            "5": "5",
            "6": "5",
            "7": "5",
            "city": "Гомель",
            "team_name": "Все свои",
            "total": "38"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "1",
            "4": "3",
            "5": "4",
            "6": "11",
            "7": "4",
            "city": "Нижняя Тура",
            "team_name": "Х. З. (Хаос Знаний)",
            "total": "38"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "3",
            "5": "3",
            "6": "9",
            "7": "4",
            "city": "Екатеринбург",
            "team_name": "Курочкин и Ко",
            "total": "38"
        },
        {
            "0": "5",
            "1": "6",
            "2": "2",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "7",
            "7": "4",
            "city": "Махачкала",
            "team_name": "ПРОСТО УЧИТЕЛЯ",
            "total": "38"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "5",
            "7": "4",
            "city": "Омск",
            "team_name": "Malting",
            "total": "38"
        },
        {
            "0": "7",
            "1": "6",
            "2": "7",
            "3": "3",
            "4": "0",
            "5": "2",
            "6": "10",
            "7": "3",
            "city": "Архангельск",
            "team_name": "Искорки",
            "total": "38"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "2",
            "5": "3",
            "6": "9",
            "7": "3",
            "city": "Каменск-Уральский",
            "team_name": "Разум и чувства",
            "total": "38"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "1",
            "5": "3",
            "6": "8",
            "7": "3",
            "city": "Барановичи",
            "team_name": "Сборная солянка",
            "total": "38"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "1",
            "5": "3",
            "6": "8",
            "7": "3",
            "city": "Барнаул",
            "team_name": "Омерзительная семерка",
            "total": "38"
        },
        {
            "0": "6",
            "1": "3",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "2",
            "6": "8",
            "7": "3",
            "city": "Минск",
            "team_name": "Борис и Ко",
            "total": "38"
        },
        {
            "0": "4",
            "1": "5",
            "2": "1",
            "3": "7",
            "4": "4",
            "5": "7",
            "6": "7",
            "7": "3",
            "city": "Петрозаводск",
            "team_name": "Истина в Моне",
            "total": "38"
        },
        {
            "0": "5",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "7",
            "7": "3",
            "city": "Новокубанск",
            "team_name": "Премудрые и мистер Х",
            "total": "38"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "6",
            "7": "3",
            "city": "Воронеж",
            "team_name": "Привези мне привези",
            "total": "38"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "1",
            "5": "3",
            "6": "6",
            "7": "3",
            "city": "Воронеж",
            "team_name": "Финики",
            "total": "38"
        },
        {
            "0": "4",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "2",
            "6": "11",
            "7": "2",
            "city": "Симферополь",
            "team_name": "Бутылка WineГрета",
            "total": "38"
        },
        {
            "0": "5",
            "1": "5",
            "2": "7",
            "3": "4",
            "4": "3",
            "5": "2",
            "6": "10",
            "7": "2",
            "city": "Борисов",
            "team_name": "Кот да Винчик",
            "total": "38"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "8",
            "4": "-2",
            "5": "6",
            "6": "8",
            "7": "2",
            "city": "Новокубанск",
            "team_name": "Амнезия",
            "total": "38"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "4",
            "6": "8",
            "7": "2",
            "city": "Гродно",
            "team_name": "Сеня, береги ухо",
            "total": "38"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "3",
            "6": "8",
            "7": "2",
            "city": "Минск",
            "team_name": "Третий пропускаем",
            "total": "38"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "5",
            "7": "2",
            "city": "Пятигорск",
            "team_name": "Горе от ума",
            "total": "38"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "6",
            "4": "2",
            "5": "5",
            "6": "4",
            "7": "2",
            "city": "Пятигорск",
            "team_name": "Happy people",
            "total": "38"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "8",
            "7": "1",
            "city": "Кропоткин",
            "team_name": "Коктейль Молотова",
            "total": "38"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "8",
            "7": "1",
            "city": "Архангельск",
            "team_name": "We'll be back",
            "total": "38"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "1",
            "5": "5",
            "6": "11",
            "7": "0",
            "city": "Бишкек",
            "team_name": "Цэдваашпятьоаш",
            "total": "38"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "2",
            "5": "3",
            "6": "11",
            "7": "0",
            "city": "Кемерово",
            "team_name": "Команда молодости нашей",
            "total": "38"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "9",
            "7": "0",
            "city": "Химки",
            "team_name": "Пара-выра",
            "total": "38"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "5",
            "6": "9",
            "7": "0",
            "city": "Кемерово",
            "team_name": "Вынос мозга и ЧБ",
            "total": "38"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "0",
            "city": "Пермь",
            "team_name": "Ставим всё на чёрное",
            "total": "38"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "1",
            "5": "4",
            "6": "9",
            "7": "0",
            "city": "Первоуральск",
            "team_name": "Это фиаско, братан!",
            "total": "38"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "8",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "0",
            "city": "Киров",
            "team_name": "Мотор Игоря",
            "total": "38"
        },
        {
            "0": "6",
            "1": "5",
            "2": "7",
            "3": "5",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "0",
            "city": "Пенза",
            "team_name": "Мы со своим",
            "total": "38"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "8",
            "4": "3",
            "5": "2",
            "6": "8",
            "7": "0",
            "city": "Кирово-Чепецк",
            "team_name": "Сальвадор в Дали",
            "total": "38"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "7",
            "7": "0",
            "city": "Артемовский",
            "team_name": "Можжечог",
            "total": "38"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "4",
            "6": "5",
            "7": "0",
            "city": "Пенза",
            "team_name": "Детектив Коломбо",
            "total": "38"
        },
        {
            "0": "7",
            "1": "4",
            "2": "7",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "-1",
            "city": "Кострома",
            "team_name": "Свой формат",
            "total": "38"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "3",
            "6": "8",
            "7": "-1",
            "city": "Слободской",
            "team_name": "Взрыв WOWana",
            "total": "38"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "3",
            "5": "4",
            "6": "12",
            "7": "-2",
            "city": "Петрозаводск",
            "team_name": "Пинки и Брейн",
            "total": "38"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "4",
            "5": "3",
            "6": "10",
            "7": "-3",
            "city": "Тверь",
            "team_name": "10 пельменей фиолетовой империи",
            "total": "38"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "4",
            "5": "5",
            "6": "8",
            "7": "-5",
            "city": "Слободской",
            "team_name": "100 %",
            "total": "38"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "-1",
            "5": "3",
            "6": "7",
            "7": "8",
            "city": "Полевской",
            "team_name": "Мяу-чикиряу",
            "total": "37"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "2",
            "6": "5",
            "7": "8",
            "city": "Хельсинки",
            "team_name": "Ляляфа ",
            "total": "37"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "3",
            "6": "4",
            "7": "7",
            "city": "Барнаул",
            "team_name": "Клуб Добрячок",
            "total": "37"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "4",
            "4": "0",
            "5": "3",
            "6": "10",
            "7": "6",
            "city": "Санкт-Петербург",
            "team_name": "Дом, там где винишко",
            "total": "37"
        },
        {
            "0": "5",
            "1": "4",
            "2": "4",
            "3": "2",
            "4": "4",
            "5": "3",
            "6": "9",
            "7": "6",
            "city": "Чернигов",
            "team_name": "Шалені Бджілки",
            "total": "37"
        },
        {
            "0": "6",
            "1": "4",
            "2": "3",
            "3": "4",
            "4": "5",
            "5": "1",
            "6": "8",
            "7": "6",
            "city": "Омск",
            "team_name": "Фигасе",
            "total": "37"
        },
        {
            "0": "6",
            "1": "6",
            "2": "3",
            "3": "6",
            "4": "2",
            "5": "2",
            "6": "6",
            "7": "6",
            "city": "Орехово-Зуево",
            "team_name": "В пределах разумного",
            "total": "37"
        },
        {
            "0": "4",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "5",
            "7": "6",
            "city": "Пермь",
            "team_name": "Пузырек на середину",
            "total": "37"
        },
        {
            "0": "4",
            "1": "4",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "5",
            "7": "6",
            "city": "Кирово-Чепецк",
            "team_name": "Шерше ля Факт",
            "total": "37"
        },
        {
            "0": "6",
            "1": "6",
            "2": "2",
            "3": "9",
            "4": "3",
            "5": "2",
            "6": "3",
            "7": "6",
            "city": "Челябинск",
            "team_name": "Мы просто поесть",
            "total": "37"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "2",
            "5": "3",
            "6": "8",
            "7": "5",
            "city": "Минск",
            "team_name": "Неприятели",
            "total": "37"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "5",
            "city": "Архангельск",
            "team_name": "Мориарти",
            "total": "37"
        },
        {
            "0": "4",
            "1": "6",
            "2": "3",
            "3": "6",
            "4": "2",
            "5": "5",
            "6": "6",
            "7": "5",
            "city": "Сургут",
            "team_name": "Кактус Луиджи",
            "total": "37"
        },
        {
            "0": "4",
            "1": "4",
            "2": "4",
            "3": "8",
            "4": "3",
            "5": "4",
            "6": "5",
            "7": "5",
            "city": "Лондон",
            "team_name": "Небо Лондона",
            "total": "37"
        },
        {
            "0": "5",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "3",
            "5": "3",
            "6": "9",
            "7": "4",
            "city": "Челябинск",
            "team_name": "Звездочка",
            "total": "37"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "2",
            "5": "3",
            "6": "8",
            "7": "4",
            "city": "Электросталь",
            "team_name": "Бешеный барсук",
            "total": "37"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "1",
            "5": "3",
            "6": "7",
            "7": "4",
            "city": "Ивдель",
            "team_name": "С теми, кто в теме",
            "total": "37"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "2",
            "6": "6",
            "7": "4",
            "city": "Полевской",
            "team_name": "Александр Сергеевич",
            "total": "37"
        },
        {
            "0": "7",
            "1": "5",
            "2": "2",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "5",
            "7": "4",
            "city": "Орск",
            "team_name": "Нищая богема",
            "total": "37"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "1",
            "5": "3",
            "6": "5",
            "7": "4",
            "city": "Югорск",
            "team_name": "Какие есть",
            "total": "37"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "3",
            "4": "3",
            "5": "3",
            "6": "9",
            "7": "3",
            "city": "Полевской",
            "team_name": "Шли мимо мимоходом",
            "total": "37"
        },
        {
            "0": "7",
            "1": "4",
            "2": "2",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "3",
            "city": "Челябинск",
            "team_name": "Кетаминки",
            "total": "37"
        },
        {
            "0": "5",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "3",
            "5": "4",
            "6": "7",
            "7": "3",
            "city": "Владимир",
            "team_name": "МозгоДжобы",
            "total": "37"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "1",
            "5": "2",
            "6": "7",
            "7": "3",
            "city": "Раменское",
            "team_name": "Умозаключённые",
            "total": "37"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "0",
            "5": "4",
            "6": "6",
            "7": "3",
            "city": "Поставы",
            "team_name": "КуПучино",
            "total": "37"
        },
        {
            "0": "6",
            "1": "6",
            "2": "3",
            "3": "7",
            "4": "0",
            "5": "3",
            "6": "10",
            "7": "2",
            "city": "Екатеринбург",
            "team_name": "Гоголь-моголь",
            "total": "37"
        },
        {
            "0": "5",
            "1": "4",
            "2": "7",
            "3": "4",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "2",
            "city": "Москва",
            "team_name": "Скинемся по 500",
            "total": "37"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "2",
            "6": "9",
            "7": "2",
            "city": "Туапсе",
            "team_name": "Цвет настроения черный",
            "total": "37"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "2",
            "city": "Воронеж",
            "team_name": "Спасибо большое",
            "total": "37"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "3",
            "6": "7",
            "7": "2",
            "city": "Кострома",
            "team_name": "Внезапные кегли",
            "total": "37"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "3",
            "6": "7",
            "7": "2",
            "city": "Брест",
            "team_name": "Зато красивые",
            "total": "37"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "5",
            "5": "3",
            "6": "6",
            "7": "2",
            "city": "Жуковский",
            "team_name": "BESTыжие",
            "total": "37"
        },
        {
            "0": "7",
            "1": "3",
            "2": "5",
            "3": "5",
            "4": "1",
            "5": "5",
            "6": "10",
            "7": "1",
            "city": "Таганрог",
            "team_name": "МОЗГОШТОЛЬНЯ",
            "total": "37"
        },
        {
            "0": "7",
            "1": "3",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "2",
            "6": "10",
            "7": "1",
            "city": "Минск",
            "team_name": "Уральский хомяк",
            "total": "37"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "-3",
            "5": "6",
            "6": "9",
            "7": "1",
            "city": "Гомель",
            "team_name": "Самая Тупая Команда",
            "total": "37"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "0",
            "5": "6",
            "6": "8",
            "7": "1",
            "city": "Глазов",
            "team_name": "ЗАО \"Дно\"",
            "total": "37"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "4",
            "6": "5",
            "7": "1",
            "city": "Раменское",
            "team_name": "Формула любви",
            "total": "37"
        },
        {
            "0": "5",
            "1": "5",
            "2": "7",
            "3": "7",
            "4": "2",
            "5": "2",
            "6": "9",
            "7": "0",
            "city": "Екатеринбург",
            "team_name": "Юху!!!",
            "total": "37"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "5",
            "7": "0",
            "city": "Пятигорск",
            "team_name": "Друзь-Я",
            "total": "37"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "9",
            "4": "5",
            "5": "6",
            "6": "0",
            "7": "0",
            "city": "Тамбов",
            "team_name": "Кевин, спейся!!!",
            "total": "37"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "0",
            "5": "5",
            "6": "10",
            "7": "-1",
            "city": "Артемовский",
            "team_name": "Люблю пятницу",
            "total": "37"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "8",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "-1",
            "city": "Омск",
            "team_name": "Элементарно",
            "total": "37"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "2",
            "5": "5",
            "6": "8",
            "7": "-1",
            "city": "Киров",
            "team_name": "Родком",
            "total": "37"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "6",
            "4": "5",
            "5": "3",
            "6": "7",
            "7": "-1",
            "city": "Лида",
            "team_name": "ПокаНеПридумали",
            "total": "37"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "11",
            "7": "-2",
            "city": "Барановичи",
            "team_name": "Пробный тираж",
            "total": "37"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "-2",
            "city": "Владимир",
            "team_name": "Бройлер 747",
            "total": "37"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "3",
            "6": "8",
            "7": "-3",
            "city": "Владимир",
            "team_name": "Идеальные незнакомцы",
            "total": "37"
        },
        {
            "0": "4",
            "1": "4",
            "2": "4",
            "3": "2",
            "4": "-2",
            "5": "5",
            "6": "9",
            "7": "10",
            "city": "Истра",
            "team_name": "Истринские ведьмы",
            "total": "36"
        },
        {
            "0": "5",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "1",
            "5": "2",
            "6": "8",
            "7": "7",
            "city": "Чернигов",
            "team_name": "Okey, Google",
            "total": "36"
        },
        {
            "0": "4",
            "1": "4",
            "2": "5",
            "3": "3",
            "4": "2",
            "5": "1",
            "6": "11",
            "7": "6",
            "city": "Ярославль",
            "team_name": "Экзистенциалисты",
            "total": "36"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "-2",
            "5": "4",
            "6": "9",
            "7": "6",
            "city": "Екатеринбург",
            "team_name": "Мармеладные пЁсы Игоревича",
            "total": "36"
        },
        {
            "0": "6",
            "1": "2",
            "2": "4",
            "3": "7",
            "4": "2",
            "5": "2",
            "6": "7",
            "7": "6",
            "city": "Пермь",
            "team_name": "Grand cargo",
            "total": "36"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "4",
            "4": "-1",
            "5": "5",
            "6": "6",
            "7": "6",
            "city": "Норильск",
            "team_name": "Это надо было еще вчера",
            "total": "36"
        },
        {
            "0": "3",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "3",
            "6": "6",
            "7": "6",
            "city": "Нижний Новгород",
            "team_name": "Какыгельды",
            "total": "36"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "1",
            "5": "1",
            "6": "6",
            "7": "6",
            "city": "Ставрополь",
            "team_name": "Мозгоеды",
            "total": "36"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "2",
            "5": "2",
            "6": "5",
            "7": "6",
            "city": "Первоуральск",
            "team_name": "Картауж",
            "total": "36"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "0",
            "5": "3",
            "6": "4",
            "7": "6",
            "city": "Тампере",
            "team_name": "Я Люблю твои красные ногти",
            "total": "36"
        },
        {
            "0": "3",
            "1": "7",
            "2": "3",
            "3": "2",
            "4": "3",
            "5": "6",
            "6": "7",
            "7": "5",
            "city": "Реж",
            "team_name": "Дископартизаны",
            "total": "36"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "8",
            "4": "-3",
            "5": "4",
            "6": "7",
            "7": "5",
            "city": "Ярославль",
            "team_name": "Истина в вине",
            "total": "36"
        },
        {
            "0": "3",
            "1": "5",
            "2": "3",
            "3": "3",
            "4": "3",
            "5": "4",
            "6": "11",
            "7": "4",
            "city": "Тампере",
            "team_name": "Синяя гусеница",
            "total": "36"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "1",
            "4": "2",
            "5": "3",
            "6": "11",
            "7": "4",
            "city": "Снежинск",
            "team_name": "Давно знакомы",
            "total": "36"
        },
        {
            "0": "7",
            "1": "3",
            "2": "3",
            "3": "5",
            "4": "1",
            "5": "4",
            "6": "9",
            "7": "4",
            "city": "Владимир",
            "team_name": "Дай списать",
            "total": "36"
        },
        {
            "0": "3",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "3",
            "5": "3",
            "6": "9",
            "7": "4",
            "city": "Воронеж",
            "team_name": "Тупырышки",
            "total": "36"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "5",
            "5": "0",
            "6": "9",
            "7": "4",
            "city": "Барановичи",
            "team_name": "Денаши?!",
            "total": "36"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "1",
            "4": "0",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Владимир",
            "team_name": "Венский кружок",
            "total": "36"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "4",
            "4": "0",
            "5": "3",
            "6": "8",
            "7": "4",
            "city": "Артемовский",
            "team_name": "АГО ВДПО",
            "total": "36"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "2",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "4",
            "city": "Иваново",
            "team_name": "Зигзаг Удачи",
            "total": "36"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "4",
            "4": "4",
            "5": "4",
            "6": "6",
            "7": "4",
            "city": "Кемерово",
            "team_name": "Умники и умницы",
            "total": "36"
        },
        {
            "0": "7",
            "1": "6",
            "2": "2",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "6",
            "7": "4",
            "city": "Североуральск",
            "team_name": "NonStop",
            "total": "36"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "2",
            "5": "4",
            "6": "6",
            "7": "4",
            "city": "Кирово-Чепецк",
            "team_name": "Случайно вышло",
            "total": "36"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "2",
            "5": "1",
            "6": "10",
            "7": "3",
            "city": "Серпухов",
            "team_name": "Тесла",
            "total": "36"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "8",
            "4": "0",
            "5": "2",
            "6": "9",
            "7": "3",
            "city": "Петрозаводск",
            "team_name": "Perdit monocle",
            "total": "36"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "2",
            "4": "2",
            "5": "4",
            "6": "7",
            "7": "3",
            "city": "Берёзовский",
            "team_name": "Оптимисты",
            "total": "36"
        },
        {
            "0": "6",
            "1": "4",
            "2": "6",
            "3": "7",
            "4": "2",
            "5": "1",
            "6": "7",
            "7": "3",
            "city": "Сургут",
            "team_name": "Ещё два пива, пожалуйста",
            "total": "36"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "5",
            "7": "3",
            "city": "Минск",
            "team_name": "Гетлаусы",
            "total": "36"
        },
        {
            "0": "6",
            "1": "4",
            "2": "3",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "2",
            "city": "Алматы",
            "team_name": "I'll be Bach",
            "total": "36"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "2",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "2",
            "city": "Каменск-Уральский",
            "team_name": "Хочу на море",
            "total": "36"
        },
        {
            "0": "7",
            "1": "7",
            "2": "4",
            "3": "2",
            "4": "3",
            "5": "4",
            "6": "7",
            "7": "2",
            "city": "Реж",
            "team_name": "Мать ее наук",
            "total": "36"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "6",
            "4": "3",
            "5": "3",
            "6": "7",
            "7": "2",
            "city": "Челябинск",
            "team_name": "Разделяйка",
            "total": "36"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "4",
            "5": "5",
            "6": "6",
            "7": "2",
            "city": "Первоуральск",
            "team_name": "Утомленные снегом",
            "total": "36"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "8",
            "4": "-1",
            "5": "5",
            "6": "6",
            "7": "2",
            "city": "Архангельск",
            "team_name": "Под котролем!",
            "total": "36"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "4",
            "5": "4",
            "6": "6",
            "7": "2",
            "city": "Кирово-Чепецк",
            "team_name": "CASINO",
            "total": "36"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "4",
            "5": "4",
            "6": "6",
            "7": "2",
            "city": "Туапсе",
            "team_name": "Каким-то макаром",
            "total": "36"
        },
        {
            "0": "7",
            "1": "3",
            "2": "6",
            "3": "5",
            "4": "1",
            "5": "4",
            "6": "9",
            "7": "1",
            "city": "Каменск-Уральский",
            "team_name": "Сколько хотим, столько весим!",
            "total": "36"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "3",
            "6": "9",
            "7": "1",
            "city": "Бишкек",
            "team_name": "Рэд Бокс",
            "total": "36"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "2",
            "5": "2",
            "6": "9",
            "7": "1",
            "city": "Глазов",
            "team_name": "Палата №6",
            "total": "36"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "2",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "1",
            "city": "Гомель",
            "team_name": "Брызги разума",
            "total": "36"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "1",
            "city": "Раменское",
            "team_name": "Кто сможет!",
            "total": "36"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "2",
            "5": "3",
            "6": "7",
            "7": "1",
            "city": "Тюмень",
            "team_name": "Настрадания Предсказамуса",
            "total": "36"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "6",
            "7": "1",
            "city": "Каменск-Уральский",
            "team_name": "Загадочные улитки (ЗАГУЛ)",
            "total": "36"
        },
        {
            "0": "7",
            "1": "3",
            "2": "3",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "10",
            "7": "0",
            "city": "Омск",
            "team_name": "Камерная сцена",
            "total": "36"
        },
        {
            "0": "7",
            "1": "4",
            "2": "2",
            "3": "8",
            "4": "3",
            "5": "3",
            "6": "9",
            "7": "0",
            "city": "Владимир",
            "team_name": "Отвечает Алексей",
            "total": "36"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "3",
            "6": "9",
            "7": "0",
            "city": "Кострома",
            "team_name": "Поздно пить Боржоми",
            "total": "36"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "2",
            "5": "5",
            "6": "8",
            "7": "0",
            "city": "Владимир",
            "team_name": "Время покажет",
            "total": "36"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "10",
            "7": "-2",
            "city": "Снежинск",
            "team_name": "Come on everybody",
            "total": "36"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "1",
            "5": "3",
            "6": "10",
            "7": "-2",
            "city": "Асбест",
            "team_name": "Ахиллес",
            "total": "36"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "2",
            "5": "2",
            "6": "10",
            "7": "-2",
            "city": "Киров",
            "team_name": "ДАстоевские",
            "total": "36"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "9",
            "7": "-2",
            "city": "Чернигов",
            "team_name": "The Stars",
            "total": "36"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "7",
            "7": "-3",
            "city": "Таганрог",
            "team_name": "Пришли с родителями",
            "total": "36"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "1",
            "5": "4",
            "6": "9",
            "7": "-4",
            "city": "Екатеринбург",
            "team_name": "А с мельдонием можно?",
            "total": "36"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "8",
            "7": "-4",
            "city": "Редмонд",
            "team_name": "Дефлопе",
            "total": "36"
        },
        {
            "0": "2",
            "1": "6",
            "2": "3",
            "3": "4",
            "4": "0",
            "5": "5",
            "6": "9",
            "7": "6",
            "city": "Гомель",
            "team_name": "Сидим без дим",
            "total": "35"
        },
        {
            "0": "5",
            "1": "4",
            "2": "4",
            "3": "3",
            "4": "2",
            "5": "2",
            "6": "9",
            "7": "6",
            "city": "Североуральск",
            "team_name": "Викторианцы",
            "total": "35"
        },
        {
            "0": "3",
            "1": "3",
            "2": "3",
            "3": "7",
            "4": "0",
            "5": "5",
            "6": "8",
            "7": "6",
            "city": "Бишкек",
            "team_name": "Твин Пикс",
            "total": "35"
        },
        {
            "0": "6",
            "1": "7",
            "2": "2",
            "3": "7",
            "4": "-1",
            "5": "4",
            "6": "4",
            "7": "6",
            "city": "Тюмень",
            "team_name": "Нотки шафрана",
            "total": "35"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "2",
            "4": "0",
            "5": "3",
            "6": "11",
            "7": "5",
            "city": "Архангельск",
            "team_name": "Экономика",
            "total": "35"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "3",
            "4": "-5",
            "5": "3",
            "6": "10",
            "7": "5",
            "city": "Архангельск",
            "team_name": "Альпака",
            "total": "35"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "4",
            "4": "2",
            "5": "3",
            "6": "7",
            "7": "5",
            "city": "Архангельск",
            "team_name": "Охотники за удачей",
            "total": "35"
        },
        {
            "0": "7",
            "1": "3",
            "2": "3",
            "3": "9",
            "4": "0",
            "5": "1",
            "6": "7",
            "7": "5",
            "city": "Севастополь",
            "team_name": "Тут вам не здесь",
            "total": "35"
        },
        {
            "0": "6",
            "1": "6",
            "2": "3",
            "3": "2",
            "4": "0",
            "5": "3",
            "6": "11",
            "7": "4",
            "city": "Кирово-Чепецк",
            "team_name": "Зайчатки разума",
            "total": "35"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "-3",
            "5": "5",
            "6": "10",
            "7": "4",
            "city": "Челябинск",
            "team_name": "Иголочки",
            "total": "35"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "1",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "4",
            "city": "Кемерово",
            "team_name": "Убойщики",
            "total": "35"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "1",
            "4": "1",
            "5": "4",
            "6": "8",
            "7": "4",
            "city": "Архангельск",
            "team_name": "Не похожие",
            "total": "35"
        },
        {
            "0": "4",
            "1": "7",
            "2": "4",
            "3": "5",
            "4": "1",
            "5": "2",
            "6": "8",
            "7": "4",
            "city": "Северодвинск",
            "team_name": "Арктические умки",
            "total": "35"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "0",
            "5": "2",
            "6": "8",
            "7": "4",
            "city": "Нижний Новгород",
            "team_name": "Умники и умницы",
            "total": "35"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "6",
            "4": "0",
            "5": "3",
            "6": "7",
            "7": "4",
            "city": "Витебск",
            "team_name": "Leon до Лондона доведёт",
            "total": "35"
        },
        {
            "0": "7",
            "1": "6",
            "2": "2",
            "3": "5",
            "4": "3",
            "5": "3",
            "6": "5",
            "7": "4",
            "city": "Тюмень",
            "team_name": "Кокошин Эль",
            "total": "35"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "0",
            "5": "4",
            "6": "4",
            "7": "4",
            "city": "Пятигорск",
            "team_name": "Вердит",
            "total": "35"
        },
        {
            "0": "5",
            "1": "7",
            "2": "2",
            "3": "8",
            "4": "2",
            "5": "5",
            "6": "2",
            "7": "4",
            "city": "Киев",
            "team_name": "Квентин Ламантино",
            "total": "35"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "3",
            "5": "3",
            "6": "6",
            "7": "3",
            "city": "Воронеж",
            "team_name": "шКодики",
            "total": "35"
        },
        {
            "0": "7",
            "1": "4",
            "2": "3",
            "3": "9",
            "4": "1",
            "5": "2",
            "6": "6",
            "7": "3",
            "city": "Алматы",
            "team_name": "Киря и Ко",
            "total": "35"
        },
        {
            "0": "6",
            "1": "4",
            "2": "2",
            "3": "8",
            "4": "4",
            "5": "3",
            "6": "5",
            "7": "3",
            "city": "Алматы",
            "team_name": "Продающие лица и Алма",
            "total": "35"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "6",
            "4": "4",
            "5": "3",
            "6": "4",
            "7": "3",
            "city": "Магнитогорск",
            "team_name": "Ищу жену",
            "total": "35"
        },
        {
            "0": "3",
            "1": "6",
            "2": "4",
            "3": "4",
            "4": "4",
            "5": "3",
            "6": "9",
            "7": "2",
            "city": "Архангельск",
            "team_name": "Мысли вслух",
            "total": "35"
        },
        {
            "0": "2",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "2",
            "city": "Туапсе",
            "team_name": "Победила Победила",
            "total": "35"
        },
        {
            "0": "4",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "7",
            "7": "2",
            "city": "Кропоткин",
            "team_name": "Marvel",
            "total": "35"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "8",
            "4": "-1",
            "5": "3",
            "6": "7",
            "7": "2",
            "city": "Екатеринбург",
            "team_name": "Тимбим",
            "total": "35"
        },
        {
            "0": "4",
            "1": "3",
            "2": "3",
            "3": "8",
            "4": "3",
            "5": "6",
            "6": "6",
            "7": "2",
            "city": "Алматы",
            "team_name": "PNG",
            "total": "35"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "2",
            "4": "4",
            "5": "3",
            "6": "6",
            "7": "2",
            "city": "Кропоткин",
            "team_name": "Бигуди Укупника",
            "total": "35"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "2",
            "4": "3",
            "5": "3",
            "6": "6",
            "7": "2",
            "city": "Ярославль",
            "team_name": "Шампиньоны",
            "total": "35"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "1",
            "5": "1",
            "6": "5",
            "7": "2",
            "city": "Барановичи",
            "team_name": "Мозгодавы",
            "total": "35"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "1",
            "5": "5",
            "6": "4",
            "7": "2",
            "city": "Владимир",
            "team_name": "Voron'Ezh",
            "total": "35"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "2",
            "5": "4",
            "6": "9",
            "7": "1",
            "city": "Орск",
            "team_name": "качайся и крутись",
            "total": "35"
        },
        {
            "0": "5",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "0",
            "5": "5",
            "6": "8",
            "7": "1",
            "city": "Екатеринбург",
            "team_name": "Спроси у Гали",
            "total": "35"
        },
        {
            "0": "4",
            "1": "6",
            "2": "7",
            "3": "3",
            "4": "4",
            "5": "3",
            "6": "7",
            "7": "1",
            "city": "Брест",
            "team_name": "Совершенно по Фрейду",
            "total": "35"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "4",
            "5": "5",
            "6": "4",
            "7": "1",
            "city": "Киев",
            "team_name": "As designed",
            "total": "35"
        },
        {
            "0": "3",
            "1": "4",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "12",
            "7": "0",
            "city": "Турку",
            "team_name": "Дерзкие белки",
            "total": "35"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "-1",
            "5": "4",
            "6": "11",
            "7": "0",
            "city": "Лондон",
            "team_name": "Дуайт Шрут UK",
            "total": "35"
        },
        {
            "0": "7",
            "1": "3",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "2",
            "6": "9",
            "7": "0",
            "city": "Санкт-Петербург",
            "team_name": "Playbrain",
            "total": "35"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "0",
            "city": "Пермь",
            "team_name": "Ашипка Гиппократа",
            "total": "35"
        },
        {
            "0": "3",
            "1": "5",
            "2": "6",
            "3": "9",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "0",
            "city": "Минск",
            "team_name": "Мазь Дикуля",
            "total": "35"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "5",
            "4": "2",
            "5": "5",
            "6": "6",
            "7": "0",
            "city": "Полевской",
            "team_name": "Клюква",
            "total": "35"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "5",
            "4": "4",
            "5": "7",
            "6": "0",
            "7": "0",
            "city": "Тамбов",
            "team_name": "Мыли рамы",
            "total": "35"
        },
        {
            "0": "6",
            "1": "6",
            "2": "7",
            "3": "8",
            "4": "1",
            "5": "7",
            "6": "0",
            "7": "0",
            "city": "Тамбов",
            "team_name": "IG NOBEL PRIZE",
            "total": "35"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "3",
            "5": "2",
            "6": "11",
            "7": "-1",
            "city": "Северодвинск",
            "team_name": "Candyдаты",
            "total": "35"
        },
        {
            "0": "4",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "10",
            "7": "-1",
            "city": "Жуковский",
            "team_name": "Посторонним В",
            "total": "35"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "2",
            "4": "4",
            "5": "4",
            "6": "9",
            "7": "-1",
            "city": "Тверь",
            "team_name": "Абырвалг",
            "total": "35"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "5",
            "4": "1",
            "5": "6",
            "6": "9",
            "7": "-2",
            "city": "Гродно",
            "team_name": "Unexpected error",
            "total": "35"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "-2",
            "city": "Северодвинск",
            "team_name": "ТаКыРР",
            "total": "35"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "5",
            "6": "8",
            "7": "-2",
            "city": "Гомель",
            "team_name": "Ханц Фениш",
            "total": "35"
        },
        {
            "0": "6",
            "1": "6",
            "2": "3",
            "3": "9",
            "4": "3",
            "5": "3",
            "6": "7",
            "7": "-2",
            "city": "Борисов",
            "team_name": "Неадекватные люди",
            "total": "35"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "9",
            "4": "1",
            "5": "3",
            "6": "7",
            "7": "-2",
            "city": "Полевской",
            "team_name": "16+",
            "total": "35"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "5",
            "5": "6",
            "6": "7",
            "7": "-4",
            "city": "Петрозаводск",
            "team_name": "Веселые грибы",
            "total": "35"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "0",
            "5": "7",
            "6": "11",
            "7": "-6",
            "city": "Владимир",
            "team_name": "В рот енот",
            "total": "35"
        },
        {
            "0": "1",
            "1": "5",
            "2": "2",
            "3": "6",
            "4": "1",
            "5": "4",
            "6": "8",
            "7": "7",
            "city": "Великий Новгород",
            "team_name": "Молчание ребят",
            "total": "34"
        },
        {
            "0": "6",
            "1": "5",
            "2": "1",
            "3": "3",
            "4": "2",
            "5": "3",
            "6": "7",
            "7": "7",
            "city": "Полевской",
            "team_name": "7 чудес света",
            "total": "34"
        },
        {
            "0": "4",
            "1": "6",
            "2": "5",
            "3": "3",
            "4": "-1",
            "5": "4",
            "6": "6",
            "7": "7",
            "city": "Кирово-Чепецк",
            "team_name": "Принесённые ветром",
            "total": "34"
        },
        {
            "0": "2",
            "1": "3",
            "2": "4",
            "3": "7",
            "4": "1",
            "5": "5",
            "6": "5",
            "7": "7",
            "city": "Киев",
            "team_name": "Маги с Марса",
            "total": "34"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "5",
            "4": "4",
            "5": "1",
            "6": "2",
            "7": "7",
            "city": "Киев",
            "team_name": "Батько в зданії",
            "total": "34"
        },
        {
            "0": "5",
            "1": "5",
            "2": "3",
            "3": "4",
            "4": "3",
            "5": "1",
            "6": "7",
            "7": "6",
            "city": "Челябинск",
            "team_name": "Техноледи",
            "total": "34"
        },
        {
            "0": "7",
            "1": "4",
            "2": "3",
            "3": "3",
            "4": "2",
            "5": "3",
            "6": "6",
            "7": "6",
            "city": "Обнинск",
            "team_name": "Почти наверное ",
            "total": "34"
        },
        {
            "0": "3",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "3",
            "5": "4",
            "6": "5",
            "7": "6",
            "city": "Таганрог",
            "team_name": "Друзья Друзя",
            "total": "34"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "0",
            "5": "2",
            "6": "5",
            "7": "6",
            "city": "Нефтеюганск",
            "team_name": "Фортуна",
            "total": "34"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "1",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "5",
            "city": "Артемовский",
            "team_name": "Новое поколение ЛИТЛ БОСОВ",
            "total": "34"
        },
        {
            "0": "5",
            "1": "5",
            "2": "4",
            "3": "2",
            "4": "3",
            "5": "3",
            "6": "8",
            "7": "4",
            "city": "Лида",
            "team_name": "Элен и ребята",
            "total": "34"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "4",
            "city": "Петрозаводск",
            "team_name": "Движение извилин",
            "total": "34"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "2",
            "5": "3",
            "6": "6",
            "7": "4",
            "city": "Пинск",
            "team_name": "Девятый вал",
            "total": "34"
        },
        {
            "0": "2",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "0",
            "5": "4",
            "6": "8",
            "7": "3",
            "city": "Иваново",
            "team_name": "Мы просто растерялись",
            "total": "34"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "4",
            "4": "3",
            "5": "4",
            "6": "6",
            "7": "3",
            "city": "Киров",
            "team_name": "Стакан смузи",
            "total": "34"
        },
        {
            "0": "7",
            "1": "2",
            "2": "4",
            "3": "7",
            "4": "1",
            "5": "4",
            "6": "6",
            "7": "3",
            "city": "Омск",
            "team_name": "Генеральная упорка",
            "total": "34"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "0",
            "5": "5",
            "6": "5",
            "7": "3",
            "city": "Тюмень",
            "team_name": "Родня ведущего",
            "total": "34"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "3",
            "4": "0",
            "5": "2",
            "6": "10",
            "7": "2",
            "city": "Владимир",
            "team_name": "Мы по блату",
            "total": "34"
        },
        {
            "0": "6",
            "1": "5",
            "2": "2",
            "3": "4",
            "4": "5",
            "5": "0",
            "6": "10",
            "7": "2",
            "city": "Северодвинск",
            "team_name": "karma police",
            "total": "34"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "1",
            "4": "1",
            "5": "5",
            "6": "8",
            "7": "2",
            "city": "Воронеж",
            "team_name": "Кто скурил медиаплан",
            "total": "34"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "1",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "2",
            "city": "Берёзовский",
            "team_name": "Пифагоровы штаны",
            "total": "34"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "0",
            "4": "3",
            "5": "4",
            "6": "8",
            "7": "2",
            "city": "Кирово-Чепецк",
            "team_name": "Повод встретиться",
            "total": "34"
        },
        {
            "0": "7",
            "1": "4",
            "2": "7",
            "3": "4",
            "4": "0",
            "5": "4",
            "6": "6",
            "7": "2",
            "city": "Снежинск",
            "team_name": "Сбежавшие",
            "total": "34"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "5",
            "4": "4",
            "5": "4",
            "6": "5",
            "7": "2",
            "city": "Норильск",
            "team_name": "Всадники Апокалипсиса",
            "total": "34"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "3",
            "4": "3",
            "5": "4",
            "6": "5",
            "7": "2",
            "city": "Москва",
            "team_name": "#Деловназвании",
            "total": "34"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "6",
            "4": "4",
            "5": "2",
            "6": "5",
            "7": "2",
            "city": "Красногорск",
            "team_name": "КаБанда",
            "total": "34"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "3",
            "5": "1",
            "6": "5",
            "7": "2",
            "city": "Минск",
            "team_name": "Масакра выходного дня",
            "total": "34"
        },
        {
            "0": "3",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "-1",
            "5": "3",
            "6": "11",
            "7": "1",
            "city": "Екатеринбург",
            "team_name": "Чубакки",
            "total": "34"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "1",
            "city": "Таллин",
            "team_name": "ШАРИКИ ЗА РОЛИКИ",
            "total": "34"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "3",
            "5": "3",
            "6": "7",
            "7": "1",
            "city": "Артемовский",
            "team_name": "Медик-А-Менты",
            "total": "34"
        },
        {
            "0": "5",
            "1": "7",
            "2": "5",
            "3": "2",
            "4": "3",
            "5": "5",
            "6": "6",
            "7": "1",
            "city": "Реж",
            "team_name": "Один раз не… модельер",
            "total": "34"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "6",
            "4": "0",
            "5": "4",
            "6": "5",
            "7": "1",
            "city": "Молодечно",
            "team_name": "Ступы на парковке",
            "total": "34"
        },
        {
            "0": "5",
            "1": "4",
            "2": "4",
            "3": "2",
            "4": "5",
            "5": "5",
            "6": "9",
            "7": "0",
            "city": "Туапсе",
            "team_name": "Красота.Грация.Идеал",
            "total": "34"
        },
        {
            "0": "4",
            "1": "4",
            "2": "5",
            "3": "5",
            "4": "4",
            "5": "3",
            "6": "9",
            "7": "0",
            "city": "Химки",
            "team_name": "КЖН",
            "total": "34"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "2",
            "5": "3",
            "6": "9",
            "7": "0",
            "city": "Артемовский",
            "team_name": "P.s. biblioteka",
            "total": "34"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "-1",
            "5": "3",
            "6": "9",
            "7": "0",
            "city": "Минск",
            "team_name": "Абыхто",
            "total": "34"
        },
        {
            "0": "5",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "1",
            "5": "2",
            "6": "9",
            "7": "0",
            "city": "Тюмень",
            "team_name": "Мозжечок",
            "total": "34"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "1",
            "5": "6",
            "6": "6",
            "7": "0",
            "city": "Омск",
            "team_name": "Тру усики Дали",
            "total": "34"
        },
        {
            "0": "7",
            "1": "3",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "4",
            "6": "6",
            "7": "0",
            "city": "Челябинск",
            "team_name": "Ананасики",
            "total": "34"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "1",
            "5": "4",
            "6": "6",
            "7": "0",
            "city": "Тюмень",
            "team_name": "Запись дюны",
            "total": "34"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "8",
            "4": "2",
            "5": "4",
            "6": "4",
            "7": "0",
            "city": "Слободской",
            "team_name": "Дикий фреш",
            "total": "34"
        },
        {
            "0": "6",
            "1": "6",
            "2": "6",
            "3": "8",
            "4": "3",
            "5": "5",
            "6": "0",
            "7": "0",
            "city": "Тамбов",
            "team_name": "Проказники",
            "total": "34"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "1",
            "5": "2",
            "6": "11",
            "7": "-2",
            "city": "Пермь",
            "team_name": "Фантазер, ты меня называла!",
            "total": "34"
        },
        {
            "0": "4",
            "1": "6",
            "2": "6",
            "3": "4",
            "4": "4",
            "5": "3",
            "6": "9",
            "7": "-2",
            "city": "Каменск-Уральский",
            "team_name": "Эйяфьядлайёкюдль",
            "total": "34"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "7",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "-6",
            "city": "Бобруйск",
            "team_name": "Н.А.Т.А.Ш.А.",
            "total": "34"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "4",
            "4": "-2",
            "5": "2",
            "6": "9",
            "7": "6",
            "city": "Чернигов",
            "team_name": "11-A",
            "total": "33"
        },
        {
            "0": "5",
            "1": "5",
            "2": "4",
            "3": "3",
            "4": "0",
            "5": "1",
            "6": "9",
            "7": "6",
            "city": "Омск",
            "team_name": "Квартет ё",
            "total": "33"
        },
        {
            "0": "6",
            "1": "4",
            "2": "3",
            "3": "1",
            "4": "1",
            "5": "4",
            "6": "8",
            "7": "6",
            "city": "Каменск-Уральский",
            "team_name": "ВсёПутём",
            "total": "33"
        },
        {
            "0": "7",
            "1": "5",
            "2": "0",
            "3": "9",
            "4": "-2",
            "5": "5",
            "6": "3",
            "7": "6",
            "city": "Киев",
            "team_name": "АЯЖЕГОВОРИЛА",
            "total": "33"
        },
        {
            "0": "5",
            "1": "4",
            "2": "2",
            "3": "4",
            "4": "4",
            "5": "3",
            "6": "6",
            "7": "5",
            "city": "Омск",
            "team_name": "ЧТОКС",
            "total": "33"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "2",
            "4": "1",
            "5": "1",
            "6": "6",
            "7": "5",
            "city": "Каменск-Уральский",
            "team_name": "Ум в приоритете",
            "total": "33"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "2",
            "4": "0",
            "5": "2",
            "6": "11",
            "7": "4",
            "city": "Артемовский",
            "team_name": "Рожденные в СССР",
            "total": "33"
        },
        {
            "0": "4",
            "1": "4",
            "2": "5",
            "3": "3",
            "4": "2",
            "5": "3",
            "6": "8",
            "7": "4",
            "city": "Минск",
            "team_name": "Правильный ответ",
            "total": "33"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "2",
            "4": "0",
            "5": "3",
            "6": "8",
            "7": "4",
            "city": "Ухта",
            "team_name": "Б2",
            "total": "33"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "3",
            "4": "1",
            "5": "1",
            "6": "8",
            "7": "4",
            "city": "Архангельск",
            "team_name": "Нам не по пути",
            "total": "33"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "-1",
            "5": "5",
            "6": "7",
            "7": "4",
            "city": "Воронеж",
            "team_name": "Пушистые",
            "total": "33"
        },
        {
            "0": "5",
            "1": "4",
            "2": "4",
            "3": "4",
            "4": "1",
            "5": "4",
            "6": "7",
            "7": "4",
            "city": "Сургут",
            "team_name": "Засадисты",
            "total": "33"
        },
        {
            "0": "6",
            "1": "5",
            "2": "2",
            "3": "2",
            "4": "3",
            "5": "5",
            "6": "6",
            "7": "4",
            "city": "Чернигов",
            "team_name": "Летючий Корабель",
            "total": "33"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "3",
            "4": "0",
            "5": "2",
            "6": "9",
            "7": "3",
            "city": "Архангельск",
            "team_name": "На позитиве!",
            "total": "33"
        },
        {
            "0": "6",
            "1": "6",
            "2": "2",
            "3": "3",
            "4": "1",
            "5": "4",
            "6": "8",
            "7": "3",
            "city": "Королев",
            "team_name": "T&T",
            "total": "33"
        },
        {
            "0": "5",
            "1": "5",
            "2": "3",
            "3": "4",
            "4": "3",
            "5": "3",
            "6": "7",
            "7": "3",
            "city": "Петрозаводск",
            "team_name": "Дикие гитары",
            "total": "33"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "0",
            "5": "3",
            "6": "7",
            "7": "3",
            "city": "Асбест",
            "team_name": "Convex",
            "total": "33"
        },
        {
            "0": "4",
            "1": "7",
            "2": "6",
            "3": "2",
            "4": "-1",
            "5": "2",
            "6": "11",
            "7": "2",
            "city": "Нижний Новгород",
            "team_name": "Кудряшки Бенедикта",
            "total": "33"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "0",
            "5": "2",
            "6": "8",
            "7": "2",
            "city": "Владимир",
            "team_name": "Не в тему",
            "total": "33"
        },
        {
            "0": "4",
            "1": "5",
            "2": "2",
            "3": "8",
            "4": "1",
            "5": "4",
            "6": "7",
            "7": "2",
            "city": "Хельсинки",
            "team_name": "М&Ж ",
            "total": "33"
        },
        {
            "0": "7",
            "1": "3",
            "2": "5",
            "3": "3",
            "4": "3",
            "5": "3",
            "6": "7",
            "7": "2",
            "city": "Барановичи",
            "team_name": "Смурфы",
            "total": "33"
        },
        {
            "0": "5",
            "1": "6",
            "2": "4",
            "3": "4",
            "4": "3",
            "5": "2",
            "6": "7",
            "7": "2",
            "city": "Екатеринбург",
            "team_name": "Сетелем",
            "total": "33"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "5",
            "4": "0",
            "5": "3",
            "6": "6",
            "7": "2",
            "city": "Брест",
            "team_name": "Потом назовемся",
            "total": "33"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "4",
            "4": "2",
            "5": "2",
            "6": "6",
            "7": "2",
            "city": "Слободской",
            "team_name": "Взрывной ballon",
            "total": "33"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "2",
            "5": "1",
            "6": "6",
            "7": "2",
            "city": "Югорск",
            "team_name": "Бессмертные",
            "total": "33"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "7",
            "4": "2",
            "5": "2",
            "6": "5",
            "7": "2",
            "city": "Пермь",
            "team_name": "Халапеньо",
            "total": "33"
        },
        {
            "0": "5",
            "1": "3",
            "2": "4",
            "3": "8",
            "4": "3",
            "5": "4",
            "6": "4",
            "7": "2",
            "city": "Владимир",
            "team_name": "Хороший, плохой, кусь!",
            "total": "33"
        },
        {
            "0": "5",
            "1": "4",
            "2": "4",
            "3": "4",
            "4": "2",
            "5": "2",
            "6": "11",
            "7": "1",
            "city": "Балашиха",
            "team_name": "Друзь_не_пришёл",
            "total": "33"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "0",
            "4": "4",
            "5": "2",
            "6": "10",
            "7": "1",
            "city": "Иркутск",
            "team_name": "Истина в изюме",
            "total": "33"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "1",
            "5": "2",
            "6": "9",
            "7": "1",
            "city": "Петрозаводск",
            "team_name": "Аш-два-Во!",
            "total": "33"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "6",
            "4": "-1",
            "5": "4",
            "6": "6",
            "7": "1",
            "city": "Архангельск",
            "team_name": "Как обычно!",
            "total": "33"
        },
        {
            "0": "7",
            "1": "3",
            "2": "6",
            "3": "6",
            "4": "2",
            "5": "2",
            "6": "6",
            "7": "1",
            "city": "Минск",
            "team_name": "На метле",
            "total": "33"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "3",
            "5": "2",
            "6": "5",
            "7": "1",
            "city": "Иркутск",
            "team_name": "Выпускайте Кракена!",
            "total": "33"
        },
        {
            "0": "6",
            "1": "4",
            "2": "3",
            "3": "7",
            "4": "1",
            "5": "5",
            "6": "7",
            "7": "0",
            "city": "Омск",
            "team_name": "Ребзя 2",
            "total": "33"
        },
        {
            "0": "7",
            "1": "7",
            "2": "6",
            "3": "7",
            "4": "3",
            "5": "3",
            "6": "0",
            "7": "0",
            "city": "Тамбов",
            "team_name": "Непара",
            "total": "33"
        },
        {
            "0": "5",
            "1": "7",
            "2": "5",
            "3": "4",
            "4": "0",
            "5": "4",
            "6": "9",
            "7": "-1",
            "city": "Борисов",
            "team_name": "Идея Фикс",
            "total": "33"
        },
        {
            "0": "7",
            "1": "5",
            "2": "7",
            "3": "6",
            "4": "0",
            "5": "3",
            "6": "6",
            "7": "-1",
            "city": "Барнаул",
            "team_name": "ром&мята",
            "total": "33"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "3",
            "5": "2",
            "6": "8",
            "7": "-2",
            "city": "Каменск-Уральский",
            "team_name": "Всегда найдётся…",
            "total": "33"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "3",
            "5": "5",
            "6": "6",
            "7": "-2",
            "city": "Иваново",
            "team_name": "Интуиция Да!",
            "total": "33"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "7",
            "4": "0",
            "5": "3",
            "6": "9",
            "7": "-4",
            "city": "Алматы",
            "team_name": "Мафиозные миньоны",
            "total": "33"
        },
        {
            "0": "5",
            "1": "7",
            "2": "4",
            "3": "7",
            "4": "4",
            "5": "4",
            "6": "6",
            "7": "-4",
            "city": "Орехово-Зуево",
            "team_name": "Генерал Лимон",
            "total": "33"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "5",
            "6": "10",
            "7": "-6",
            "city": "Бобруйск",
            "team_name": "Компания",
            "total": "33"
        },
        {
            "0": "5",
            "1": "4",
            "2": "3",
            "3": "5",
            "4": "2",
            "5": "2",
            "6": "5",
            "7": "6",
            "city": "Нижний Новгород",
            "team_name": "СМУ",
            "total": "32"
        },
        {
            "0": "5",
            "1": "3",
            "2": "4",
            "3": "5",
            "4": "4",
            "5": "0",
            "6": "6",
            "7": "5",
            "city": "Тампа",
            "team_name": "Мамочки",
            "total": "32"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "1",
            "5": "2",
            "6": "5",
            "7": "5",
            "city": "Пинск",
            "team_name": "Агата Кристи",
            "total": "32"
        },
        {
            "0": "5",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "4",
            "5": "2",
            "6": "3",
            "7": "5",
            "city": "Пятигорск",
            "team_name": "Группа 932",
            "total": "32"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "-3",
            "5": "3",
            "6": "9",
            "7": "4",
            "city": "Ивдель",
            "team_name": "Билли Миллиган",
            "total": "32"
        },
        {
            "0": "4",
            "1": "5",
            "2": "3",
            "3": "5",
            "4": "0",
            "5": "2",
            "6": "9",
            "7": "4",
            "city": "Турку",
            "team_name": "Валерьянка",
            "total": "32"
        },
        {
            "0": "7",
            "1": "3",
            "2": "5",
            "3": "0",
            "4": "2",
            "5": "3",
            "6": "8",
            "7": "4",
            "city": "Берёзовский",
            "team_name": "Палата 666",
            "total": "32"
        },
        {
            "0": "4",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "3",
            "5": "0",
            "6": "8",
            "7": "4",
            "city": "Архангельск",
            "team_name": "Петровские безумцы",
            "total": "32"
        },
        {
            "0": "3",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "2",
            "5": "3",
            "6": "6",
            "7": "4",
            "city": "Кропоткин",
            "team_name": "Красная машина",
            "total": "32"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "2",
            "5": "2",
            "6": "6",
            "7": "4",
            "city": "Пинск",
            "team_name": "Елисейские поля",
            "total": "32"
        },
        {
            "0": "6",
            "1": "4",
            "2": "3",
            "3": "3",
            "4": "2",
            "5": "2",
            "6": "9",
            "7": "3",
            "city": "Архангельск",
            "team_name": "Земноводные Чепепахи",
            "total": "32"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "2",
            "5": "4",
            "6": "5",
            "7": "3",
            "city": "Екатеринбург",
            "team_name": "А а че ЭТО вы здесь делаете, А?",
            "total": "32"
        },
        {
            "0": "4",
            "1": "3",
            "2": "5",
            "3": "3",
            "4": "0",
            "5": "6",
            "6": "9",
            "7": "2",
            "city": "Белгород",
            "team_name": "Приходите завтра…",
            "total": "32"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "0",
            "5": "5",
            "6": "9",
            "7": "2",
            "city": "Хельсинки",
            "team_name": "Новичкам везет! ",
            "total": "32"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "1",
            "4": "2",
            "5": "2",
            "6": "9",
            "7": "2",
            "city": "Нижний Новгород",
            "team_name": "ПРОИБЭ",
            "total": "32"
        },
        {
            "0": "7",
            "1": "2",
            "2": "2",
            "3": "4",
            "4": "3",
            "5": "5",
            "6": "7",
            "7": "2",
            "city": "Бишкек",
            "team_name": "Alter Ego",
            "total": "32"
        },
        {
            "0": "5",
            "1": "4",
            "2": "5",
            "3": "6",
            "4": "0",
            "5": "3",
            "6": "7",
            "7": "2",
            "city": "Гродно",
            "team_name": "Pepega team",
            "total": "32"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "5",
            "4": "1",
            "5": "2",
            "6": "7",
            "7": "2",
            "city": "Норильск",
            "team_name": "Зеленый крокодил",
            "total": "32"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "3",
            "4": "1",
            "5": "5",
            "6": "6",
            "7": "2",
            "city": "Чернигов",
            "team_name": "Блондинки в Душе",
            "total": "32"
        },
        {
            "0": "7",
            "1": "4",
            "2": "2",
            "3": "7",
            "4": "1",
            "5": "4",
            "6": "5",
            "7": "2",
            "city": "Красногорск",
            "team_name": "Какие-то люди",
            "total": "32"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "3",
            "5": "2",
            "6": "5",
            "7": "2",
            "city": "Омутнинск",
            "team_name": "M&Ms",
            "total": "32"
        },
        {
            "0": "2",
            "1": "6",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "2",
            "6": "5",
            "7": "2",
            "city": "Минск",
            "team_name": "Ёлки-палки",
            "total": "32"
        },
        {
            "0": "7",
            "1": "6",
            "2": "2",
            "3": "7",
            "4": "1",
            "5": "2",
            "6": "5",
            "7": "2",
            "city": "Екатеринбург",
            "team_name": "Кондрат не виноват",
            "total": "32"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "5",
            "5": "2",
            "6": "4",
            "7": "2",
            "city": "Молодечно",
            "team_name": "Зайчаткі Разума",
            "total": "32"
        },
        {
            "0": "3",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "1",
            "city": "Кропоткин",
            "team_name": "7 Пятниц",
            "total": "32"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "1",
            "4": "2",
            "5": "5",
            "6": "7",
            "7": "1",
            "city": "Берёзовский",
            "team_name": "700 кг счастья",
            "total": "32"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "4",
            "4": "4",
            "5": "0",
            "6": "7",
            "7": "1",
            "city": "Пермь",
            "team_name": "Кипучий случай",
            "total": "32"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "7",
            "4": "-1",
            "5": "6",
            "6": "3",
            "7": "1",
            "city": "Киев",
            "team_name": "Норма Не Норма",
            "total": "32"
        },
        {
            "0": "4",
            "1": "2",
            "2": "4",
            "3": "8",
            "4": "1",
            "5": "3",
            "6": "10",
            "7": "0",
            "city": "Воронеж",
            "team_name": "Тапочки Эйнштейна",
            "total": "32"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "6",
            "4": "3",
            "5": "2",
            "6": "7",
            "7": "0",
            "city": "Артемовский",
            "team_name": "Под мельдонием",
            "total": "32"
        },
        {
            "0": "7",
            "1": "4",
            "2": "3",
            "3": "8",
            "4": "2",
            "5": "2",
            "6": "6",
            "7": "0",
            "city": "Рязань",
            "team_name": "#безмужей",
            "total": "32"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "7",
            "4": "0",
            "5": "4",
            "6": "5",
            "7": "0",
            "city": "Поставы",
            "team_name": "Акуна-Матата",
            "total": "32"
        },
        {
            "0": "5",
            "1": "7",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "6",
            "6": "0",
            "7": "0",
            "city": "Тамбов",
            "team_name": "Кефир",
            "total": "32"
        },
        {
            "0": "6",
            "1": "6",
            "2": "3",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "5",
            "7": "-1",
            "city": "Пятигорск",
            "team_name": "Marvel",
            "total": "32"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "3",
            "4": "0",
            "5": "3",
            "6": "10",
            "7": "-2",
            "city": "Редмонд",
            "team_name": "Кпанинуниногой",
            "total": "32"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "-2",
            "city": "Нижняя Тура",
            "team_name": "Могучая кучка",
            "total": "32"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "7",
            "4": "0",
            "5": "5",
            "6": "7",
            "7": "-2",
            "city": "Норильск",
            "team_name": "Трижды проклятые",
            "total": "32"
        },
        {
            "0": "7",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "4",
            "7": "-2",
            "city": "Барнаул",
            "team_name": "4-е место",
            "total": "32"
        },
        {
            "0": "7",
            "1": "3",
            "2": "1",
            "3": "8",
            "4": "1",
            "5": "5",
            "6": "11",
            "7": "-4",
            "city": "Ташкент",
            "team_name": "За любой кипишь, если мама отпустит",
            "total": "32"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "9",
            "4": "3",
            "5": "2",
            "6": "7",
            "7": "-4",
            "city": "Челябинск",
            "team_name": "КабернеСовиньон",
            "total": "32"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "5",
            "6": "6",
            "7": "-4",
            "city": "Туапсе",
            "team_name": "Ракамакафо",
            "total": "32"
        },
        {
            "0": "3",
            "1": "5",
            "2": "3",
            "3": "2",
            "4": "0",
            "5": "5",
            "6": "5",
            "7": "8",
            "city": "Североуральск",
            "team_name": "Юпитер",
            "total": "31"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "3",
            "4": "2",
            "5": "2",
            "6": "5",
            "7": "4",
            "city": "Белгород",
            "team_name": "Кофю",
            "total": "31"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "5",
            "4": "1",
            "5": "2",
            "6": "4",
            "7": "4",
            "city": "Ижевск",
            "team_name": "Чёрноезолото ",
            "total": "31"
        },
        {
            "0": "6",
            "1": "2",
            "2": "4",
            "3": "4",
            "4": "1",
            "5": "2",
            "6": "9",
            "7": "3",
            "city": "Ивдель",
            "team_name": "Вагон-купе",
            "total": "31"
        },
        {
            "0": "2",
            "1": "5",
            "2": "4",
            "3": "3",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "3",
            "city": "Туапсе",
            "team_name": "Энергия успеха",
            "total": "31"
        },
        {
            "0": "7",
            "1": "6",
            "2": "1",
            "3": "5",
            "4": "-1",
            "5": "4",
            "6": "6",
            "7": "3",
            "city": "Ташкент",
            "team_name": "MoZгоЁды",
            "total": "31"
        },
        {
            "0": "5",
            "1": "4",
            "2": "6",
            "3": "4",
            "4": "-1",
            "5": "4",
            "6": "6",
            "7": "3",
            "city": "Могилев",
            "team_name": "HappyTreeFriends",
            "total": "31"
        },
        {
            "0": "5",
            "1": "7",
            "2": "5",
            "3": "1",
            "4": "1",
            "5": "3",
            "6": "6",
            "7": "3",
            "city": "Северодвинск",
            "team_name": "Дилетанты",
            "total": "31"
        },
        {
            "0": "6",
            "1": "3",
            "2": "3",
            "3": "8",
            "4": "3",
            "5": "3",
            "6": "2",
            "7": "3",
            "city": "Киев",
            "team_name": "Friends Отца Евгения",
            "total": "31"
        },
        {
            "0": "1",
            "1": "3",
            "2": "4",
            "3": "5",
            "4": "3",
            "5": "4",
            "6": "9",
            "7": "2",
            "city": "Редмонд",
            "team_name": "По пивку",
            "total": "31"
        },
        {
            "0": "5",
            "1": "3",
            "2": "6",
            "3": "2",
            "4": "1",
            "5": "3",
            "6": "9",
            "7": "2",
            "city": "Каменск-Уральский",
            "team_name": "Изюм",
            "total": "31"
        },
        {
            "0": "6",
            "1": "4",
            "2": "6",
            "3": "3",
            "4": "0",
            "5": "2",
            "6": "8",
            "7": "2",
            "city": "Югорск",
            "team_name": "Непохожие",
            "total": "31"
        },
        {
            "0": "5",
            "1": "4",
            "2": "4",
            "3": "7",
            "4": "-2",
            "5": "4",
            "6": "7",
            "7": "2",
            "city": "Ухта",
            "team_name": "ИмперияWIN",
            "total": "31"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "6",
            "4": "-3",
            "5": "3",
            "6": "7",
            "7": "2",
            "city": "Севастополь",
            "team_name": "Малиновый пунш",
            "total": "31"
        },
        {
            "0": "5",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "5",
            "5": "1",
            "6": "3",
            "7": "2",
            "city": "Киев",
            "team_name": "Дети Маминой Подруги",
            "total": "31"
        },
        {
            "0": "6",
            "1": "5",
            "2": "6",
            "3": "4",
            "4": "4",
            "5": "1",
            "6": "3",
            "7": "2",
            "city": "Поставы",
            "team_name": "Ничего страшного",
            "total": "31"
        },
        {
            "0": "4",
            "1": "4",
            "2": "4",
            "3": "5",
            "4": "1",
            "5": "2",
            "6": "10",
            "7": "1",
            "city": "Тюмень",
            "team_name": "Флюгегехаймен",
            "total": "31"
        },
        {
            "0": "7",
            "1": "3",
            "2": "5",
            "3": "4",
            "4": "2",
            "5": "1",
            "6": "8",
            "7": "1",
            "city": "Зеленоград",
            "team_name": "Все остальные отказались",
            "total": "31"
        },
        {
            "0": "4",
            "1": "3",
            "2": "4",
            "3": "8",
            "4": "1",
            "5": "3",
            "6": "7",
            "7": "1",
            "city": "Минск",
            "team_name": "#Розовыйфламинго",
            "total": "31"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "2",
            "4": "2",
            "5": "4",
            "6": "6",
            "7": "1",
            "city": "Омск",
            "team_name": "Толькоучусь",
            "total": "31"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "2",
            "4": "4",
            "5": "2",
            "6": "6",
            "7": "1",
            "city": "Кирово-Чепецк",
            "team_name": "В яблочко!",
            "total": "31"
        },
        {
            "0": "3",
            "1": "4",
            "2": "6",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "4",
            "7": "1",
            "city": "Таллин",
            "team_name": "Costa-La-Costa",
            "total": "31"
        },
        {
            "0": "5",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "2",
            "5": "4",
            "6": "4",
            "7": "1",
            "city": "Павловский Посад",
            "team_name": "Чебупели",
            "total": "31"
        },
        {
            "0": "6",
            "1": "2",
            "2": "4",
            "3": "5",
            "4": "2",
            "5": "5",
            "6": "7",
            "7": "0",
            "city": "Омутнинск",
            "team_name": "А это моя любимая команда",
            "total": "31"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "-3",
            "5": "4",
            "6": "7",
            "7": "0",
            "city": "Петропавловск",
            "team_name": "Неестественный отбор",
            "total": "31"
        },
        {
            "0": "7",
            "1": "6",
            "2": "4",
            "3": "5",
            "4": "1",
            "5": "2",
            "6": "6",
            "7": "0",
            "city": "Екатеринбург",
            "team_name": "Толя ещё будет",
            "total": "31"
        },
        {
            "0": "6",
            "1": "6",
            "2": "3",
            "3": "8",
            "4": "0",
            "5": "3",
            "6": "5",
            "7": "0",
            "city": "Зеленоград",
            "team_name": "Цвет настроения синий",
            "total": "31"
        },
        {
            "0": "7",
            "1": "6",
            "2": "6",
            "3": "7",
            "4": "0",
            "5": "5",
            "6": "0",
            "7": "0",
            "city": "Тамбов",
            "team_name": "НЕ куриные мозги",
            "total": "31"
        },
        {
            "0": "6",
            "1": "4",
            "2": "3",
            "3": "8",
            "4": "3",
            "5": "3",
            "6": "5",
            "7": "-1",
            "city": "Алматы",
            "team_name": "AirYoutube",
            "total": "31"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "0",
            "5": "3",
            "6": "10",
            "7": "-2",
            "city": "Зеленоград",
            "team_name": "Мама сказала играйте отдельно",
            "total": "31"
        },
        {
            "0": "5",
            "1": "4",
            "2": "4",
            "3": "8",
            "4": "0",
            "5": "3",
            "6": "9",
            "7": "-2",
            "city": "Орехово-Зуево",
            "team_name": "Валар Моргулис",
            "total": "31"
        },
        {
            "0": "2",
            "1": "5",
            "2": "4",
            "3": "6",
            "4": "3",
            "5": "7",
            "6": "8",
            "7": "-4",
            "city": "Таллин",
            "team_name": "Бабкины семки",
            "total": "31"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "8",
            "7": "-4",
            "city": "Кирово-Чепецк",
            "team_name": "Гибкий ЗОЖ",
            "total": "31"
        },
        {
            "0": "2",
            "1": "3",
            "2": "4",
            "3": "5",
            "4": "0",
            "5": "3",
            "6": "8",
            "7": "5",
            "city": "Иркутск",
            "team_name": "Покемоны",
            "total": "30"
        },
        {
            "0": "3",
            "1": "4",
            "2": "3",
            "3": "4",
            "4": "1",
            "5": "2",
            "6": "8",
            "7": "5",
            "city": "Челябинск",
            "team_name": "АвтоДива и компания",
            "total": "30"
        },
        {
            "0": "5",
            "1": "3",
            "2": "3",
            "3": "6",
            "4": "1",
            "5": "3",
            "6": "5",
            "7": "4",
            "city": "Алматы",
            "team_name": "Непонятно как",
            "total": "30"
        },
        {
            "0": "6",
            "1": "4",
            "2": "3",
            "3": "7",
            "4": "-1",
            "5": "2",
            "6": "5",
            "7": "4",
            "city": "Екатеринбург",
            "team_name": "Бронепоезд в тупике",
            "total": "30"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "1",
            "4": "1",
            "5": "4",
            "6": "7",
            "7": "3",
            "city": "Иркутск",
            "team_name": "Горшочек вари",
            "total": "30"
        },
        {
            "0": "7",
            "1": "3",
            "2": "5",
            "3": "4",
            "4": "0",
            "5": "2",
            "6": "6",
            "7": "3",
            "city": "Североуральск",
            "team_name": "Карманы Вассермана",
            "total": "30"
        },
        {
            "0": "7",
            "1": "3",
            "2": "3",
            "3": "3",
            "4": "3",
            "5": "3",
            "6": "5",
            "7": "3",
            "city": "Златоуст",
            "team_name": "Nota Bene",
            "total": "30"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "4",
            "5": "4",
            "6": "2",
            "7": "3",
            "city": "Киев",
            "team_name": "Мастер и Маргариты",
            "total": "30"
        },
        {
            "0": "4",
            "1": "3",
            "2": "4",
            "3": "3",
            "4": "1",
            "5": "5",
            "6": "8",
            "7": "2",
            "city": "Кирово-Чепецк",
            "team_name": "Борцы СУМОм",
            "total": "30"
        },
        {
            "0": "5",
            "1": "4",
            "2": "7",
            "3": "4",
            "4": "-1",
            "5": "1",
            "6": "8",
            "7": "2",
            "city": "Минск",
            "team_name": "АББ СОК",
            "total": "30"
        },
        {
            "0": "6",
            "1": "5",
            "2": "2",
            "3": "4",
            "4": "2",
            "5": "3",
            "6": "6",
            "7": "2",
            "city": "Иркутск",
            "team_name": "Богиня Элджея",
            "total": "30"
        },
        {
            "0": "6",
            "1": "6",
            "2": "5",
            "3": "2",
            "4": "1",
            "5": "3",
            "6": "5",
            "7": "2",
            "city": "Северодвинск",
            "team_name": "Трезвый Шкипер",
            "total": "30"
        },
        {
            "0": "4",
            "1": "3",
            "2": "4",
            "3": "7",
            "4": "3",
            "5": "2",
            "6": "5",
            "7": "2",
            "city": "Каменск-Уральский",
            "team_name": "Люди в Чёрном",
            "total": "30"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "3",
            "4": "-2",
            "5": "2",
            "6": "10",
            "7": "1",
            "city": "Минск",
            "team_name": "Антигении",
            "total": "30"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "2",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "1",
            "city": "Екатеринбург",
            "team_name": "Медведи",
            "total": "30"
        },
        {
            "0": "7",
            "1": "4",
            "2": "6",
            "3": "4",
            "4": "-1",
            "5": "1",
            "6": "8",
            "7": "1",
            "city": "Кирово-Чепецк",
            "team_name": "Ин100грамм",
            "total": "30"
        },
        {
            "0": "7",
            "1": "3",
            "2": "5",
            "3": "4",
            "4": "2",
            "5": "2",
            "6": "6",
            "7": "1",
            "city": "Кропоткин",
            "team_name": "Феникс",
            "total": "30"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "-1",
            "5": "4",
            "6": "7",
            "7": "0",
            "city": "Ставрополь",
            "team_name": "Духом НеПал",
            "total": "30"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "5",
            "4": "1",
            "5": "3",
            "6": "7",
            "7": "0",
            "city": "Санкт-Петербург",
            "team_name": "PRoTOOH",
            "total": "30"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "5",
            "4": "2",
            "5": "2",
            "6": "7",
            "7": "0",
            "city": "Нижний Новгород",
            "team_name": "почти гении",
            "total": "30"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "5",
            "4": "2",
            "5": "0",
            "6": "7",
            "7": "0",
            "city": "Тюмень",
            "team_name": "Смешарики",
            "total": "30"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "3",
            "6": "2",
            "7": "0",
            "city": "Пятигорск",
            "team_name": "Хьюстон без проблем",
            "total": "30"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "1",
            "5": "3",
            "6": "11",
            "7": "-1",
            "city": "Екатеринбург",
            "team_name": "Согласны на педаль",
            "total": "30"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "3",
            "4": "-2",
            "5": "4",
            "6": "10",
            "7": "-1",
            "city": "Петрозаводск",
            "team_name": "Хумахуш",
            "total": "30"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "3",
            "5": "1",
            "6": "8",
            "7": "-1",
            "city": "Омск",
            "team_name": "Иришки и мальчишки",
            "total": "30"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "6",
            "4": "1",
            "5": "2",
            "6": "7",
            "7": "-1",
            "city": "Симферополь",
            "team_name": "Без тормозoff",
            "total": "30"
        },
        {
            "0": "7",
            "1": "6",
            "2": "3",
            "3": "8",
            "4": "-1",
            "5": "3",
            "6": "5",
            "7": "-1",
            "city": "Югорск",
            "team_name": "Мастеровые люди",
            "total": "30"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "4",
            "4": "1",
            "5": "3",
            "6": "9",
            "7": "-2",
            "city": "Архангельск",
            "team_name": "Безразличные Хаски",
            "total": "30"
        },
        {
            "0": "4",
            "1": "4",
            "2": "5",
            "3": "5",
            "4": "3",
            "5": "2",
            "6": "9",
            "7": "-2",
            "city": "Жуковский",
            "team_name": "Шальные мюсли",
            "total": "30"
        },
        {
            "0": "7",
            "1": "3",
            "2": "5",
            "3": "5",
            "4": "1",
            "5": "5",
            "6": "6",
            "7": "-2",
            "city": "Орск",
            "team_name": "Инкогнито",
            "total": "30"
        },
        {
            "0": "6",
            "1": "6",
            "2": "3",
            "3": "7",
            "4": "0",
            "5": "4",
            "6": "6",
            "7": "-2",
            "city": "Иваново",
            "team_name": "Изолента",
            "total": "30"
        },
        {
            "0": "7",
            "1": "5",
            "2": "2",
            "3": "6",
            "4": "2",
            "5": "5",
            "6": "5",
            "7": "-2",
            "city": "Североуральск",
            "team_name": "Жан Клод Ваншот",
            "total": "30"
        },
        {
            "0": "5",
            "1": "5",
            "2": "6",
            "3": "9",
            "4": "-2",
            "5": "3",
            "6": "8",
            "7": "-4",
            "city": "Минск",
            "team_name": "Бин и Ко",
            "total": "30"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "6",
            "4": "3",
            "5": "4",
            "6": "6",
            "7": "-4",
            "city": "Иркутск",
            "team_name": "ФБР",
            "total": "30"
        },
        {
            "0": "6",
            "1": "3",
            "2": "7",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "5",
            "7": "-4",
            "city": "Челябинск",
            "team_name": "Алла Пугачёва",
            "total": "30"
        },
        {
            "0": "3",
            "1": "4",
            "2": "2",
            "3": "1",
            "4": "2",
            "5": "2",
            "6": "6",
            "7": "9",
            "city": "Ивдель",
            "team_name": "И один в поле воин",
            "total": "29"
        },
        {
            "0": "3",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "1",
            "5": "3",
            "6": "1",
            "7": "5",
            "city": "Воронеж",
            "team_name": "Рыбаки и Рыбки",
            "total": "29"
        },
        {
            "0": "2",
            "1": "4",
            "2": "2",
            "3": "5",
            "4": "2",
            "5": "3",
            "6": "7",
            "7": "4",
            "city": "Тампа",
            "team_name": "HWY 75",
            "total": "29"
        },
        {
            "0": "5",
            "1": "5",
            "2": "3",
            "3": "3",
            "4": "1",
            "5": "2",
            "6": "7",
            "7": "3",
            "city": "Североуральск",
            "team_name": "Хочу шампанского",
            "total": "29"
        },
        {
            "0": "5",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "-3",
            "5": "3",
            "6": "9",
            "7": "2",
            "city": "Омск",
            "team_name": "Без вариантов",
            "total": "29"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "2",
            "4": "4",
            "5": "1",
            "6": "5",
            "7": "2",
            "city": "Ногинск",
            "team_name": "Вся жесть впереди",
            "total": "29"
        },
        {
            "0": "2",
            "1": "6",
            "2": "3",
            "3": "7",
            "4": "3",
            "5": "1",
            "6": "5",
            "7": "2",
            "city": "Асбест",
            "team_name": "Вавилон",
            "total": "29"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "2",
            "5": "6",
            "6": "3",
            "7": "2",
            "city": "Поставы",
            "team_name": "BestиЯ",
            "total": "29"
        },
        {
            "0": "3",
            "1": "4",
            "2": "5",
            "3": "3",
            "4": "3",
            "5": "1",
            "6": "9",
            "7": "1",
            "city": "Владимир",
            "team_name": "Щасспою",
            "total": "29"
        },
        {
            "0": "5",
            "1": "4",
            "2": "5",
            "3": "2",
            "4": "3",
            "5": "2",
            "6": "7",
            "7": "1",
            "city": "Реж",
            "team_name": "Пятый элемент",
            "total": "29"
        },
        {
            "0": "4",
            "1": "5",
            "2": "3",
            "3": "9",
            "4": "-2",
            "5": "2",
            "6": "7",
            "7": "1",
            "city": "Полевской",
            "team_name": "Вынос мозга",
            "total": "29"
        },
        {
            "0": "5",
            "1": "3",
            "2": "3",
            "3": "3",
            "4": "1",
            "5": "7",
            "6": "6",
            "7": "1",
            "city": "Вольск",
            "team_name": "Незабудки",
            "total": "29"
        },
        {
            "0": "5",
            "1": "3",
            "2": "5",
            "3": "1",
            "4": "4",
            "5": "4",
            "6": "6",
            "7": "1",
            "city": "Барановичи",
            "team_name": "Нейронные связи",
            "total": "29"
        },
        {
            "0": "5",
            "1": "2",
            "2": "3",
            "3": "5",
            "4": "4",
            "5": "3",
            "6": "6",
            "7": "1",
            "city": "Нижний Новгород",
            "team_name": "Зайчатки разума",
            "total": "29"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "5",
            "4": "1",
            "5": "3",
            "6": "5",
            "7": "1",
            "city": "Слободской",
            "team_name": "Тяжёлый творожок",
            "total": "29"
        },
        {
            "0": "7",
            "1": "3",
            "2": "6",
            "3": "3",
            "4": "5",
            "5": "-1",
            "6": "5",
            "7": "1",
            "city": "Тула",
            "team_name": "Сборная Тулы по кёрлингу",
            "total": "29"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "1",
            "4": "0",
            "5": "3",
            "6": "9",
            "7": "0",
            "city": "Каменск-Уральский",
            "team_name": "Блеск",
            "total": "29"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "3",
            "4": "1",
            "5": "3",
            "6": "7",
            "7": "0",
            "city": "Берёзовский",
            "team_name": "Не супер герои",
            "total": "29"
        },
        {
            "0": "5",
            "1": "3",
            "2": "4",
            "3": "4",
            "4": "2",
            "5": "5",
            "6": "6",
            "7": "0",
            "city": "Орехово-Зуево",
            "team_name": "Пыльная радуга",
            "total": "29"
        },
        {
            "0": "4",
            "1": "7",
            "2": "6",
            "3": "2",
            "4": "1",
            "5": "3",
            "6": "6",
            "7": "0",
            "city": "Реж",
            "team_name": "Печа куча",
            "total": "29"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "3",
            "4": "1",
            "5": "5",
            "6": "5",
            "7": "0",
            "city": "Северодвинск",
            "team_name": "Таблетка «ОтУма»",
            "total": "29"
        },
        {
            "0": "4",
            "1": "6",
            "2": "3",
            "3": "5",
            "4": "2",
            "5": "4",
            "6": "6",
            "7": "-1",
            "city": "Владимир",
            "team_name": "Эффект Доплера",
            "total": "29"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "-1",
            "5": "1",
            "6": "10",
            "7": "-2",
            "city": "Тверь",
            "team_name": "Полуграции",
            "total": "29"
        },
        {
            "0": "5",
            "1": "3",
            "2": "3",
            "3": "8",
            "4": "0",
            "5": "3",
            "6": "9",
            "7": "-2",
            "city": "Челябинск",
            "team_name": "Зато красивые",
            "total": "29"
        },
        {
            "0": "5",
            "1": "5",
            "2": "3",
            "3": "3",
            "4": "4",
            "5": "4",
            "6": "8",
            "7": "-3",
            "city": "Севастополь",
            "team_name": "Шестидесятники",
            "total": "29"
        },
        {
            "0": "3",
            "1": "5",
            "2": "4",
            "3": "2",
            "4": "1",
            "5": "1",
            "6": "6",
            "7": "6",
            "city": "Новокубанск",
            "team_name": "Свои люди",
            "total": "28"
        },
        {
            "0": "4",
            "1": "5",
            "2": "4",
            "3": "3",
            "4": "-3",
            "5": "3",
            "6": "8",
            "7": "4",
            "city": "Архангельск",
            "team_name": "El Mariachis",
            "total": "28"
        },
        {
            "0": "6",
            "1": "3",
            "2": "3",
            "3": "2",
            "4": "1",
            "5": "2",
            "6": "9",
            "7": "2",
            "city": "Киров",
            "team_name": "BLACK PARTY-779",
            "total": "28"
        },
        {
            "0": "5",
            "1": "5",
            "2": "2",
            "3": "4",
            "4": "0",
            "5": "3",
            "6": "7",
            "7": "2",
            "city": "Ташкент",
            "team_name": "Ваши новые соперники",
            "total": "28"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "3",
            "4": "-1",
            "5": "4",
            "6": "6",
            "7": "2",
            "city": "Первоуральск",
            "team_name": "Интеллектуальный ОргазмЪ",
            "total": "28"
        },
        {
            "0": "6",
            "1": "5",
            "2": "2",
            "3": "3",
            "4": "1",
            "5": "3",
            "6": "6",
            "7": "2",
            "city": "Архангельск",
            "team_name": "ББ",
            "total": "28"
        },
        {
            "0": "3",
            "1": "3",
            "2": "4",
            "3": "6",
            "4": "1",
            "5": "4",
            "6": "5",
            "7": "2",
            "city": "Серпухов",
            "team_name": "Сложный вопрос",
            "total": "28"
        },
        {
            "0": "4",
            "1": "4",
            "2": "5",
            "3": "1",
            "4": "2",
            "5": "4",
            "6": "7",
            "7": "1",
            "city": "Реж",
            "team_name": "Плавали, знаем!",
            "total": "28"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "0",
            "5": "2",
            "6": "6",
            "7": "1",
            "city": "Снежинск",
            "team_name": "Брейн",
            "total": "28"
        },
        {
            "0": "5",
            "1": "3",
            "2": "5",
            "3": "3",
            "4": "3",
            "5": "3",
            "6": "5",
            "7": "1",
            "city": "Чайковский",
            "team_name": "Корица",
            "total": "28"
        },
        {
            "0": "7",
            "1": "3",
            "2": "5",
            "3": "5",
            "4": "1",
            "5": "2",
            "6": "4",
            "7": "1",
            "city": "Нижний Новгород",
            "team_name": "На грани разумного",
            "total": "28"
        },
        {
            "0": "3",
            "1": "4",
            "2": "3",
            "3": "6",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "0",
            "city": "Красногорск",
            "team_name": "Перспектива",
            "total": "28"
        },
        {
            "0": "7",
            "1": "4",
            "2": "4",
            "3": "5",
            "4": "-2",
            "5": "3",
            "6": "7",
            "7": "0",
            "city": "Ивдель",
            "team_name": "Ревмозгсовет",
            "total": "28"
        },
        {
            "0": "5",
            "1": "2",
            "2": "3",
            "3": "4",
            "4": "5",
            "5": "2",
            "6": "7",
            "7": "0",
            "city": "Владимир",
            "team_name": "Алёша Попович и змеи",
            "total": "28"
        },
        {
            "0": "1",
            "1": "5",
            "2": "6",
            "3": "5",
            "4": "3",
            "5": "2",
            "6": "6",
            "7": "0",
            "city": "Туапсе",
            "team_name": "Кипиш",
            "total": "28"
        },
        {
            "0": "5",
            "1": "7",
            "2": "4",
            "3": "3",
            "4": "1",
            "5": "2",
            "6": "6",
            "7": "0",
            "city": "Реж",
            "team_name": "ЁПРСТ",
            "total": "28"
        },
        {
            "0": "6",
            "1": "4",
            "2": "2",
            "3": "7",
            "4": "2",
            "5": "3",
            "6": "4",
            "7": "0",
            "city": "Ухта",
            "team_name": "Просто песня",
            "total": "28"
        },
        {
            "0": "2",
            "1": "6",
            "2": "4",
            "3": "7",
            "4": "2",
            "5": "4",
            "6": "3",
            "7": "0",
            "city": "Пятигорск",
            "team_name": "Чертоги разума",
            "total": "28"
        },
        {
            "0": "6",
            "1": "7",
            "2": "5",
            "3": "3",
            "4": "2",
            "5": "5",
            "6": "0",
            "7": "0",
            "city": "Тамбов",
            "team_name": "Ядра кедров",
            "total": "28"
        },
        {
            "0": "3",
            "1": "5",
            "2": "3",
            "3": "6",
            "4": "0",
            "5": "3",
            "6": "10",
            "7": "-2",
            "city": "Архангельск",
            "team_name": "Регенбогэн",
            "total": "28"
        },
        {
            "0": "6",
            "1": "3",
            "2": "4",
            "3": "4",
            "4": "4",
            "5": "5",
            "6": "4",
            "7": "-2",
            "city": "Белгород",
            "team_name": "Валенки",
            "total": "28"
        },
        {
            "0": "6",
            "1": "3",
            "2": "5",
            "3": "5",
            "4": "-1",
            "5": "6",
            "6": "7",
            "7": "-3",
            "city": "Архангельск",
            "team_name": "если чЁ мы работаем",
            "total": "28"
        },
        {
            "0": "5",
            "1": "5",
            "2": "2",
            "3": "3",
            "4": "0",
            "5": "2",
            "6": "6",
            "7": "4",
            "city": "Санкт-Петербург",
            "team_name": "DANCE",
            "total": "27"
        },
        {
            "0": "6",
            "1": "5",
            "2": "3",
            "3": "2",
            "4": "-1",
            "5": "3",
            "6": "5",
            "7": "4",
            "city": "Северодвинск",
            "team_name": "Белый круг",
            "total": "27"
        },
        {
            "0": "6",
            "1": "2",
            "2": "6",
            "3": "0",
            "4": "2",
            "5": "2",
            "6": "5",
            "7": "4",
            "city": "Москва",
            "team_name": "DrinkTeam",
            "total": "27"
        },
        {
            "0": "5",
            "1": "4",
            "2": "4",
            "3": "1",
            "4": "2",
            "5": "3",
            "6": "4",
            "7": "4",
            "city": "Красногорск",
            "team_name": "claque la porte",
            "total": "27"
        },
        {
            "0": "6",
            "1": "4",
            "2": "5",
            "3": "2",
            "4": "-3",
            "5": "3",
            "6": "8",
            "7": "2",
            "city": "Кемерово",
            "team_name": "Дебют",
            "total": "27"
        },
        {
            "0": "3",
            "1": "5",
            "2": "5",
            "3": "2",
            "4": "1",
            "5": "1",
            "6": "8",
            "7": "2",
            "city": "Пенза",
            "team_name": "Positive people's",
            "total": "27"
        },
        {
            "0": "5",
            "1": "3",
            "2": "4",
            "3": "3",
            "4": "1",
            "5": "3",
            "6": "6",
            "7": "2",
            "city": "Кирово-Чепецк",
            "team_name": "ЗарукиМураками",
            "total": "27"
        },
        {
            "0": "4",
            "1": "4",
            "2": "4",
            "3": "5",
            "4": "1",
            "5": "2",
            "6": "5",
            "7": "2",
            "city": "Оренбург",
            "team_name": "Ума палата ",
            "total": "27"
        },
        {
            "0": "3",
            "1": "4",
            "2": "5",
            "3": "6",
            "4": "1",
            "5": "2",
            "6": "4",
            "7": "2",
            "city": "Майами",
            "team_name": "RABA",
            "total": "27"
        },
        {
            "0": "2",
            "1": "3",
            "2": "3",
            "3": "6",
            "4": "2",
            "5": "3",
            "6": "7",
            "7": "1",
            "city": "Туапсе",
            "team_name": "Апельсин",
            "total": "27"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "-5",
            "5": "0",
            "6": "7",
            "7": "1",
            "city": "Екатеринбург",
            "team_name": "УМ",
            "total": "27"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "2",
            "4": "-2",
            "5": "2",
            "6": "6",
            "7": "1",
            "city": "Архангельск",
            "team_name": "Атака клоунОFF",
            "total": "27"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "3",
            "4": "2",
            "5": "2",
            "6": "5",
            "7": "1",
            "city": "Кирово-Чепецк",
            "team_name": "Mega Drive",
            "total": "27"
        },
        {
            "0": "4",
            "1": "4",
            "2": "5",
            "3": "2",
            "4": "1",
            "5": "3",
            "6": "8",
            "7": "0",
            "city": "Иваново",
            "team_name": "Люди W",
            "total": "27"
        },
        {
            "0": "4",
            "1": "3",
            "2": "3",
            "3": "6",
            "4": "1",
            "5": "3",
            "6": "7",
            "7": "0",
            "city": "Нефтеюганск",
            "team_name": "Друзья Друзя",
            "total": "27"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "4",
            "4": "0",
            "5": "2",
            "6": "7",
            "7": "0",
            "city": "Кирово-Чепецк",
            "team_name": "Мышки в наруЖке",
            "total": "27"
        },
        {
            "0": "7",
            "1": "6",
            "2": "1",
            "3": "5",
            "4": "-1",
            "5": "3",
            "6": "6",
            "7": "0",
            "city": "Кемерово",
            "team_name": "Флэш",
            "total": "27"
        },
        {
            "0": "5",
            "1": "5",
            "2": "5",
            "3": "6",
            "4": "-3",
            "5": "3",
            "6": "6",
            "7": "0",
            "city": "Полевской",
            "team_name": "ВУЗ",
            "total": "27"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "-1",
            "5": "2",
            "6": "6",
            "7": "0",
            "city": "Артемовский",
            "team_name": "Шальная извилина",
            "total": "27"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "4",
            "4": "0",
            "5": "3",
            "6": "5",
            "7": "0",
            "city": "Ухта",
            "team_name": "Родинка на подбородке",
            "total": "27"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "1",
            "5": "1",
            "6": "5",
            "7": "0",
            "city": "Нижний Новгород",
            "team_name": "7 этаж",
            "total": "27"
        },
        {
            "0": "3",
            "1": "5",
            "2": "5",
            "3": "8",
            "4": "2",
            "5": "4",
            "6": "0",
            "7": "0",
            "city": "Тамбов",
            "team_name": "THIS IS PARTA",
            "total": "27"
        },
        {
            "0": "7",
            "1": "3",
            "2": "4",
            "3": "3",
            "4": "2",
            "5": "2",
            "6": "7",
            "7": "-1",
            "city": "Санкт-Петербург",
            "team_name": "Три плюс два",
            "total": "27"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "3",
            "4": "0",
            "5": "4",
            "6": "6",
            "7": "-2",
            "city": "Брест",
            "team_name": "СколопендрА",
            "total": "27"
        },
        {
            "0": "4",
            "1": "6",
            "2": "2",
            "3": "6",
            "4": "2",
            "5": "3",
            "6": "7",
            "7": "-3",
            "city": "Санкт-Петербург",
            "team_name": "Гарда",
            "total": "27"
        },
        {
            "0": "7",
            "1": "3",
            "2": "4",
            "3": "6",
            "4": "1",
            "5": "2",
            "6": "7",
            "7": "-3",
            "city": "Екатеринбург",
            "team_name": "Лишь бы не последние",
            "total": "27"
        },
        {
            "0": "5",
            "1": "4",
            "2": "5",
            "3": "2",
            "4": "4",
            "5": "4",
            "6": "9",
            "7": "-6",
            "city": "Туапсе",
            "team_name": "Свобода мысли",
            "total": "27"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "7",
            "4": "-3",
            "5": "6",
            "6": "8",
            "7": "-6",
            "city": "Ярославль",
            "team_name": "Адольф Ильич",
            "total": "27"
        },
        {
            "0": "5",
            "1": "2",
            "2": "4",
            "3": "3",
            "4": "0",
            "5": "2",
            "6": "3",
            "7": "7",
            "city": "Поставы",
            "team_name": "Ума палата #6",
            "total": "26"
        },
        {
            "0": "4",
            "1": "4",
            "2": "4",
            "3": "1",
            "4": "-1",
            "5": "3",
            "6": "7",
            "7": "4",
            "city": "Пенза",
            "team_name": "Новая Маша",
            "total": "26"
        },
        {
            "0": "6",
            "1": "4",
            "2": "1",
            "3": "5",
            "4": "-3",
            "5": "3",
            "6": "6",
            "7": "4",
            "city": "Орск",
            "team_name": "win-win people",
            "total": "26"
        },
        {
            "0": "2",
            "1": "1",
            "2": "5",
            "3": "4",
            "4": "2",
            "5": "2",
            "6": "7",
            "7": "3",
            "city": "Тюмень",
            "team_name": "На десерт",
            "total": "26"
        },
        {
            "0": "4",
            "1": "3",
            "2": "4",
            "3": "3",
            "4": "2",
            "5": "3",
            "6": "4",
            "7": "3",
            "city": "Владимир",
            "team_name": "МаннаяКафка",
            "total": "26"
        },
        {
            "0": "5",
            "1": "4",
            "2": "2",
            "3": "3",
            "4": "2",
            "5": "3",
            "6": "5",
            "7": "2",
            "city": "Орехово-Зуево",
            "team_name": "Будь совой",
            "total": "26"
        },
        {
            "0": "5",
            "1": "3",
            "2": "3",
            "3": "4",
            "4": "1",
            "5": "3",
            "6": "5",
            "7": "2",
            "city": "Норильск",
            "team_name": "56 оттенков из серого",
            "total": "26"
        },
        {
            "0": "4",
            "1": "3",
            "2": "3",
            "3": "5",
            "4": "2",
            "5": "2",
            "6": "6",
            "7": "1",
            "city": "Пенза",
            "team_name": "Дольче Вита",
            "total": "26"
        },
        {
            "0": "6",
            "1": "3",
            "2": "1",
            "3": "7",
            "4": "1",
            "5": "1",
            "6": "6",
            "7": "1",
            "city": "Екатеринбург",
            "team_name": "Мы еще подумаем",
            "total": "26"
        },
        {
            "0": "7",
            "1": "6",
            "2": "2",
            "3": "6",
            "4": "-3",
            "5": "2",
            "6": "5",
            "7": "1",
            "city": "Асбест",
            "team_name": "ОЙ, ВСЁ",
            "total": "26"
        },
        {
            "0": "4",
            "1": "6",
            "2": "2",
            "3": "2",
            "4": "1",
            "5": "2",
            "6": "9",
            "7": "0",
            "city": "Турку",
            "team_name": "Brexit",
            "total": "26"
        },
        {
            "0": "3",
            "1": "2",
            "2": "3",
            "3": "3",
            "4": "4",
            "5": "3",
            "6": "8",
            "7": "0",
            "city": "Бишкек",
            "team_name": "БДСэМ",
            "total": "26"
        },
        {
            "0": "3",
            "1": "6",
            "2": "5",
            "3": "4",
            "4": "-3",
            "5": "3",
            "6": "8",
            "7": "0",
            "city": "Хельсинки",
            "team_name": "911",
            "total": "26"
        },
        {
            "0": "4",
            "1": "3",
            "2": "3",
            "3": "4",
            "4": "2",
            "5": "2",
            "6": "8",
            "7": "0",
            "city": "Екатеринбург",
            "team_name": "МАРС атакует!!!",
            "total": "26"
        },
        {
            "0": "7",
            "1": "3",
            "2": "6",
            "3": "2",
            "4": "-2",
            "5": "3",
            "6": "7",
            "7": "0",
            "city": "Хельсинки",
            "team_name": "Самоцветы ",
            "total": "26"
        },
        {
            "0": "7",
            "1": "2",
            "2": "2",
            "3": "5",
            "4": "1",
            "5": "3",
            "6": "6",
            "7": "0",
            "city": "Владимир",
            "team_name": "Да не по-колпаковски, а по-колоколовски",
            "total": "26"
        },
        {
            "0": "6",
            "1": "2",
            "2": "5",
            "3": "4",
            "4": "0",
            "5": "3",
            "6": "6",
            "7": "0",
            "city": "Ивдель",
            "team_name": "Мыслители Ивделя",
            "total": "26"
        },
        {
            "0": "5",
            "1": "4",
            "2": "4",
            "3": "6",
            "4": "1",
            "5": "0",
            "6": "6",
            "7": "0",
            "city": "Краснотурьинск",
            "team_name": "Мозгоеды Дубль 3",
            "total": "26"
        },
        {
            "0": "4",
            "1": "4",
            "2": "5",
            "3": "2",
            "4": "3",
            "5": "3",
            "6": "5",
            "7": "0",
            "city": "Красногорск",
            "team_name": "Родители детей Подмосковья",
            "total": "26"
        },
        {
            "0": "7",
            "1": "5",
            "2": "6",
            "3": "2",
            "4": "4",
            "5": "2",
            "6": "0",
            "7": "0",
            "city": "Тамбов",
            "team_name": "Теория струн",
            "total": "26"
        },
        {
            "0": "6",
            "1": "5",
            "2": "5",
            "3": "4",
            "4": "0",
            "5": "3",
            "6": "5",
            "7": "-2",
            "city": "Хельсинки",
            "team_name": "Добрый вечер ",
            "total": "26"
        },
        {
            "0": "6",
            "1": "7",
            "2": "4",
            "3": "1",
            "4": "3",
            "5": "2",
            "6": "5",
            "7": "-2",
            "city": "Ухта",
            "team_name": "Штаб",
            "total": "26"
        },
        {
            "0": "7",
            "1": "5",
            "2": "3",
            "3": "1",
            "4": "-1",
            "5": "3",
            "6": "3",
            "7": "4",
            "city": "Глазов",
            "team_name": "Овощное рагу",
            "total": "25"
        },
        {
            "0": "1",
            "1": "4",
            "2": "4",
            "3": "4",
            "4": "0",
            "5": "4",
            "6": "5",
            "7": "3",
            "city": "Чернигов",
            "team_name": "Bubenchyky",
            "total": "25"
        },
        {
            "0": "6",
            "1": "3",
            "2": "5",
            "3": "3",
            "4": "0",
            "5": "3",
            "6": "2",
            "7": "3",
            "city": "Киев",
            "team_name": "Дуже погані матусі",
            "total": "25"
        },
        {
            "0": "2",
            "1": "3",
            "2": "5",
            "3": "1",
            "4": "3",
            "5": "1",
            "6": "8",
            "7": "2",
            "city": "Туапсе",
            "team_name": "Узуфрукт",
            "total": "25"
        },
        {
            "0": "3",
            "1": "4",
            "2": "2",
            "3": "5",
            "4": "0",
            "5": "2",
            "6": "7",
            "7": "2",
            "city": "Пермь",
            "team_name": "Кликниклитор",
            "total": "25"
        },
        {
            "0": "5",
            "1": "2",
            "2": "5",
            "3": "4",
            "4": "-1",
            "5": "2",
            "6": "6",
            "7": "2",
            "city": "Минск",
            "team_name": "14:27",
            "total": "25"
        },
        {
            "0": "5",
            "1": "3",
            "2": "3",
            "3": "4",
            "4": "-1",
            "5": "4",
            "6": "6",
            "7": "1",
            "city": "Майами",
            "team_name": "Sunbizz",
            "total": "25"
        },
        {
            "0": "6",
            "1": "1",
            "2": "3",
            "3": "6",
            "4": "2",
            "5": "1",
            "6": "5",
            "7": "1",
            "city": "Слободской",
            "team_name": "Happy end",
            "total": "25"
        },
        {
            "0": "1",
            "1": "5",
            "2": "4",
            "3": "3",
            "4": "2",
            "5": "4",
            "6": "6",
            "7": "0",
            "city": "Балашиха",
            "team_name": "Команда ХО",
            "total": "25"
        },
        {
            "0": "4",
            "1": "3",
            "2": "3",
            "3": "4",
            "4": "1",
            "5": "4",
            "6": "6",
            "7": "0",
            "city": "Кострома",
            "team_name": "Легинсы",
            "total": "25"
        },
        {
            "0": "5",
            "1": "3",
            "2": "5",
            "3": "3",
            "4": "0",
            "5": "3",
            "6": "6",
            "7": "0",
            "city": "Берёзовский",
            "team_name": "Бригада",
            "total": "25"
        },
        {
            "0": "1",
            "1": "4",
            "2": "4",
            "3": "7",
            "4": "2",
            "5": "2",
            "6": "5",
            "7": "0",
            "city": "Турку",
            "team_name": "Хищники",
            "total": "25"
        },
        {
            "0": "7",
            "1": "2",
            "2": "4",
            "3": "4",
            "4": "0",
            "5": "3",
            "6": "7",
            "7": "-2",
            "city": "Пермь",
            "team_name": "Солёные уши",
            "total": "25"
        },
        {
            "0": "7",
            "1": "4",
            "2": "5",
            "3": "4",
            "4": "1",
            "5": "1",
            "6": "5",
            "7": "-2",
            "city": "Асбест",
            "team_name": "СлиФки",
            "total": "25"
        },
        {
            "0": "7",
            "1": "4",
            "2": "1",
            "3": "2",
            "4": "0",
            "5": "0",
            "6": "8",
            "7": "2",
            "city": "Кемерово",
            "team_name": "Мне пофиг как хочешь",
            "total": "24"
        },
        {
            "0": "6",
            "1": "4",
            "2": "3",
            "3": "4",
            "4": "-1",
            "5": "0",
            "6": "6",
            "7": "2",
            "city": "Екатеринбург",
            "team_name": "Раки в банке",
            "total": "24"
        },
        {
            "0": "4",
            "1": "4",
            "2": "1",
            "3": "5",
            "4": "-1",
            "5": "4",
            "6": "5",
            "7": "2",
            "city": "Бишкек",
            "team_name": "Ночной Дожор",
            "total": "24"
        },
        {
            "0": "3",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "-1",
            "5": "2",
            "6": "5",
            "7": "2",
            "city": "Асбест",
            "team_name": "Пионер",
            "total": "24"
        },
        {
            "0": "4",
            "1": "2",
            "2": "3",
            "3": "6",
            "4": "1",
            "5": "2",
            "6": "4",
            "7": "2",
            "city": "Новокубанск",
            "team_name": "Без вариантов",
            "total": "24"
        },
        {
            "0": "2",
            "1": "5",
            "2": "3",
            "3": "5",
            "4": "1",
            "5": "2",
            "6": "4",
            "7": "2",
            "city": "Минск",
            "team_name": "Связисты и строитель",
            "total": "24"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "2",
            "4": "-1",
            "5": "1",
            "6": "4",
            "7": "2",
            "city": "Полевской",
            "team_name": "Все ушли, а мы остались",
            "total": "24"
        },
        {
            "0": "7",
            "1": "2",
            "2": "3",
            "3": "3",
            "4": "2",
            "5": "1",
            "6": "5",
            "7": "1",
            "city": "Владимир",
            "team_name": "Пакет с пакетами",
            "total": "24"
        },
        {
            "0": "6",
            "1": "2",
            "2": "3",
            "3": "0",
            "4": "2",
            "5": "3",
            "6": "8",
            "7": "0",
            "city": "Красногорск",
            "team_name": "Снайперы Зенита",
            "total": "24"
        },
        {
            "0": "3",
            "1": "5",
            "2": "3",
            "3": "7",
            "4": "1",
            "5": "2",
            "6": "3",
            "7": "0",
            "city": "Алматы",
            "team_name": "Алкоголианцы",
            "total": "24"
        },
        {
            "0": "2",
            "1": "4",
            "2": "5",
            "3": "2",
            "4": "-2",
            "5": "2",
            "6": "12",
            "7": "-1",
            "city": "Ялта",
            "team_name": "Те самые",
            "total": "24"
        },
        {
            "0": "7",
            "1": "4",
            "2": "3",
            "3": "6",
            "4": "-3",
            "5": "2",
            "6": "6",
            "7": "-1",
            "city": "Красногорск",
            "team_name": "Мел судьбы",
            "total": "24"
        },
        {
            "0": "5",
            "1": "3",
            "2": "6",
            "3": "2",
            "4": "3",
            "5": "4",
            "6": "4",
            "7": "-3",
            "city": "Ижевск",
            "team_name": "Капибара ",
            "total": "24"
        },
        {
            "0": "6",
            "1": "4",
            "2": "6",
            "3": "5",
            "4": "-3",
            "5": "-1",
            "6": "11",
            "7": "-4",
            "city": "Тула",
            "team_name": "Фрейдзона",
            "total": "24"
        },
        {
            "0": "5",
            "1": "4",
            "2": "4",
            "3": "7",
            "4": "1",
            "5": "2",
            "6": "7",
            "7": "-6",
            "city": "Хельсинки",
            "team_name": "Злобные карлики и душевные тролли ",
            "total": "24"
        },
        {
            "0": "4",
            "1": "5",
            "2": "2",
            "3": "5",
            "4": "-1",
            "5": "2",
            "6": "2",
            "7": "4",
            "city": "Иваново",
            "team_name": "Так надо",
            "total": "23"
        },
        {
            "0": "5",
            "1": "5",
            "2": "4",
            "3": "2",
            "4": "0",
            "5": "1",
            "6": "2",
            "7": "4",
            "city": "Поставы",
            "team_name": "Спарта",
            "total": "23"
        },
        {
            "0": "3",
            "1": "2",
            "2": "4",
            "3": "2",
            "4": "-1",
            "5": "2",
            "6": "8",
            "7": "3",
            "city": "Молодечно",
            "team_name": "Серьёзные люди",
            "total": "23"
        },
        {
            "0": "4",
            "1": "5",
            "2": "4",
            "3": "1",
            "4": "-2",
            "5": "5",
            "6": "3",
            "7": "3",
            "city": "Вольск",
            "team_name": "Адреналин",
            "total": "23"
        },
        {
            "0": "3",
            "1": "3",
            "2": "3",
            "3": "4",
            "4": "1",
            "5": "2",
            "6": "5",
            "7": "2",
            "city": "Белгород",
            "team_name": "Принесенные ветром",
            "total": "23"
        },
        {
            "0": "5",
            "1": "5",
            "2": "2",
            "3": "4",
            "4": "0",
            "5": "0",
            "6": "5",
            "7": "2",
            "city": "Кемерово",
            "team_name": "В_Первые",
            "total": "23"
        },
        {
            "0": "6",
            "1": "4",
            "2": "4",
            "3": "2",
            "4": "0",
            "5": "1",
            "6": "4",
            "7": "2",
            "city": "Пермь",
            "team_name": "ПЁСдаЛИС",
            "total": "23"
        },
        {
            "0": "7",
            "1": "3",
            "2": "3",
            "3": "5",
            "4": "0",
            "5": "1",
            "6": "2",
            "7": "2",
            "city": "Орск",
            "team_name": "Ласковые монашки",
            "total": "23"
        },
        {
            "0": "5",
            "1": "4",
            "2": "3",
            "3": "2",
            "4": "2",
            "5": "4",
            "6": "5",
            "7": "-2",
            "city": "Каменск-Уральский",
            "team_name": "На позитиве)",
            "total": "23"
        },
        {
            "0": "5",
            "1": "5",
            "2": "2",
            "3": "6",
            "4": "0",
            "5": "2",
            "6": "5",
            "7": "-2",
            "city": "Курган",
            "team_name": "BEEPER",
            "total": "23"
        },
        {
            "0": "3",
            "1": "6",
            "2": "2",
            "3": "8",
            "4": "1",
            "5": "2",
            "6": "7",
            "7": "-6",
            "city": "Владимир",
            "team_name": "Констататары",
            "total": "23"
        },
        {
            "0": "4",
            "1": "5",
            "2": "3",
            "3": "8",
            "4": "-2",
            "5": "5",
            "6": "6",
            "7": "-6",
            "city": "Ставрополь",
            "team_name": "Где Оля?",
            "total": "23"
        },
        {
            "0": "1",
            "1": "4",
            "2": "5",
            "3": "1",
            "4": "1",
            "5": "1",
            "6": "7",
            "7": "2",
            "city": "Ногинск",
            "team_name": "Очень старые друзья",
            "total": "22"
        },
        {
            "0": "1",
            "1": "3",
            "2": "4",
            "3": "5",
            "4": "0",
            "5": "4",
            "6": "5",
            "7": "0",
            "city": "Бишкек",
            "team_name": "Кофевары",
            "total": "22"
        },
        {
            "0": "6",
            "1": "3",
            "2": "3",
            "3": "3",
            "4": "-2",
            "5": "4",
            "6": "5",
            "7": "0",
            "city": "Санкт-Петербург",
            "team_name": "В смысле?",
            "total": "22"
        },
        {
            "0": "4",
            "1": "4",
            "2": "4",
            "3": "3",
            "4": "-2",
            "5": "3",
            "6": "7",
            "7": "-1",
            "city": "Ташкент",
            "team_name": "Без каблуков",
            "total": "22"
        },
        {
            "0": "7",
            "1": "5",
            "2": "5",
            "3": "0",
            "4": "0",
            "5": "2",
            "6": "4",
            "7": "-1",
            "city": "Краснотурьинск",
            "team_name": "Ёжики 2.0",
            "total": "22"
        },
        {
            "0": "3",
            "1": "3",
            "2": "4",
            "3": "2",
            "4": "4",
            "5": "1",
            "6": "7",
            "7": "-2",
            "city": "Тюмень",
            "team_name": "Ещё могём",
            "total": "22"
        },
        {
            "0": "7",
            "1": "4",
            "2": "2",
            "3": "3",
            "4": "3",
            "5": "1",
            "6": "4",
            "7": "-2",
            "city": "Иркутск",
            "team_name": "Гиганты мысли",
            "total": "22"
        },
        {
            "0": "5",
            "1": "5",
            "2": "3",
            "3": "4",
            "4": "-1",
            "5": "5",
            "6": "5",
            "7": "-4",
            "city": "Химки",
            "team_name": "Блестящие",
            "total": "22"
        },
        {
            "0": "6",
            "1": "1",
            "2": "3",
            "3": "2",
            "4": "-1",
            "5": "2",
            "6": "4",
            "7": "4",
            "city": "Домодедово",
            "team_name": "Надоподумать",
            "total": "21"
        },
        {
            "0": "2",
            "1": "4",
            "2": "4",
            "3": "4",
            "4": "1",
            "5": "2",
            "6": "1",
            "7": "3",
            "city": "Поставы",
            "team_name": "Puzzle team",
            "total": "21"
        },
        {
            "0": "1",
            "1": "3",
            "2": "4",
            "3": "1",
            "4": "0",
            "5": "1",
            "6": "9",
            "7": "2",
            "city": "Варшава",
            "team_name": "ЛетоНасТупит",
            "total": "21"
        },
        {
            "0": "5",
            "1": "3",
            "2": "2",
            "3": "1",
            "4": "1",
            "5": "2",
            "6": "6",
            "7": "1",
            "city": "Екатеринбург",
            "team_name": "Девушки входят в бар",
            "total": "21"
        },
        {
            "0": "5",
            "1": "3",
            "2": "2",
            "3": "2",
            "4": "0",
            "5": "2",
            "6": "6",
            "7": "1",
            "city": "Кирово-Чепецк",
            "team_name": "Десять было…",
            "total": "21"
        },
        {
            "0": "4",
            "1": "4",
            "2": "3",
            "3": "0",
            "4": "0",
            "5": "4",
            "6": "5",
            "7": "1",
            "city": "Севастополь",
            "team_name": "Победители",
            "total": "21"
        },
        {
            "0": "5",
            "1": "5",
            "2": "3",
            "3": "4",
            "4": "-5",
            "5": "3",
            "6": "6",
            "7": "0",
            "city": "Ивдель",
            "team_name": "ПРО УИС",
            "total": "21"
        },
        {
            "0": "5",
            "1": "3",
            "2": "3",
            "3": "1",
            "4": "1",
            "5": "2",
            "6": "6",
            "7": "0",
            "city": "Владимир",
            "team_name": "Радуга",
            "total": "21"
        },
        {
            "0": "7",
            "1": "3",
            "2": "4",
            "3": "2",
            "4": "-1",
            "5": "1",
            "6": "5",
            "7": "0",
            "city": "Североуральск",
            "team_name": "Молодые и красивые",
            "total": "21"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "1",
            "4": "0",
            "5": "3",
            "6": "4",
            "7": "-2",
            "city": "Владимир",
            "team_name": "День рождения",
            "total": "21"
        },
        {
            "0": "4",
            "1": "5",
            "2": "5",
            "3": "7",
            "4": "2",
            "5": "0",
            "6": "4",
            "7": "-6",
            "city": "Воронеж",
            "team_name": "Пробили дно",
            "total": "21"
        },
        {
            "0": "5",
            "1": "5",
            "2": "4",
            "3": "4",
            "4": "0",
            "5": "2",
            "6": "9",
            "7": "-8",
            "city": "Ковров",
            "team_name": "Мозговые рыбаки",
            "total": "21"
        },
        {
            "0": "6",
            "1": "6",
            "2": "4",
            "3": "9",
            "4": "0",
            "5": "3",
            "6": "7",
            "7": "-14",
            "city": "Ташкент",
            "team_name": "ДОДАДЭД",
            "total": "21"
        },
        {
            "0": "2",
            "1": "2",
            "2": "3",
            "3": "4",
            "4": "1",
            "5": "2",
            "6": "4",
            "7": "2",
            "city": "Санкт-Петербург",
            "team_name": "Эрудиты",
            "total": "20"
        },
        {
            "0": "1",
            "1": "2",
            "2": "4",
            "3": "1",
            "4": "2",
            "5": "1",
            "6": "8",
            "7": "1",
            "city": "Артемовский",
            "team_name": "А цимес в чем?",
            "total": "20"
        },
        {
            "0": "4",
            "1": "5",
            "2": "1",
            "3": "4",
            "4": "-2",
            "5": "1",
            "6": "6",
            "7": "1",
            "city": "Екатеринбург",
            "team_name": "Боевые хомячки",
            "total": "20"
        },
        {
            "0": "4",
            "1": "2",
            "2": "3",
            "3": "5",
            "4": "-1",
            "5": "0",
            "6": "6",
            "7": "1",
            "city": "Челябинск",
            "team_name": "Качки хомячки",
            "total": "20"
        },
        {
            "0": "4",
            "1": "1",
            "2": "2",
            "3": "5",
            "4": "0",
            "5": "2",
            "6": "5",
            "7": "1",
            "city": "Югорск",
            "team_name": "Вынос мозга",
            "total": "20"
        },
        {
            "0": "1",
            "1": "3",
            "2": "3",
            "3": "5",
            "4": "0",
            "5": "3",
            "6": "4",
            "7": "1",
            "city": "Челябинск",
            "team_name": "Элен и ребята",
            "total": "20"
        },
        {
            "0": "3",
            "1": "4",
            "2": "2",
            "3": "2",
            "4": "0",
            "5": "3",
            "6": "6",
            "7": "0",
            "city": "Владимир",
            "team_name": "Совуньи",
            "total": "20"
        },
        {
            "0": "4",
            "1": "2",
            "2": "4",
            "3": "7",
            "4": "-3",
            "5": "3",
            "6": "3",
            "7": "0",
            "city": "Тель Авив",
            "team_name": "Обе две",
            "total": "20"
        },
        {
            "0": "4",
            "1": "5",
            "2": "3",
            "3": "1",
            "4": "2",
            "5": "2",
            "6": "3",
            "7": "0",
            "city": "Оренбург",
            "team_name": "Ум+няшки",
            "total": "20"
        },
        {
            "0": "3",
            "1": "4",
            "2": "2",
            "3": "3",
            "4": "0",
            "5": "3",
            "6": "7",
            "7": "-2",
            "city": "Нижняя Тура",
            "team_name": "ХЛЕБ И МАСЛО",
            "total": "20"
        },
        {
            "0": "5",
            "1": "4",
            "2": "3",
            "3": "2",
            "4": "-1",
            "5": "2",
            "6": "7",
            "7": "-2",
            "city": "Пенза",
            "team_name": "Горожанки",
            "total": "20"
        },
        {
            "0": "7",
            "1": "4",
            "2": "3",
            "3": "2",
            "4": "0",
            "5": "2",
            "6": "4",
            "7": "-2",
            "city": "Североуральск",
            "team_name": "Молодёжь",
            "total": "20"
        },
        {
            "0": "0",
            "1": "3",
            "2": "1",
            "3": "4",
            "4": "0",
            "5": "2",
            "6": "3",
            "7": "6",
            "city": "Пермь",
            "team_name": "Игра",
            "total": "19"
        },
        {
            "0": "4",
            "1": "3",
            "2": "4",
            "3": "1",
            "4": "3",
            "5": "1",
            "6": "2",
            "7": "1",
            "city": "Киев",
            "team_name": "#сукаятакизнал",
            "total": "19"
        },
        {
            "0": "1",
            "1": "1",
            "2": "3",
            "3": "6",
            "4": "1",
            "5": "2",
            "6": "5",
            "7": "0",
            "city": "Бишкек",
            "team_name": "Родственничики",
            "total": "19"
        },
        {
            "0": "7",
            "1": "5",
            "2": "4",
            "3": "2",
            "4": "-3",
            "5": "4",
            "6": "2",
            "7": "-2",
            "city": "Пятигорск",
            "team_name": "Гудвин",
            "total": "19"
        },
        {
            "0": "6",
            "1": "4",
            "2": "2",
            "3": "5",
            "4": "1",
            "5": "2",
            "6": "5",
            "7": "-6",
            "city": "Челябинск",
            "team_name": "Слабоумиеиотвага",
            "total": "19"
        },
        {
            "0": "6",
            "1": "5",
            "2": "4",
            "3": "0",
            "4": "-4",
            "5": "2",
            "6": "4",
            "7": "1",
            "city": "Чайковский",
            "team_name": "Ultraviolet",
            "total": "18"
        },
        {
            "0": "2",
            "1": "3",
            "2": "2",
            "3": "7",
            "4": "1",
            "5": "0",
            "6": "5",
            "7": "-2",
            "city": "Бишкек",
            "team_name": "Девчата",
            "total": "18"
        },
        {
            "0": "6",
            "1": "3",
            "2": "3",
            "3": "1",
            "4": "2",
            "5": "1",
            "6": "4",
            "7": "-2",
            "city": "Ижевск",
            "team_name": "КомуЗА ",
            "total": "18"
        },
        {
            "0": "2",
            "1": "2",
            "2": "2",
            "3": "8",
            "4": "1",
            "5": "2",
            "6": "3",
            "7": "-2",
            "city": "Майами",
            "team_name": "Амазония",
            "total": "18"
        },
        {
            "0": "7",
            "1": "2",
            "2": "5",
            "3": "4",
            "4": "-3",
            "5": "2",
            "6": "5",
            "7": "-4",
            "city": "Чайковский",
            "team_name": "Brainstorm",
            "total": "18"
        },
        {
            "0": "4",
            "1": "4",
            "2": "4",
            "3": "1",
            "4": "2",
            "5": "3",
            "6": "4",
            "7": "-4",
            "city": "Ковров",
            "team_name": "HOLLYWOOD",
            "total": "18"
        },
        {
            "0": "2",
            "1": "4",
            "2": "3",
            "3": "4",
            "4": "0",
            "5": "5",
            "6": "6",
            "7": "-6",
            "city": "Москва",
            "team_name": "Идем на олимп",
            "total": "18"
        },
        {
            "0": "5",
            "1": "3",
            "2": "2",
            "3": "2",
            "4": "-2",
            "5": "1",
            "6": "5",
            "7": "1",
            "city": "Екатеринбург",
            "team_name": "Уралкабель2",
            "total": "17"
        },
        {
            "0": "6",
            "1": "3",
            "2": "2",
            "3": "3",
            "4": "-2",
            "5": "1",
            "6": "4",
            "7": "0",
            "city": "Ижевск",
            "team_name": "Так вышло ",
            "total": "17"
        },
        {
            "0": "6",
            "1": "2",
            "2": "4",
            "3": "3",
            "4": "-1",
            "5": "2",
            "6": "5",
            "7": "-4",
            "city": "Асбест",
            "team_name": "Неестественный отбор",
            "total": "17"
        },
        {
            "0": "5",
            "1": "3",
            "2": "5",
            "3": "7",
            "4": "-1",
            "5": "2",
            "6": "6",
            "7": "-10",
            "city": "Омск",
            "team_name": "группа Губы",
            "total": "17"
        },
        {
            "0": "4",
            "1": "2",
            "2": "4",
            "3": "1",
            "4": "-1",
            "5": "1",
            "6": "5",
            "7": "0",
            "city": "Полевской",
            "team_name": "Внуки Анфисы",
            "total": "16"
        },
        {
            "0": "2",
            "1": "3",
            "2": "3",
            "3": "6",
            "4": "-3",
            "5": "1",
            "6": "6",
            "7": "-2",
            "city": "Брест",
            "team_name": "Два человека",
            "total": "16"
        },
        {
            "0": "3",
            "1": "3",
            "2": "4",
            "3": "1",
            "4": "3",
            "5": "1",
            "6": "7",
            "7": "-6",
            "city": "Сургут",
            "team_name": "Высшая Лига",
            "total": "16"
        },
        {
            "0": "6",
            "1": "2",
            "2": "2",
            "3": "0",
            "4": "-2",
            "5": "4",
            "6": "1",
            "7": "2",
            "city": "Пинск",
            "team_name": "2283",
            "total": "15"
        },
        {
            "0": "2",
            "1": "2",
            "2": "5",
            "3": "3",
            "4": "-2",
            "5": "0",
            "6": "5",
            "7": "0",
            "city": "Асбест",
            "team_name": "Иногда мы смелые",
            "total": "15"
        },
        {
            "0": "5",
            "1": "3",
            "2": "2",
            "3": "4",
            "4": "-2",
            "5": "2",
            "6": "1",
            "7": "0",
            "city": "Петропавловск",
            "team_name": "Надежда",
            "total": "15"
        },
        {
            "0": "3",
            "1": "3",
            "2": "5",
            "3": "0",
            "4": "-2",
            "5": "2",
            "6": "6",
            "7": "-2",
            "city": "Чайковский",
            "team_name": "А, у вас, КЛЮЁТ?",
            "total": "15"
        },
        {
            "0": "1",
            "1": "3",
            "2": "3",
            "3": "3",
            "4": "1",
            "5": "0",
            "6": "6",
            "7": "-2",
            "city": "Екатеринбург",
            "team_name": "ВсегдаПравы",
            "total": "15"
        },
        {
            "0": "4",
            "1": "2",
            "2": "2",
            "3": "2",
            "4": "2",
            "5": "3",
            "6": "2",
            "7": "-2",
            "city": "Магнитогорск",
            "team_name": "Даём свет!",
            "total": "15"
        },
        {
            "0": "7",
            "1": "3",
            "2": "1",
            "3": "0",
            "4": "-1",
            "5": "2",
            "6": "5",
            "7": "-3",
            "city": "Курган",
            "team_name": "Пятничные тюлени",
            "total": "14"
        },
        {
            "0": "3",
            "1": "4",
            "2": "3",
            "3": "5",
            "4": "-2",
            "5": "0",
            "6": "4",
            "7": "-4",
            "city": "Первоуральск",
            "team_name": "Большой театр",
            "total": "13"
        },
        {
            "0": "1",
            "1": "3",
            "2": "2",
            "3": "1",
            "4": "3",
            "5": "1",
            "6": "3",
            "7": "-2",
            "city": "Домодедово",
            "team_name": "ЧИППОЛИНО",
            "total": "12"
        },
        {
            "0": "5",
            "1": "3",
            "2": "1",
            "3": "3",
            "4": "0",
            "5": "2",
            "6": "2",
            "7": "-4",
            "city": "Ижевск",
            "team_name": "МедуЗа ",
            "total": "12"
        },
        {
            "0": "7",
            "1": "2",
            "2": "4",
            "3": "5",
            "4": "-3",
            "5": "5",
            "6": "6",
            "7": "-14",
            "city": "Ковров",
            "team_name": "Селфи",
            "total": "12"
        },
        {
            "0": "7",
            "1": "4",
            "2": "2",
            "3": "2",
            "4": "3",
            "5": "3",
            "6": "5",
            "7": "-14",
            "city": "Иркутск",
            "team_name": "Вагон Вилс",
            "total": "12"
        },
        {
            "0": "4",
            "1": "2",
            "2": "2",
            "3": "5",
            "4": "0",
            "5": "3",
            "6": "5",
            "7": "-10",
            "city": "Владимир",
            "team_name": "Комната 404",
            "total": "11"
        },
        {
            "0": "5",
            "1": "3",
            "2": "5",
            "3": "4",
            "4": "2",
            "5": "2",
            "6": "4",
            "7": "-14",
            "city": "Кропоткин",
            "team_name": "7-Я",
            "total": "11"
        },
        {
            "0": "2",
            "1": "2",
            "2": "3",
            "3": "2",
            "4": "-1",
            "5": "0",
            "6": "8",
            "7": "-6",
            "city": "Санкт-Петербург",
            "team_name": "Отпетые напарники",
            "total": "10"
        },
        {
            "0": "3",
            "1": "2",
            "2": "1",
            "3": "6",
            "4": "-1",
            "5": "0",
            "6": "3",
            "7": "-6",
            "city": "Алматы",
            "team_name": "Avrora",
            "total": "8"
        },
        {
            "0": "2",
            "1": "4",
            "2": "3",
            "3": "3",
            "4": "0",
            "5": "1",
            "6": "5",
            "7": "-14",
            "city": "Кропоткин",
            "team_name": "Рога и Копыта",
            "total": "4"
        }
    
],
      showResultModal: false,
      selectedTeam: {},
    }
  },
  mounted() {
    // axios.get('http://localhost:8080/assets/data.json')
    //   .then((response) => {
    //     this.teams = response.data.data;
    //   })
  },
  methods: {
    initModal(ev) {
      this.selectedTeam = this.teams[ev.id];
      this.toggleResultModal();
    },
    toggleResultModal() {
      this.showResultModal = !this.showResultModal
    }
  }

};
</script>

<style scoped>
.table {
  background-color: rgba(255, 255, 255, 0.7);
  border-radius: 10px;
  color: #333333;
}
.tour {
  width: 44px;
}
table {
  border-collapse: collapse;
  border-spacing: 0 10px;
}
thead {
  border-bottom: 1px solid #979797;
}
tbody {
  max-height: 550px;
  overflow-y: scroll;
   display: block;
   width:100%;
}
thead tr, tbody tr {
  display: table;
  width: 100%;
} 

th {
  text-align: start;
  padding: 5px;
  white-space: nowrap;
}
.team-name {
  width: 350px;
}
.city {
  width: 250px;
}
::-webkit-scrollbar {
    background-color:transparent;
    width:3px
}
::-webkit-scrollbar-track {
    background-color:transparent
}

::-webkit-scrollbar-thumb {
    background-color: rgba(151,151,151, .2);
    
    border-radius: 16px;
    border:5px solid transparent;
    
    transition: background-color .8s ease;
}
table:hover ::-webkit-scrollbar-thumb{
  background-color: rgba(151,151,151, .5);
  

}

@media screen and (min-width: 300px) and (max-width: 800px)  {
  .table {
    width: 300px !important; 
  }
  .team-name {
    width: 200px !important;
  }

}
</style>